"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
const core_1 = require("@smash-sdk/core");
const ListUserTeamsError_1 = require("./types/ListUserTeams/ListUserTeamsError");
const ListUserTeamsError_2 = require("./types/ListUserTeams/ListUserTeamsError");
const ListUserTeamsError_3 = require("./types/ListUserTeams/ListUserTeamsError");
const ListUserTeamsError_4 = require("./types/ListUserTeams/ListUserTeamsError");
const ListUserTeamsError_5 = require("./types/ListUserTeams/ListUserTeamsError");
const ListUserTeamsError_6 = require("./types/ListUserTeams/ListUserTeamsError");
const ListUserTeamsError_7 = require("./types/ListUserTeams/ListUserTeamsError");
const ListUserTeamsError_8 = require("./types/ListUserTeams/ListUserTeamsError");
const ListUsersError_1 = require("./types/ListUsers/ListUsersError");
const ListUsersError_2 = require("./types/ListUsers/ListUsersError");
const ListUsersError_3 = require("./types/ListUsers/ListUsersError");
const ListUsersError_4 = require("./types/ListUsers/ListUsersError");
const ListUsersError_5 = require("./types/ListUsers/ListUsersError");
const ListUsersError_6 = require("./types/ListUsers/ListUsersError");
const ListUsersSCIMError_1 = require("./types/ListUsersSCIM/ListUsersSCIMError");
const ListUsersSCIMError_2 = require("./types/ListUsersSCIM/ListUsersSCIMError");
const ListUsersSCIMError_3 = require("./types/ListUsersSCIM/ListUsersSCIMError");
const ListUsersSCIMError_4 = require("./types/ListUsersSCIM/ListUsersSCIMError");
const ListUsersSCIMError_5 = require("./types/ListUsersSCIM/ListUsersSCIMError");
const ListUsersSCIMError_6 = require("./types/ListUsersSCIM/ListUsersSCIMError");
const ListUsersSCIMError_7 = require("./types/ListUsersSCIM/ListUsersSCIMError");
const PatchGroupSCIMError_1 = require("./types/PatchGroupSCIM/PatchGroupSCIMError");
const PatchGroupSCIMError_2 = require("./types/PatchGroupSCIM/PatchGroupSCIMError");
const PatchGroupSCIMError_3 = require("./types/PatchGroupSCIM/PatchGroupSCIMError");
const PatchGroupSCIMError_4 = require("./types/PatchGroupSCIM/PatchGroupSCIMError");
const PatchGroupSCIMError_5 = require("./types/PatchGroupSCIM/PatchGroupSCIMError");
const PatchGroupSCIMError_6 = require("./types/PatchGroupSCIM/PatchGroupSCIMError");
const PatchGroupSCIMError_7 = require("./types/PatchGroupSCIM/PatchGroupSCIMError");
const PatchGroupSCIMError_8 = require("./types/PatchGroupSCIM/PatchGroupSCIMError");
const PatchUserSCIMError_1 = require("./types/PatchUserSCIM/PatchUserSCIMError");
const PatchUserSCIMError_2 = require("./types/PatchUserSCIM/PatchUserSCIMError");
const PatchUserSCIMError_3 = require("./types/PatchUserSCIM/PatchUserSCIMError");
const PatchUserSCIMError_4 = require("./types/PatchUserSCIM/PatchUserSCIMError");
const PatchUserSCIMError_5 = require("./types/PatchUserSCIM/PatchUserSCIMError");
const PatchUserSCIMError_6 = require("./types/PatchUserSCIM/PatchUserSCIMError");
const PatchUserSCIMError_7 = require("./types/PatchUserSCIM/PatchUserSCIMError");
const PatchUserSCIMError_8 = require("./types/PatchUserSCIM/PatchUserSCIMError");
const PatchUserSCIMError_9 = require("./types/PatchUserSCIM/PatchUserSCIMError");
const RenewTokenError_1 = require("./types/RenewToken/RenewTokenError");
const RenewTokenError_2 = require("./types/RenewToken/RenewTokenError");
const RenewTokenError_3 = require("./types/RenewToken/RenewTokenError");
const RenewTokenError_4 = require("./types/RenewToken/RenewTokenError");
const RenewTokenError_5 = require("./types/RenewToken/RenewTokenError");
const RenewTokenError_6 = require("./types/RenewToken/RenewTokenError");
const RenewTokenError_7 = require("./types/RenewToken/RenewTokenError");
const RenewTokenError_8 = require("./types/RenewToken/RenewTokenError");
const RenewTokenError_9 = require("./types/RenewToken/RenewTokenError");
const RenewTokenError_10 = require("./types/RenewToken/RenewTokenError");
const ResetMfaFactorError_1 = require("./types/ResetMfaFactor/ResetMfaFactorError");
const ResetMfaFactorError_2 = require("./types/ResetMfaFactor/ResetMfaFactorError");
const ResetMfaFactorError_3 = require("./types/ResetMfaFactor/ResetMfaFactorError");
const ResetMfaFactorError_4 = require("./types/ResetMfaFactor/ResetMfaFactorError");
const ResetMfaFactorError_5 = require("./types/ResetMfaFactor/ResetMfaFactorError");
const ResetMfaFactorError_6 = require("./types/ResetMfaFactor/ResetMfaFactorError");
const ResetMfaFactorError_7 = require("./types/ResetMfaFactor/ResetMfaFactorError");
const ResetMfaFactorError_8 = require("./types/ResetMfaFactor/ResetMfaFactorError");
const ResetPasswordError_1 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_2 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_3 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_4 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_5 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_6 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_7 = require("./types/ResetPassword/ResetPasswordError");
const ResetPasswordError_8 = require("./types/ResetPassword/ResetPasswordError");
const ResetUserMfaFactorError_1 = require("./types/ResetUserMfaFactor/ResetUserMfaFactorError");
const ResetUserMfaFactorError_2 = require("./types/ResetUserMfaFactor/ResetUserMfaFactorError");
const ResetUserMfaFactorError_3 = require("./types/ResetUserMfaFactor/ResetUserMfaFactorError");
const ResetUserMfaFactorError_4 = require("./types/ResetUserMfaFactor/ResetUserMfaFactorError");
const ResetUserMfaFactorError_5 = require("./types/ResetUserMfaFactor/ResetUserMfaFactorError");
const ResetUserMfaFactorError_6 = require("./types/ResetUserMfaFactor/ResetUserMfaFactorError");
const ResetUserMfaFactorError_7 = require("./types/ResetUserMfaFactor/ResetUserMfaFactorError");
const ResetUserMfaFactorError_8 = require("./types/ResetUserMfaFactor/ResetUserMfaFactorError");
const RotateKeyError_1 = require("./types/RotateKey/RotateKeyError");
const RotateKeyError_2 = require("./types/RotateKey/RotateKeyError");
const RotateKeyError_3 = require("./types/RotateKey/RotateKeyError");
const RotateKeyError_4 = require("./types/RotateKey/RotateKeyError");
const RotateKeyError_5 = require("./types/RotateKey/RotateKeyError");
const RotateKeyError_6 = require("./types/RotateKey/RotateKeyError");
const RotateKeyError_7 = require("./types/RotateKey/RotateKeyError");
const RotateUserKeyError_1 = require("./types/RotateUserKey/RotateUserKeyError");
const RotateUserKeyError_2 = require("./types/RotateUserKey/RotateUserKeyError");
const RotateUserKeyError_3 = require("./types/RotateUserKey/RotateUserKeyError");
const RotateUserKeyError_4 = require("./types/RotateUserKey/RotateUserKeyError");
const RotateUserKeyError_5 = require("./types/RotateUserKey/RotateUserKeyError");
const RotateUserKeyError_6 = require("./types/RotateUserKey/RotateUserKeyError");
const RotateUserKeyError_7 = require("./types/RotateUserKey/RotateUserKeyError");
const RotateUserKeyError_8 = require("./types/RotateUserKey/RotateUserKeyError");
const SamlSignonError_1 = require("./types/SamlSignon/SamlSignonError");
const SamlSignonError_2 = require("./types/SamlSignon/SamlSignonError");
const SamlSignonError_3 = require("./types/SamlSignon/SamlSignonError");
const SamlSignonError_4 = require("./types/SamlSignon/SamlSignonError");
const SamlSignonError_5 = require("./types/SamlSignon/SamlSignonError");
const SamlSignonError_6 = require("./types/SamlSignon/SamlSignonError");
const SamlSignonError_7 = require("./types/SamlSignon/SamlSignonError");
const SamlSignonError_8 = require("./types/SamlSignon/SamlSignonError");
const SamlSignonError_9 = require("./types/SamlSignon/SamlSignonError");
const SendOtpError_1 = require("./types/SendOtp/SendOtpError");
const SendOtpError_2 = require("./types/SendOtp/SendOtpError");
const SendOtpError_3 = require("./types/SendOtp/SendOtpError");
const SendOtpError_4 = require("./types/SendOtp/SendOtpError");
const SendOtpError_5 = require("./types/SendOtp/SendOtpError");
const SendOtpError_6 = require("./types/SendOtp/SendOtpError");
const SendOtpError_7 = require("./types/SendOtp/SendOtpError");
const SendOtpError_8 = require("./types/SendOtp/SendOtpError");
const SsoSigninError_1 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_2 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_3 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_4 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_5 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_6 = require("./types/SsoSignin/SsoSigninError");
const SsoSigninError_7 = require("./types/SsoSignin/SsoSigninError");
const UpdateAccountError_1 = require("./types/UpdateAccount/UpdateAccountError");
const UpdateAccountError_2 = require("./types/UpdateAccount/UpdateAccountError");
const UpdateAccountError_3 = require("./types/UpdateAccount/UpdateAccountError");
const UpdateAccountError_4 = require("./types/UpdateAccount/UpdateAccountError");
const UpdateAccountError_5 = require("./types/UpdateAccount/UpdateAccountError");
const UpdateAccountError_6 = require("./types/UpdateAccount/UpdateAccountError");
const UpdateAccountError_7 = require("./types/UpdateAccount/UpdateAccountError");
const UpdateAccountError_8 = require("./types/UpdateAccount/UpdateAccountError");
const UpdateAccountError_9 = require("./types/UpdateAccount/UpdateAccountError");
const UpdateGroupError_1 = require("./types/UpdateGroup/UpdateGroupError");
const UpdateGroupError_2 = require("./types/UpdateGroup/UpdateGroupError");
const UpdateGroupError_3 = require("./types/UpdateGroup/UpdateGroupError");
const UpdateGroupError_4 = require("./types/UpdateGroup/UpdateGroupError");
const UpdateGroupError_5 = require("./types/UpdateGroup/UpdateGroupError");
const UpdateGroupError_6 = require("./types/UpdateGroup/UpdateGroupError");
const UpdateGroupError_7 = require("./types/UpdateGroup/UpdateGroupError");
const UpdateGroupError_8 = require("./types/UpdateGroup/UpdateGroupError");
const UpdateGroupSCIMError_1 = require("./types/UpdateGroupSCIM/UpdateGroupSCIMError");
const UpdateGroupSCIMError_2 = require("./types/UpdateGroupSCIM/UpdateGroupSCIMError");
const UpdateGroupSCIMError_3 = require("./types/UpdateGroupSCIM/UpdateGroupSCIMError");
const UpdateGroupSCIMError_4 = require("./types/UpdateGroupSCIM/UpdateGroupSCIMError");
const UpdateGroupSCIMError_5 = require("./types/UpdateGroupSCIM/UpdateGroupSCIMError");
const UpdateGroupSCIMError_6 = require("./types/UpdateGroupSCIM/UpdateGroupSCIMError");
const UpdateGroupSCIMError_7 = require("./types/UpdateGroupSCIM/UpdateGroupSCIMError");
const UpdateGroupSCIMError_8 = require("./types/UpdateGroupSCIM/UpdateGroupSCIMError");
const UpdateManagedPolicyError_1 = require("./types/UpdateManagedPolicy/UpdateManagedPolicyError");
const UpdateManagedPolicyError_2 = require("./types/UpdateManagedPolicy/UpdateManagedPolicyError");
const UpdateManagedPolicyError_3 = require("./types/UpdateManagedPolicy/UpdateManagedPolicyError");
const UpdateManagedPolicyError_4 = require("./types/UpdateManagedPolicy/UpdateManagedPolicyError");
const UpdateManagedPolicyError_5 = require("./types/UpdateManagedPolicy/UpdateManagedPolicyError");
const UpdateManagedPolicyError_6 = require("./types/UpdateManagedPolicy/UpdateManagedPolicyError");
const UpdateManagedPolicyError_7 = require("./types/UpdateManagedPolicy/UpdateManagedPolicyError");
const UpdateManagedPolicyError_8 = require("./types/UpdateManagedPolicy/UpdateManagedPolicyError");
const UpdateMfaError_1 = require("./types/UpdateMfa/UpdateMfaError");
const UpdateMfaError_2 = require("./types/UpdateMfa/UpdateMfaError");
const UpdateMfaError_3 = require("./types/UpdateMfa/UpdateMfaError");
const UpdateMfaError_4 = require("./types/UpdateMfa/UpdateMfaError");
const UpdateMfaError_5 = require("./types/UpdateMfa/UpdateMfaError");
const UpdateMfaError_6 = require("./types/UpdateMfa/UpdateMfaError");
const UpdateMfaError_7 = require("./types/UpdateMfa/UpdateMfaError");
const UpdateMfaError_8 = require("./types/UpdateMfa/UpdateMfaError");
const UpdateMfaError_9 = require("./types/UpdateMfa/UpdateMfaError");
const UpdatePasswordError_1 = require("./types/UpdatePassword/UpdatePasswordError");
const UpdatePasswordError_2 = require("./types/UpdatePassword/UpdatePasswordError");
const UpdatePasswordError_3 = require("./types/UpdatePassword/UpdatePasswordError");
const UpdatePasswordError_4 = require("./types/UpdatePassword/UpdatePasswordError");
const UpdatePasswordError_5 = require("./types/UpdatePassword/UpdatePasswordError");
const UpdatePasswordError_6 = require("./types/UpdatePassword/UpdatePasswordError");
const UpdatePasswordError_7 = require("./types/UpdatePassword/UpdatePasswordError");
const UpdatePasswordError_8 = require("./types/UpdatePassword/UpdatePasswordError");
const UpdatePasswordError_9 = require("./types/UpdatePassword/UpdatePasswordError");
const UpdatePasswordError_10 = require("./types/UpdatePassword/UpdatePasswordError");
const UpdatePolicyError_1 = require("./types/UpdatePolicy/UpdatePolicyError");
const UpdatePolicyError_2 = require("./types/UpdatePolicy/UpdatePolicyError");
const UpdatePolicyError_3 = require("./types/UpdatePolicy/UpdatePolicyError");
const UpdatePolicyError_4 = require("./types/UpdatePolicy/UpdatePolicyError");
const UpdatePolicyError_5 = require("./types/UpdatePolicy/UpdatePolicyError");
const UpdatePolicyError_6 = require("./types/UpdatePolicy/UpdatePolicyError");
const UpdatePolicyError_7 = require("./types/UpdatePolicy/UpdatePolicyError");
const UpdatePolicyError_8 = require("./types/UpdatePolicy/UpdatePolicyError");
const UpdateProviderError_1 = require("./types/UpdateProvider/UpdateProviderError");
const UpdateProviderError_2 = require("./types/UpdateProvider/UpdateProviderError");
const UpdateProviderError_3 = require("./types/UpdateProvider/UpdateProviderError");
const UpdateProviderError_4 = require("./types/UpdateProvider/UpdateProviderError");
const UpdateProviderError_5 = require("./types/UpdateProvider/UpdateProviderError");
const UpdateProviderError_6 = require("./types/UpdateProvider/UpdateProviderError");
const UpdateProviderError_7 = require("./types/UpdateProvider/UpdateProviderError");
const UpdateProviderError_8 = require("./types/UpdateProvider/UpdateProviderError");
const UpdateProviderError_9 = require("./types/UpdateProvider/UpdateProviderError");
const UpdateRoleError_1 = require("./types/UpdateRole/UpdateRoleError");
const UpdateRoleError_2 = require("./types/UpdateRole/UpdateRoleError");
const UpdateRoleError_3 = require("./types/UpdateRole/UpdateRoleError");
const UpdateRoleError_4 = require("./types/UpdateRole/UpdateRoleError");
const UpdateRoleError_5 = require("./types/UpdateRole/UpdateRoleError");
const UpdateRoleError_6 = require("./types/UpdateRole/UpdateRoleError");
const UpdateRoleError_7 = require("./types/UpdateRole/UpdateRoleError");
const UpdateRoleError_8 = require("./types/UpdateRole/UpdateRoleError");
const UpdateSecurityError_1 = require("./types/UpdateSecurity/UpdateSecurityError");
const UpdateSecurityError_2 = require("./types/UpdateSecurity/UpdateSecurityError");
const UpdateSecurityError_3 = require("./types/UpdateSecurity/UpdateSecurityError");
const UpdateSecurityError_4 = require("./types/UpdateSecurity/UpdateSecurityError");
const UpdateSecurityError_5 = require("./types/UpdateSecurity/UpdateSecurityError");
const UpdateSecurityError_6 = require("./types/UpdateSecurity/UpdateSecurityError");
const UpdateSecurityError_7 = require("./types/UpdateSecurity/UpdateSecurityError");
const UpdateSecurityError_8 = require("./types/UpdateSecurity/UpdateSecurityError");
const UpdateTeamError_1 = require("./types/UpdateTeam/UpdateTeamError");
const UpdateTeamError_2 = require("./types/UpdateTeam/UpdateTeamError");
const UpdateTeamError_3 = require("./types/UpdateTeam/UpdateTeamError");
const UpdateTeamError_4 = require("./types/UpdateTeam/UpdateTeamError");
const UpdateTeamError_5 = require("./types/UpdateTeam/UpdateTeamError");
const UpdateTeamError_6 = require("./types/UpdateTeam/UpdateTeamError");
const UpdateTeamError_7 = require("./types/UpdateTeam/UpdateTeamError");
const UpdateTeamError_8 = require("./types/UpdateTeam/UpdateTeamError");
const UpdateTeamGroupError_1 = require("./types/UpdateTeamGroup/UpdateTeamGroupError");
const UpdateTeamGroupError_2 = require("./types/UpdateTeamGroup/UpdateTeamGroupError");
const UpdateTeamGroupError_3 = require("./types/UpdateTeamGroup/UpdateTeamGroupError");
const UpdateTeamGroupError_4 = require("./types/UpdateTeamGroup/UpdateTeamGroupError");
const UpdateTeamGroupError_5 = require("./types/UpdateTeamGroup/UpdateTeamGroupError");
const UpdateTeamGroupError_6 = require("./types/UpdateTeamGroup/UpdateTeamGroupError");
const UpdateTeamGroupError_7 = require("./types/UpdateTeamGroup/UpdateTeamGroupError");
const UpdateTeamGroupError_8 = require("./types/UpdateTeamGroup/UpdateTeamGroupError");
const UpdateTeamUserError_1 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateTeamUserError_2 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateTeamUserError_3 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateTeamUserError_4 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateTeamUserError_5 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateTeamUserError_6 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateTeamUserError_7 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateTeamUserError_8 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateTeamUserError_9 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateTeamUserError_10 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateTeamUserError_11 = require("./types/UpdateTeamUser/UpdateTeamUserError");
const UpdateUserError_1 = require("./types/UpdateUser/UpdateUserError");
const UpdateUserError_2 = require("./types/UpdateUser/UpdateUserError");
const UpdateUserError_3 = require("./types/UpdateUser/UpdateUserError");
const UpdateUserError_4 = require("./types/UpdateUser/UpdateUserError");
const UpdateUserError_5 = require("./types/UpdateUser/UpdateUserError");
const UpdateUserError_6 = require("./types/UpdateUser/UpdateUserError");
const UpdateUserError_7 = require("./types/UpdateUser/UpdateUserError");
const UpdateUserError_8 = require("./types/UpdateUser/UpdateUserError");
const UpdateUserError_9 = require("./types/UpdateUser/UpdateUserError");
const UpdateUserError_10 = require("./types/UpdateUser/UpdateUserError");
const UpdateUserMfaError_1 = require("./types/UpdateUserMfa/UpdateUserMfaError");
const UpdateUserMfaError_2 = require("./types/UpdateUserMfa/UpdateUserMfaError");
const UpdateUserMfaError_3 = require("./types/UpdateUserMfa/UpdateUserMfaError");
const UpdateUserMfaError_4 = require("./types/UpdateUserMfa/UpdateUserMfaError");
const UpdateUserMfaError_5 = require("./types/UpdateUserMfa/UpdateUserMfaError");
const UpdateUserMfaError_6 = require("./types/UpdateUserMfa/UpdateUserMfaError");
const UpdateUserMfaError_7 = require("./types/UpdateUserMfa/UpdateUserMfaError");
const UpdateUserMfaError_8 = require("./types/UpdateUserMfa/UpdateUserMfaError");
const UpdateUserMfaError_9 = require("./types/UpdateUserMfa/UpdateUserMfaError");
const UpdateUserSCIMError_1 = require("./types/UpdateUserSCIM/UpdateUserSCIMError");
const UpdateUserSCIMError_2 = require("./types/UpdateUserSCIM/UpdateUserSCIMError");
const UpdateUserSCIMError_3 = require("./types/UpdateUserSCIM/UpdateUserSCIMError");
const UpdateUserSCIMError_4 = require("./types/UpdateUserSCIM/UpdateUserSCIMError");
const UpdateUserSCIMError_5 = require("./types/UpdateUserSCIM/UpdateUserSCIMError");
const UpdateUserSCIMError_6 = require("./types/UpdateUserSCIM/UpdateUserSCIMError");
const UpdateUserSCIMError_7 = require("./types/UpdateUserSCIM/UpdateUserSCIMError");
const UpdateUserSCIMError_8 = require("./types/UpdateUserSCIM/UpdateUserSCIMError");
const UpdateUserSCIMError_9 = require("./types/UpdateUserSCIM/UpdateUserSCIMError");
const VerifyMfaFactorError_1 = require("./types/VerifyMfaFactor/VerifyMfaFactorError");
const VerifyMfaFactorError_2 = require("./types/VerifyMfaFactor/VerifyMfaFactorError");
const VerifyMfaFactorError_3 = require("./types/VerifyMfaFactor/VerifyMfaFactorError");
const VerifyMfaFactorError_4 = require("./types/VerifyMfaFactor/VerifyMfaFactorError");
const VerifyMfaFactorError_5 = require("./types/VerifyMfaFactor/VerifyMfaFactorError");
const VerifyMfaFactorError_6 = require("./types/VerifyMfaFactor/VerifyMfaFactorError");
const VerifyMfaFactorError_7 = require("./types/VerifyMfaFactor/VerifyMfaFactorError");
const VerifyMfaFactorError_8 = require("./types/VerifyMfaFactor/VerifyMfaFactorError");
const VerifyMfaFactorError_9 = require("./types/VerifyMfaFactor/VerifyMfaFactorError");
const VerifyOtpError_1 = require("./types/VerifyOtp/VerifyOtpError");
const VerifyOtpError_2 = require("./types/VerifyOtp/VerifyOtpError");
const VerifyOtpError_3 = require("./types/VerifyOtp/VerifyOtpError");
const VerifyOtpError_4 = require("./types/VerifyOtp/VerifyOtpError");
const VerifyOtpError_5 = require("./types/VerifyOtp/VerifyOtpError");
const VerifyOtpError_6 = require("./types/VerifyOtp/VerifyOtpError");
const VerifyOtpError_7 = require("./types/VerifyOtp/VerifyOtpError");
const VerifyOtpError_8 = require("./types/VerifyOtp/VerifyOtpError");
const VerifyOtpError_9 = require("./types/VerifyOtp/VerifyOtpError");
const VerifyUserMfaFactorError_1 = require("./types/VerifyUserMfaFactor/VerifyUserMfaFactorError");
const VerifyUserMfaFactorError_2 = require("./types/VerifyUserMfaFactor/VerifyUserMfaFactorError");
const VerifyUserMfaFactorError_3 = require("./types/VerifyUserMfaFactor/VerifyUserMfaFactorError");
const VerifyUserMfaFactorError_4 = require("./types/VerifyUserMfaFactor/VerifyUserMfaFactorError");
const VerifyUserMfaFactorError_5 = require("./types/VerifyUserMfaFactor/VerifyUserMfaFactorError");
const VerifyUserMfaFactorError_6 = require("./types/VerifyUserMfaFactor/VerifyUserMfaFactorError");
const VerifyUserMfaFactorError_7 = require("./types/VerifyUserMfaFactor/VerifyUserMfaFactorError");
const VerifyUserMfaFactorError_8 = require("./types/VerifyUserMfaFactor/VerifyUserMfaFactorError");
const VerifyUserMfaFactorError_9 = require("./types/VerifyUserMfaFactor/VerifyUserMfaFactorError");
const DetachTeamRoleError_1 = require("./types/DetachTeamRole/DetachTeamRoleError");
const DetachTeamRoleError_2 = require("./types/DetachTeamRole/DetachTeamRoleError");
const DetachTeamRoleError_3 = require("./types/DetachTeamRole/DetachTeamRoleError");
const DetachTeamRoleError_4 = require("./types/DetachTeamRole/DetachTeamRoleError");
const DetachTeamRoleError_5 = require("./types/DetachTeamRole/DetachTeamRoleError");
const DetachTeamRoleError_6 = require("./types/DetachTeamRole/DetachTeamRoleError");
const DetachTeamRoleError_7 = require("./types/DetachTeamRole/DetachTeamRoleError");
const DetachTeamRoleError_8 = require("./types/DetachTeamRole/DetachTeamRoleError");
const DetachTeamUserError_1 = require("./types/DetachTeamUser/DetachTeamUserError");
const DetachTeamUserError_2 = require("./types/DetachTeamUser/DetachTeamUserError");
const DetachTeamUserError_3 = require("./types/DetachTeamUser/DetachTeamUserError");
const DetachTeamUserError_4 = require("./types/DetachTeamUser/DetachTeamUserError");
const DetachTeamUserError_5 = require("./types/DetachTeamUser/DetachTeamUserError");
const DetachTeamUserError_6 = require("./types/DetachTeamUser/DetachTeamUserError");
const DetachTeamUserError_7 = require("./types/DetachTeamUser/DetachTeamUserError");
const DetachTeamUserError_8 = require("./types/DetachTeamUser/DetachTeamUserError");
const DetachTeamUserRoleError_1 = require("./types/DetachTeamUserRole/DetachTeamUserRoleError");
const DetachTeamUserRoleError_2 = require("./types/DetachTeamUserRole/DetachTeamUserRoleError");
const DetachTeamUserRoleError_3 = require("./types/DetachTeamUserRole/DetachTeamUserRoleError");
const DetachTeamUserRoleError_4 = require("./types/DetachTeamUserRole/DetachTeamUserRoleError");
const DetachTeamUserRoleError_5 = require("./types/DetachTeamUserRole/DetachTeamUserRoleError");
const DetachTeamUserRoleError_6 = require("./types/DetachTeamUserRole/DetachTeamUserRoleError");
const DetachTeamUserRoleError_7 = require("./types/DetachTeamUserRole/DetachTeamUserRoleError");
const DetachTeamUserRoleError_8 = require("./types/DetachTeamUserRole/DetachTeamUserRoleError");
const DetachUserRoleError_1 = require("./types/DetachUserRole/DetachUserRoleError");
const DetachUserRoleError_2 = require("./types/DetachUserRole/DetachUserRoleError");
const DetachUserRoleError_3 = require("./types/DetachUserRole/DetachUserRoleError");
const DetachUserRoleError_4 = require("./types/DetachUserRole/DetachUserRoleError");
const DetachUserRoleError_5 = require("./types/DetachUserRole/DetachUserRoleError");
const DetachUserRoleError_6 = require("./types/DetachUserRole/DetachUserRoleError");
const DetachUserRoleError_7 = require("./types/DetachUserRole/DetachUserRoleError");
const DetachUserRoleError_8 = require("./types/DetachUserRole/DetachUserRoleError");
const ForgotPasswordError_1 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_2 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_3 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_4 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_5 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_6 = require("./types/ForgotPassword/ForgotPasswordError");
const ForgotPasswordError_7 = require("./types/ForgotPassword/ForgotPasswordError");
const GetAccountError_1 = require("./types/GetAccount/GetAccountError");
const GetAccountError_2 = require("./types/GetAccount/GetAccountError");
const GetAccountError_3 = require("./types/GetAccount/GetAccountError");
const GetAccountError_4 = require("./types/GetAccount/GetAccountError");
const GetAccountError_5 = require("./types/GetAccount/GetAccountError");
const GetAccountError_6 = require("./types/GetAccount/GetAccountError");
const GetAccountError_7 = require("./types/GetAccount/GetAccountError");
const GetGroupError_1 = require("./types/GetGroup/GetGroupError");
const GetGroupError_2 = require("./types/GetGroup/GetGroupError");
const GetGroupError_3 = require("./types/GetGroup/GetGroupError");
const GetGroupError_4 = require("./types/GetGroup/GetGroupError");
const GetGroupError_5 = require("./types/GetGroup/GetGroupError");
const GetGroupError_6 = require("./types/GetGroup/GetGroupError");
const GetGroupError_7 = require("./types/GetGroup/GetGroupError");
const GetGroupError_8 = require("./types/GetGroup/GetGroupError");
const GetGroupSCIMError_1 = require("./types/GetGroupSCIM/GetGroupSCIMError");
const GetGroupSCIMError_2 = require("./types/GetGroupSCIM/GetGroupSCIMError");
const GetGroupSCIMError_3 = require("./types/GetGroupSCIM/GetGroupSCIMError");
const GetGroupSCIMError_4 = require("./types/GetGroupSCIM/GetGroupSCIMError");
const GetGroupSCIMError_5 = require("./types/GetGroupSCIM/GetGroupSCIMError");
const GetGroupSCIMError_6 = require("./types/GetGroupSCIM/GetGroupSCIMError");
const GetGroupSCIMError_7 = require("./types/GetGroupSCIM/GetGroupSCIMError");
const GetGroupSCIMError_8 = require("./types/GetGroupSCIM/GetGroupSCIMError");
const GetMfaError_1 = require("./types/GetMfa/GetMfaError");
const GetMfaError_2 = require("./types/GetMfa/GetMfaError");
const GetMfaError_3 = require("./types/GetMfa/GetMfaError");
const GetMfaError_4 = require("./types/GetMfa/GetMfaError");
const GetMfaError_5 = require("./types/GetMfa/GetMfaError");
const GetMfaError_6 = require("./types/GetMfa/GetMfaError");
const GetMfaError_7 = require("./types/GetMfa/GetMfaError");
const GetPolicyError_1 = require("./types/GetPolicy/GetPolicyError");
const GetPolicyError_2 = require("./types/GetPolicy/GetPolicyError");
const GetPolicyError_3 = require("./types/GetPolicy/GetPolicyError");
const GetPolicyError_4 = require("./types/GetPolicy/GetPolicyError");
const GetPolicyError_5 = require("./types/GetPolicy/GetPolicyError");
const GetPolicyError_6 = require("./types/GetPolicy/GetPolicyError");
const GetPolicyError_7 = require("./types/GetPolicy/GetPolicyError");
const GetPolicyError_8 = require("./types/GetPolicy/GetPolicyError");
const GetProviderError_1 = require("./types/GetProvider/GetProviderError");
const GetProviderError_2 = require("./types/GetProvider/GetProviderError");
const GetProviderError_3 = require("./types/GetProvider/GetProviderError");
const GetProviderError_4 = require("./types/GetProvider/GetProviderError");
const GetProviderError_5 = require("./types/GetProvider/GetProviderError");
const GetProviderError_6 = require("./types/GetProvider/GetProviderError");
const GetProviderError_7 = require("./types/GetProvider/GetProviderError");
const GetProviderError_8 = require("./types/GetProvider/GetProviderError");
const GetResourceTypesError_1 = require("./types/GetResourceTypes/GetResourceTypesError");
const GetResourceTypesError_2 = require("./types/GetResourceTypes/GetResourceTypesError");
const GetResourceTypesError_3 = require("./types/GetResourceTypes/GetResourceTypesError");
const GetResourceTypesError_4 = require("./types/GetResourceTypes/GetResourceTypesError");
const GetResourceTypesError_5 = require("./types/GetResourceTypes/GetResourceTypesError");
const GetResourceTypesError_6 = require("./types/GetResourceTypes/GetResourceTypesError");
const GetRoleError_1 = require("./types/GetRole/GetRoleError");
const GetRoleError_2 = require("./types/GetRole/GetRoleError");
const GetRoleError_3 = require("./types/GetRole/GetRoleError");
const GetRoleError_4 = require("./types/GetRole/GetRoleError");
const GetRoleError_5 = require("./types/GetRole/GetRoleError");
const GetRoleError_6 = require("./types/GetRole/GetRoleError");
const GetRoleError_7 = require("./types/GetRole/GetRoleError");
const GetRoleError_8 = require("./types/GetRole/GetRoleError");
const GetSchemasError_1 = require("./types/GetSchemas/GetSchemasError");
const GetSchemasError_2 = require("./types/GetSchemas/GetSchemasError");
const GetSchemasError_3 = require("./types/GetSchemas/GetSchemasError");
const GetSchemasError_4 = require("./types/GetSchemas/GetSchemasError");
const GetSchemasError_5 = require("./types/GetSchemas/GetSchemasError");
const GetSchemasError_6 = require("./types/GetSchemas/GetSchemasError");
const GetSecurityError_1 = require("./types/GetSecurity/GetSecurityError");
const GetSecurityError_2 = require("./types/GetSecurity/GetSecurityError");
const GetSecurityError_3 = require("./types/GetSecurity/GetSecurityError");
const GetSecurityError_4 = require("./types/GetSecurity/GetSecurityError");
const GetSecurityError_5 = require("./types/GetSecurity/GetSecurityError");
const GetSecurityError_6 = require("./types/GetSecurity/GetSecurityError");
const GetSecurityError_7 = require("./types/GetSecurity/GetSecurityError");
const GetServiceProviderConfigError_1 = require("./types/GetServiceProviderConfig/GetServiceProviderConfigError");
const GetServiceProviderConfigError_2 = require("./types/GetServiceProviderConfig/GetServiceProviderConfigError");
const GetServiceProviderConfigError_3 = require("./types/GetServiceProviderConfig/GetServiceProviderConfigError");
const GetServiceProviderConfigError_4 = require("./types/GetServiceProviderConfig/GetServiceProviderConfigError");
const GetServiceProviderConfigError_5 = require("./types/GetServiceProviderConfig/GetServiceProviderConfigError");
const GetServiceProviderConfigError_6 = require("./types/GetServiceProviderConfig/GetServiceProviderConfigError");
const GetSigninConfigurationError_1 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetSigninConfigurationError_2 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetSigninConfigurationError_3 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetSigninConfigurationError_4 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetSigninConfigurationError_5 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetSigninConfigurationError_6 = require("./types/GetSigninConfiguration/GetSigninConfigurationError");
const GetTeamError_1 = require("./types/GetTeam/GetTeamError");
const GetTeamError_2 = require("./types/GetTeam/GetTeamError");
const GetTeamError_3 = require("./types/GetTeam/GetTeamError");
const GetTeamError_4 = require("./types/GetTeam/GetTeamError");
const GetTeamError_5 = require("./types/GetTeam/GetTeamError");
const GetTeamError_6 = require("./types/GetTeam/GetTeamError");
const GetTeamError_7 = require("./types/GetTeam/GetTeamError");
const GetTeamError_8 = require("./types/GetTeam/GetTeamError");
const GetTeamGroupError_1 = require("./types/GetTeamGroup/GetTeamGroupError");
const GetTeamGroupError_2 = require("./types/GetTeamGroup/GetTeamGroupError");
const GetTeamGroupError_3 = require("./types/GetTeamGroup/GetTeamGroupError");
const GetTeamGroupError_4 = require("./types/GetTeamGroup/GetTeamGroupError");
const GetTeamGroupError_5 = require("./types/GetTeamGroup/GetTeamGroupError");
const GetTeamGroupError_6 = require("./types/GetTeamGroup/GetTeamGroupError");
const GetTeamGroupError_7 = require("./types/GetTeamGroup/GetTeamGroupError");
const GetTeamGroupError_8 = require("./types/GetTeamGroup/GetTeamGroupError");
const GetTeamUserError_1 = require("./types/GetTeamUser/GetTeamUserError");
const GetTeamUserError_2 = require("./types/GetTeamUser/GetTeamUserError");
const GetTeamUserError_3 = require("./types/GetTeamUser/GetTeamUserError");
const GetTeamUserError_4 = require("./types/GetTeamUser/GetTeamUserError");
const GetTeamUserError_5 = require("./types/GetTeamUser/GetTeamUserError");
const GetTeamUserError_6 = require("./types/GetTeamUser/GetTeamUserError");
const GetTeamUserError_7 = require("./types/GetTeamUser/GetTeamUserError");
const GetTeamUserError_8 = require("./types/GetTeamUser/GetTeamUserError");
const GetUserError_1 = require("./types/GetUser/GetUserError");
const GetUserError_2 = require("./types/GetUser/GetUserError");
const GetUserError_3 = require("./types/GetUser/GetUserError");
const GetUserError_4 = require("./types/GetUser/GetUserError");
const GetUserError_5 = require("./types/GetUser/GetUserError");
const GetUserError_6 = require("./types/GetUser/GetUserError");
const GetUserError_7 = require("./types/GetUser/GetUserError");
const GetUserError_8 = require("./types/GetUser/GetUserError");
const GetUserMfaError_1 = require("./types/GetUserMfa/GetUserMfaError");
const GetUserMfaError_2 = require("./types/GetUserMfa/GetUserMfaError");
const GetUserMfaError_3 = require("./types/GetUserMfa/GetUserMfaError");
const GetUserMfaError_4 = require("./types/GetUserMfa/GetUserMfaError");
const GetUserMfaError_5 = require("./types/GetUserMfa/GetUserMfaError");
const GetUserMfaError_6 = require("./types/GetUserMfa/GetUserMfaError");
const GetUserMfaError_7 = require("./types/GetUserMfa/GetUserMfaError");
const GetUserMfaError_8 = require("./types/GetUserMfa/GetUserMfaError");
const GetUserSCIMError_1 = require("./types/GetUserSCIM/GetUserSCIMError");
const GetUserSCIMError_2 = require("./types/GetUserSCIM/GetUserSCIMError");
const GetUserSCIMError_3 = require("./types/GetUserSCIM/GetUserSCIMError");
const GetUserSCIMError_4 = require("./types/GetUserSCIM/GetUserSCIMError");
const GetUserSCIMError_5 = require("./types/GetUserSCIM/GetUserSCIMError");
const GetUserSCIMError_6 = require("./types/GetUserSCIM/GetUserSCIMError");
const GetUserSCIMError_7 = require("./types/GetUserSCIM/GetUserSCIMError");
const GetUserSCIMError_8 = require("./types/GetUserSCIM/GetUserSCIMError");
const InviteTeamUserError_1 = require("./types/InviteTeamUser/InviteTeamUserError");
const InviteTeamUserError_2 = require("./types/InviteTeamUser/InviteTeamUserError");
const InviteTeamUserError_3 = require("./types/InviteTeamUser/InviteTeamUserError");
const InviteTeamUserError_4 = require("./types/InviteTeamUser/InviteTeamUserError");
const InviteTeamUserError_5 = require("./types/InviteTeamUser/InviteTeamUserError");
const InviteTeamUserError_6 = require("./types/InviteTeamUser/InviteTeamUserError");
const InviteTeamUserError_7 = require("./types/InviteTeamUser/InviteTeamUserError");
const InviteTeamUserError_8 = require("./types/InviteTeamUser/InviteTeamUserError");
const InviteUserError_1 = require("./types/InviteUser/InviteUserError");
const InviteUserError_2 = require("./types/InviteUser/InviteUserError");
const InviteUserError_3 = require("./types/InviteUser/InviteUserError");
const InviteUserError_4 = require("./types/InviteUser/InviteUserError");
const InviteUserError_5 = require("./types/InviteUser/InviteUserError");
const InviteUserError_6 = require("./types/InviteUser/InviteUserError");
const InviteUserError_7 = require("./types/InviteUser/InviteUserError");
const InviteUserError_8 = require("./types/InviteUser/InviteUserError");
const InviteUserError_9 = require("./types/InviteUser/InviteUserError");
const ListGroupRolesError_1 = require("./types/ListGroupRoles/ListGroupRolesError");
const ListGroupRolesError_2 = require("./types/ListGroupRoles/ListGroupRolesError");
const ListGroupRolesError_3 = require("./types/ListGroupRoles/ListGroupRolesError");
const ListGroupRolesError_4 = require("./types/ListGroupRoles/ListGroupRolesError");
const ListGroupRolesError_5 = require("./types/ListGroupRoles/ListGroupRolesError");
const ListGroupRolesError_6 = require("./types/ListGroupRoles/ListGroupRolesError");
const ListGroupRolesError_7 = require("./types/ListGroupRoles/ListGroupRolesError");
const ListGroupRolesError_8 = require("./types/ListGroupRoles/ListGroupRolesError");
const ListGroupTeamsError_1 = require("./types/ListGroupTeams/ListGroupTeamsError");
const ListGroupTeamsError_2 = require("./types/ListGroupTeams/ListGroupTeamsError");
const ListGroupTeamsError_3 = require("./types/ListGroupTeams/ListGroupTeamsError");
const ListGroupTeamsError_4 = require("./types/ListGroupTeams/ListGroupTeamsError");
const ListGroupTeamsError_5 = require("./types/ListGroupTeams/ListGroupTeamsError");
const ListGroupTeamsError_6 = require("./types/ListGroupTeams/ListGroupTeamsError");
const ListGroupTeamsError_7 = require("./types/ListGroupTeams/ListGroupTeamsError");
const ListGroupTeamsError_8 = require("./types/ListGroupTeams/ListGroupTeamsError");
const ListGroupUsersError_1 = require("./types/ListGroupUsers/ListGroupUsersError");
const ListGroupUsersError_2 = require("./types/ListGroupUsers/ListGroupUsersError");
const ListGroupUsersError_3 = require("./types/ListGroupUsers/ListGroupUsersError");
const ListGroupUsersError_4 = require("./types/ListGroupUsers/ListGroupUsersError");
const ListGroupUsersError_5 = require("./types/ListGroupUsers/ListGroupUsersError");
const ListGroupUsersError_6 = require("./types/ListGroupUsers/ListGroupUsersError");
const ListGroupUsersError_7 = require("./types/ListGroupUsers/ListGroupUsersError");
const ListGroupUsersError_8 = require("./types/ListGroupUsers/ListGroupUsersError");
const ListGroupsError_1 = require("./types/ListGroups/ListGroupsError");
const ListGroupsError_2 = require("./types/ListGroups/ListGroupsError");
const ListGroupsError_3 = require("./types/ListGroups/ListGroupsError");
const ListGroupsError_4 = require("./types/ListGroups/ListGroupsError");
const ListGroupsError_5 = require("./types/ListGroups/ListGroupsError");
const ListGroupsError_6 = require("./types/ListGroups/ListGroupsError");
const ListGroupsError_7 = require("./types/ListGroups/ListGroupsError");
const ListGroupsSCIMError_1 = require("./types/ListGroupsSCIM/ListGroupsSCIMError");
const ListGroupsSCIMError_2 = require("./types/ListGroupsSCIM/ListGroupsSCIMError");
const ListGroupsSCIMError_3 = require("./types/ListGroupsSCIM/ListGroupsSCIMError");
const ListGroupsSCIMError_4 = require("./types/ListGroupsSCIM/ListGroupsSCIMError");
const ListGroupsSCIMError_5 = require("./types/ListGroupsSCIM/ListGroupsSCIMError");
const ListGroupsSCIMError_6 = require("./types/ListGroupsSCIM/ListGroupsSCIMError");
const ListGroupsSCIMError_7 = require("./types/ListGroupsSCIM/ListGroupsSCIMError");
const ListPoliciesError_1 = require("./types/ListPolicies/ListPoliciesError");
const ListPoliciesError_2 = require("./types/ListPolicies/ListPoliciesError");
const ListPoliciesError_3 = require("./types/ListPolicies/ListPoliciesError");
const ListPoliciesError_4 = require("./types/ListPolicies/ListPoliciesError");
const ListPoliciesError_5 = require("./types/ListPolicies/ListPoliciesError");
const ListPoliciesError_6 = require("./types/ListPolicies/ListPoliciesError");
const ListProvidersError_1 = require("./types/ListProviders/ListProvidersError");
const ListProvidersError_2 = require("./types/ListProviders/ListProvidersError");
const ListProvidersError_3 = require("./types/ListProviders/ListProvidersError");
const ListProvidersError_4 = require("./types/ListProviders/ListProvidersError");
const ListProvidersError_5 = require("./types/ListProviders/ListProvidersError");
const ListProvidersError_6 = require("./types/ListProviders/ListProvidersError");
const ListRolesError_1 = require("./types/ListRoles/ListRolesError");
const ListRolesError_2 = require("./types/ListRoles/ListRolesError");
const ListRolesError_3 = require("./types/ListRoles/ListRolesError");
const ListRolesError_4 = require("./types/ListRoles/ListRolesError");
const ListRolesError_5 = require("./types/ListRoles/ListRolesError");
const ListRolesError_6 = require("./types/ListRoles/ListRolesError");
const ListTeamGroupRolesError_1 = require("./types/ListTeamGroupRoles/ListTeamGroupRolesError");
const ListTeamGroupRolesError_2 = require("./types/ListTeamGroupRoles/ListTeamGroupRolesError");
const ListTeamGroupRolesError_3 = require("./types/ListTeamGroupRoles/ListTeamGroupRolesError");
const ListTeamGroupRolesError_4 = require("./types/ListTeamGroupRoles/ListTeamGroupRolesError");
const ListTeamGroupRolesError_5 = require("./types/ListTeamGroupRoles/ListTeamGroupRolesError");
const ListTeamGroupRolesError_6 = require("./types/ListTeamGroupRoles/ListTeamGroupRolesError");
const ListTeamGroupRolesError_7 = require("./types/ListTeamGroupRoles/ListTeamGroupRolesError");
const ListTeamGroupRolesError_8 = require("./types/ListTeamGroupRoles/ListTeamGroupRolesError");
const ListTeamGroupUsersError_1 = require("./types/ListTeamGroupUsers/ListTeamGroupUsersError");
const ListTeamGroupUsersError_2 = require("./types/ListTeamGroupUsers/ListTeamGroupUsersError");
const ListTeamGroupUsersError_3 = require("./types/ListTeamGroupUsers/ListTeamGroupUsersError");
const ListTeamGroupUsersError_4 = require("./types/ListTeamGroupUsers/ListTeamGroupUsersError");
const ListTeamGroupUsersError_5 = require("./types/ListTeamGroupUsers/ListTeamGroupUsersError");
const ListTeamGroupUsersError_6 = require("./types/ListTeamGroupUsers/ListTeamGroupUsersError");
const ListTeamGroupUsersError_7 = require("./types/ListTeamGroupUsers/ListTeamGroupUsersError");
const ListTeamGroupUsersError_8 = require("./types/ListTeamGroupUsers/ListTeamGroupUsersError");
const ListTeamGroupsError_1 = require("./types/ListTeamGroups/ListTeamGroupsError");
const ListTeamGroupsError_2 = require("./types/ListTeamGroups/ListTeamGroupsError");
const ListTeamGroupsError_3 = require("./types/ListTeamGroups/ListTeamGroupsError");
const ListTeamGroupsError_4 = require("./types/ListTeamGroups/ListTeamGroupsError");
const ListTeamGroupsError_5 = require("./types/ListTeamGroups/ListTeamGroupsError");
const ListTeamGroupsError_6 = require("./types/ListTeamGroups/ListTeamGroupsError");
const ListTeamGroupsError_7 = require("./types/ListTeamGroups/ListTeamGroupsError");
const ListTeamGroupsError_8 = require("./types/ListTeamGroups/ListTeamGroupsError");
const ListTeamRolesError_1 = require("./types/ListTeamRoles/ListTeamRolesError");
const ListTeamRolesError_2 = require("./types/ListTeamRoles/ListTeamRolesError");
const ListTeamRolesError_3 = require("./types/ListTeamRoles/ListTeamRolesError");
const ListTeamRolesError_4 = require("./types/ListTeamRoles/ListTeamRolesError");
const ListTeamRolesError_5 = require("./types/ListTeamRoles/ListTeamRolesError");
const ListTeamRolesError_6 = require("./types/ListTeamRoles/ListTeamRolesError");
const ListTeamRolesError_7 = require("./types/ListTeamRoles/ListTeamRolesError");
const ListTeamRolesError_8 = require("./types/ListTeamRoles/ListTeamRolesError");
const ListTeamUserGroupsError_1 = require("./types/ListTeamUserGroups/ListTeamUserGroupsError");
const ListTeamUserGroupsError_2 = require("./types/ListTeamUserGroups/ListTeamUserGroupsError");
const ListTeamUserGroupsError_3 = require("./types/ListTeamUserGroups/ListTeamUserGroupsError");
const ListTeamUserGroupsError_4 = require("./types/ListTeamUserGroups/ListTeamUserGroupsError");
const ListTeamUserGroupsError_5 = require("./types/ListTeamUserGroups/ListTeamUserGroupsError");
const ListTeamUserGroupsError_6 = require("./types/ListTeamUserGroups/ListTeamUserGroupsError");
const ListTeamUserGroupsError_7 = require("./types/ListTeamUserGroups/ListTeamUserGroupsError");
const ListTeamUserGroupsError_8 = require("./types/ListTeamUserGroups/ListTeamUserGroupsError");
const ListTeamUserRolesError_1 = require("./types/ListTeamUserRoles/ListTeamUserRolesError");
const ListTeamUserRolesError_2 = require("./types/ListTeamUserRoles/ListTeamUserRolesError");
const ListTeamUserRolesError_3 = require("./types/ListTeamUserRoles/ListTeamUserRolesError");
const ListTeamUserRolesError_4 = require("./types/ListTeamUserRoles/ListTeamUserRolesError");
const ListTeamUserRolesError_5 = require("./types/ListTeamUserRoles/ListTeamUserRolesError");
const ListTeamUserRolesError_6 = require("./types/ListTeamUserRoles/ListTeamUserRolesError");
const ListTeamUserRolesError_7 = require("./types/ListTeamUserRoles/ListTeamUserRolesError");
const ListTeamUserRolesError_8 = require("./types/ListTeamUserRoles/ListTeamUserRolesError");
const ListTeamUsersError_1 = require("./types/ListTeamUsers/ListTeamUsersError");
const ListTeamUsersError_2 = require("./types/ListTeamUsers/ListTeamUsersError");
const ListTeamUsersError_3 = require("./types/ListTeamUsers/ListTeamUsersError");
const ListTeamUsersError_4 = require("./types/ListTeamUsers/ListTeamUsersError");
const ListTeamUsersError_5 = require("./types/ListTeamUsers/ListTeamUsersError");
const ListTeamUsersError_6 = require("./types/ListTeamUsers/ListTeamUsersError");
const ListTeamUsersError_7 = require("./types/ListTeamUsers/ListTeamUsersError");
const ListTeamUsersError_8 = require("./types/ListTeamUsers/ListTeamUsersError");
const ListTeamsError_1 = require("./types/ListTeams/ListTeamsError");
const ListTeamsError_2 = require("./types/ListTeams/ListTeamsError");
const ListTeamsError_3 = require("./types/ListTeams/ListTeamsError");
const ListTeamsError_4 = require("./types/ListTeams/ListTeamsError");
const ListTeamsError_5 = require("./types/ListTeams/ListTeamsError");
const ListTeamsError_6 = require("./types/ListTeams/ListTeamsError");
const ListUserGroupsError_1 = require("./types/ListUserGroups/ListUserGroupsError");
const ListUserGroupsError_2 = require("./types/ListUserGroups/ListUserGroupsError");
const ListUserGroupsError_3 = require("./types/ListUserGroups/ListUserGroupsError");
const ListUserGroupsError_4 = require("./types/ListUserGroups/ListUserGroupsError");
const ListUserGroupsError_5 = require("./types/ListUserGroups/ListUserGroupsError");
const ListUserGroupsError_6 = require("./types/ListUserGroups/ListUserGroupsError");
const ListUserGroupsError_7 = require("./types/ListUserGroups/ListUserGroupsError");
const ListUserGroupsError_8 = require("./types/ListUserGroups/ListUserGroupsError");
const ListUserGroupsRolesError_1 = require("./types/ListUserGroupsRoles/ListUserGroupsRolesError");
const ListUserGroupsRolesError_2 = require("./types/ListUserGroupsRoles/ListUserGroupsRolesError");
const ListUserGroupsRolesError_3 = require("./types/ListUserGroupsRoles/ListUserGroupsRolesError");
const ListUserGroupsRolesError_4 = require("./types/ListUserGroupsRoles/ListUserGroupsRolesError");
const ListUserGroupsRolesError_5 = require("./types/ListUserGroupsRoles/ListUserGroupsRolesError");
const ListUserGroupsRolesError_6 = require("./types/ListUserGroupsRoles/ListUserGroupsRolesError");
const ListUserGroupsRolesError_7 = require("./types/ListUserGroupsRoles/ListUserGroupsRolesError");
const ListUserGroupsRolesError_8 = require("./types/ListUserGroupsRoles/ListUserGroupsRolesError");
const ListUserGroupsTeamsError_1 = require("./types/ListUserGroupsTeams/ListUserGroupsTeamsError");
const ListUserGroupsTeamsError_2 = require("./types/ListUserGroupsTeams/ListUserGroupsTeamsError");
const ListUserGroupsTeamsError_3 = require("./types/ListUserGroupsTeams/ListUserGroupsTeamsError");
const ListUserGroupsTeamsError_4 = require("./types/ListUserGroupsTeams/ListUserGroupsTeamsError");
const ListUserGroupsTeamsError_5 = require("./types/ListUserGroupsTeams/ListUserGroupsTeamsError");
const ListUserGroupsTeamsError_6 = require("./types/ListUserGroupsTeams/ListUserGroupsTeamsError");
const ListUserGroupsTeamsError_7 = require("./types/ListUserGroupsTeams/ListUserGroupsTeamsError");
const ListUserGroupsTeamsError_8 = require("./types/ListUserGroupsTeams/ListUserGroupsTeamsError");
const ListUserRolesError_1 = require("./types/ListUserRoles/ListUserRolesError");
const ListUserRolesError_2 = require("./types/ListUserRoles/ListUserRolesError");
const ListUserRolesError_3 = require("./types/ListUserRoles/ListUserRolesError");
const ListUserRolesError_4 = require("./types/ListUserRoles/ListUserRolesError");
const ListUserRolesError_5 = require("./types/ListUserRoles/ListUserRolesError");
const ListUserRolesError_6 = require("./types/ListUserRoles/ListUserRolesError");
const ListUserRolesError_7 = require("./types/ListUserRoles/ListUserRolesError");
const ListUserRolesError_8 = require("./types/ListUserRoles/ListUserRolesError");
const AcceptInvitationError_1 = require("./types/AcceptInvitation/AcceptInvitationError");
const AcceptInvitationError_2 = require("./types/AcceptInvitation/AcceptInvitationError");
const AcceptInvitationError_3 = require("./types/AcceptInvitation/AcceptInvitationError");
const AcceptInvitationError_4 = require("./types/AcceptInvitation/AcceptInvitationError");
const AcceptInvitationError_5 = require("./types/AcceptInvitation/AcceptInvitationError");
const AcceptInvitationError_6 = require("./types/AcceptInvitation/AcceptInvitationError");
const AcceptInvitationError_7 = require("./types/AcceptInvitation/AcceptInvitationError");
const AcceptInvitationError_8 = require("./types/AcceptInvitation/AcceptInvitationError");
const AcceptInvitationError_9 = require("./types/AcceptInvitation/AcceptInvitationError");
const AcceptUserInvitationError_1 = require("./types/AcceptUserInvitation/AcceptUserInvitationError");
const AcceptUserInvitationError_2 = require("./types/AcceptUserInvitation/AcceptUserInvitationError");
const AcceptUserInvitationError_3 = require("./types/AcceptUserInvitation/AcceptUserInvitationError");
const AcceptUserInvitationError_4 = require("./types/AcceptUserInvitation/AcceptUserInvitationError");
const AcceptUserInvitationError_5 = require("./types/AcceptUserInvitation/AcceptUserInvitationError");
const AcceptUserInvitationError_6 = require("./types/AcceptUserInvitation/AcceptUserInvitationError");
const AcceptUserInvitationError_7 = require("./types/AcceptUserInvitation/AcceptUserInvitationError");
const AcceptUserInvitationError_8 = require("./types/AcceptUserInvitation/AcceptUserInvitationError");
const AttachGroupRoleError_1 = require("./types/AttachGroupRole/AttachGroupRoleError");
const AttachGroupRoleError_2 = require("./types/AttachGroupRole/AttachGroupRoleError");
const AttachGroupRoleError_3 = require("./types/AttachGroupRole/AttachGroupRoleError");
const AttachGroupRoleError_4 = require("./types/AttachGroupRole/AttachGroupRoleError");
const AttachGroupRoleError_5 = require("./types/AttachGroupRole/AttachGroupRoleError");
const AttachGroupRoleError_6 = require("./types/AttachGroupRole/AttachGroupRoleError");
const AttachGroupRoleError_7 = require("./types/AttachGroupRole/AttachGroupRoleError");
const AttachGroupRoleError_8 = require("./types/AttachGroupRole/AttachGroupRoleError");
const AttachGroupRoleError_9 = require("./types/AttachGroupRole/AttachGroupRoleError");
const AttachGroupUserError_1 = require("./types/AttachGroupUser/AttachGroupUserError");
const AttachGroupUserError_2 = require("./types/AttachGroupUser/AttachGroupUserError");
const AttachGroupUserError_3 = require("./types/AttachGroupUser/AttachGroupUserError");
const AttachGroupUserError_4 = require("./types/AttachGroupUser/AttachGroupUserError");
const AttachGroupUserError_5 = require("./types/AttachGroupUser/AttachGroupUserError");
const AttachGroupUserError_6 = require("./types/AttachGroupUser/AttachGroupUserError");
const AttachGroupUserError_7 = require("./types/AttachGroupUser/AttachGroupUserError");
const AttachGroupUserError_8 = require("./types/AttachGroupUser/AttachGroupUserError");
const AttachGroupUserError_9 = require("./types/AttachGroupUser/AttachGroupUserError");
const AttachRolePolicyError_1 = require("./types/AttachRolePolicy/AttachRolePolicyError");
const AttachRolePolicyError_2 = require("./types/AttachRolePolicy/AttachRolePolicyError");
const AttachRolePolicyError_3 = require("./types/AttachRolePolicy/AttachRolePolicyError");
const AttachRolePolicyError_4 = require("./types/AttachRolePolicy/AttachRolePolicyError");
const AttachRolePolicyError_5 = require("./types/AttachRolePolicy/AttachRolePolicyError");
const AttachRolePolicyError_6 = require("./types/AttachRolePolicy/AttachRolePolicyError");
const AttachRolePolicyError_7 = require("./types/AttachRolePolicy/AttachRolePolicyError");
const AttachRolePolicyError_8 = require("./types/AttachRolePolicy/AttachRolePolicyError");
const AttachRolePolicyError_9 = require("./types/AttachRolePolicy/AttachRolePolicyError");
const AttachTeamGroupError_1 = require("./types/AttachTeamGroup/AttachTeamGroupError");
const AttachTeamGroupError_2 = require("./types/AttachTeamGroup/AttachTeamGroupError");
const AttachTeamGroupError_3 = require("./types/AttachTeamGroup/AttachTeamGroupError");
const AttachTeamGroupError_4 = require("./types/AttachTeamGroup/AttachTeamGroupError");
const AttachTeamGroupError_5 = require("./types/AttachTeamGroup/AttachTeamGroupError");
const AttachTeamGroupError_6 = require("./types/AttachTeamGroup/AttachTeamGroupError");
const AttachTeamGroupError_7 = require("./types/AttachTeamGroup/AttachTeamGroupError");
const AttachTeamGroupError_8 = require("./types/AttachTeamGroup/AttachTeamGroupError");
const AttachTeamGroupError_9 = require("./types/AttachTeamGroup/AttachTeamGroupError");
const AttachTeamGroupRoleError_1 = require("./types/AttachTeamGroupRole/AttachTeamGroupRoleError");
const AttachTeamGroupRoleError_2 = require("./types/AttachTeamGroupRole/AttachTeamGroupRoleError");
const AttachTeamGroupRoleError_3 = require("./types/AttachTeamGroupRole/AttachTeamGroupRoleError");
const AttachTeamGroupRoleError_4 = require("./types/AttachTeamGroupRole/AttachTeamGroupRoleError");
const AttachTeamGroupRoleError_5 = require("./types/AttachTeamGroupRole/AttachTeamGroupRoleError");
const AttachTeamGroupRoleError_6 = require("./types/AttachTeamGroupRole/AttachTeamGroupRoleError");
const AttachTeamGroupRoleError_7 = require("./types/AttachTeamGroupRole/AttachTeamGroupRoleError");
const AttachTeamGroupRoleError_8 = require("./types/AttachTeamGroupRole/AttachTeamGroupRoleError");
const AttachTeamGroupRoleError_9 = require("./types/AttachTeamGroupRole/AttachTeamGroupRoleError");
const AttachTeamGroupUserError_1 = require("./types/AttachTeamGroupUser/AttachTeamGroupUserError");
const AttachTeamGroupUserError_2 = require("./types/AttachTeamGroupUser/AttachTeamGroupUserError");
const AttachTeamGroupUserError_3 = require("./types/AttachTeamGroupUser/AttachTeamGroupUserError");
const AttachTeamGroupUserError_4 = require("./types/AttachTeamGroupUser/AttachTeamGroupUserError");
const AttachTeamGroupUserError_5 = require("./types/AttachTeamGroupUser/AttachTeamGroupUserError");
const AttachTeamGroupUserError_6 = require("./types/AttachTeamGroupUser/AttachTeamGroupUserError");
const AttachTeamGroupUserError_7 = require("./types/AttachTeamGroupUser/AttachTeamGroupUserError");
const AttachTeamGroupUserError_8 = require("./types/AttachTeamGroupUser/AttachTeamGroupUserError");
const AttachTeamGroupUserError_9 = require("./types/AttachTeamGroupUser/AttachTeamGroupUserError");
const AttachTeamRoleError_1 = require("./types/AttachTeamRole/AttachTeamRoleError");
const AttachTeamRoleError_2 = require("./types/AttachTeamRole/AttachTeamRoleError");
const AttachTeamRoleError_3 = require("./types/AttachTeamRole/AttachTeamRoleError");
const AttachTeamRoleError_4 = require("./types/AttachTeamRole/AttachTeamRoleError");
const AttachTeamRoleError_5 = require("./types/AttachTeamRole/AttachTeamRoleError");
const AttachTeamRoleError_6 = require("./types/AttachTeamRole/AttachTeamRoleError");
const AttachTeamRoleError_7 = require("./types/AttachTeamRole/AttachTeamRoleError");
const AttachTeamRoleError_8 = require("./types/AttachTeamRole/AttachTeamRoleError");
const AttachTeamRoleError_9 = require("./types/AttachTeamRole/AttachTeamRoleError");
const AttachTeamUserError_1 = require("./types/AttachTeamUser/AttachTeamUserError");
const AttachTeamUserError_2 = require("./types/AttachTeamUser/AttachTeamUserError");
const AttachTeamUserError_3 = require("./types/AttachTeamUser/AttachTeamUserError");
const AttachTeamUserError_4 = require("./types/AttachTeamUser/AttachTeamUserError");
const AttachTeamUserError_5 = require("./types/AttachTeamUser/AttachTeamUserError");
const AttachTeamUserError_6 = require("./types/AttachTeamUser/AttachTeamUserError");
const AttachTeamUserError_7 = require("./types/AttachTeamUser/AttachTeamUserError");
const AttachTeamUserError_8 = require("./types/AttachTeamUser/AttachTeamUserError");
const AttachTeamUserError_9 = require("./types/AttachTeamUser/AttachTeamUserError");
const AttachTeamUserRoleError_1 = require("./types/AttachTeamUserRole/AttachTeamUserRoleError");
const AttachTeamUserRoleError_2 = require("./types/AttachTeamUserRole/AttachTeamUserRoleError");
const AttachTeamUserRoleError_3 = require("./types/AttachTeamUserRole/AttachTeamUserRoleError");
const AttachTeamUserRoleError_4 = require("./types/AttachTeamUserRole/AttachTeamUserRoleError");
const AttachTeamUserRoleError_5 = require("./types/AttachTeamUserRole/AttachTeamUserRoleError");
const AttachTeamUserRoleError_6 = require("./types/AttachTeamUserRole/AttachTeamUserRoleError");
const AttachTeamUserRoleError_7 = require("./types/AttachTeamUserRole/AttachTeamUserRoleError");
const AttachTeamUserRoleError_8 = require("./types/AttachTeamUserRole/AttachTeamUserRoleError");
const AttachTeamUserRoleError_9 = require("./types/AttachTeamUserRole/AttachTeamUserRoleError");
const AttachUserRoleError_1 = require("./types/AttachUserRole/AttachUserRoleError");
const AttachUserRoleError_2 = require("./types/AttachUserRole/AttachUserRoleError");
const AttachUserRoleError_3 = require("./types/AttachUserRole/AttachUserRoleError");
const AttachUserRoleError_4 = require("./types/AttachUserRole/AttachUserRoleError");
const AttachUserRoleError_5 = require("./types/AttachUserRole/AttachUserRoleError");
const AttachUserRoleError_6 = require("./types/AttachUserRole/AttachUserRoleError");
const AttachUserRoleError_7 = require("./types/AttachUserRole/AttachUserRoleError");
const AttachUserRoleError_8 = require("./types/AttachUserRole/AttachUserRoleError");
const AttachUserRoleError_9 = require("./types/AttachUserRole/AttachUserRoleError");
const ChangePasswordError_1 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_2 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_3 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_4 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_5 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_6 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_7 = require("./types/ChangePassword/ChangePasswordError");
const ChangePasswordError_8 = require("./types/ChangePassword/ChangePasswordError");
const CreateAccountError_1 = require("./types/CreateAccount/CreateAccountError");
const CreateAccountError_2 = require("./types/CreateAccount/CreateAccountError");
const CreateAccountError_3 = require("./types/CreateAccount/CreateAccountError");
const CreateAccountError_4 = require("./types/CreateAccount/CreateAccountError");
const CreateAccountError_5 = require("./types/CreateAccount/CreateAccountError");
const CreateAccountError_6 = require("./types/CreateAccount/CreateAccountError");
const CreateAccountError_7 = require("./types/CreateAccount/CreateAccountError");
const CreateGroupError_1 = require("./types/CreateGroup/CreateGroupError");
const CreateGroupError_2 = require("./types/CreateGroup/CreateGroupError");
const CreateGroupError_3 = require("./types/CreateGroup/CreateGroupError");
const CreateGroupError_4 = require("./types/CreateGroup/CreateGroupError");
const CreateGroupError_5 = require("./types/CreateGroup/CreateGroupError");
const CreateGroupError_6 = require("./types/CreateGroup/CreateGroupError");
const CreateGroupError_7 = require("./types/CreateGroup/CreateGroupError");
const CreateGroupError_8 = require("./types/CreateGroup/CreateGroupError");
const CreateGroupSCIMError_1 = require("./types/CreateGroupSCIM/CreateGroupSCIMError");
const CreateGroupSCIMError_2 = require("./types/CreateGroupSCIM/CreateGroupSCIMError");
const CreateGroupSCIMError_3 = require("./types/CreateGroupSCIM/CreateGroupSCIMError");
const CreateGroupSCIMError_4 = require("./types/CreateGroupSCIM/CreateGroupSCIMError");
const CreateGroupSCIMError_5 = require("./types/CreateGroupSCIM/CreateGroupSCIMError");
const CreateGroupSCIMError_6 = require("./types/CreateGroupSCIM/CreateGroupSCIMError");
const CreateGroupSCIMError_7 = require("./types/CreateGroupSCIM/CreateGroupSCIMError");
const CreateGroupSCIMError_8 = require("./types/CreateGroupSCIM/CreateGroupSCIMError");
const CreateGroupSCIMError_9 = require("./types/CreateGroupSCIM/CreateGroupSCIMError");
const CreateMfaFactorSecretError_1 = require("./types/CreateMfaFactorSecret/CreateMfaFactorSecretError");
const CreateMfaFactorSecretError_2 = require("./types/CreateMfaFactorSecret/CreateMfaFactorSecretError");
const CreateMfaFactorSecretError_3 = require("./types/CreateMfaFactorSecret/CreateMfaFactorSecretError");
const CreateMfaFactorSecretError_4 = require("./types/CreateMfaFactorSecret/CreateMfaFactorSecretError");
const CreateMfaFactorSecretError_5 = require("./types/CreateMfaFactorSecret/CreateMfaFactorSecretError");
const CreateMfaFactorSecretError_6 = require("./types/CreateMfaFactorSecret/CreateMfaFactorSecretError");
const CreateMfaFactorSecretError_7 = require("./types/CreateMfaFactorSecret/CreateMfaFactorSecretError");
const CreateMfaFactorSecretError_8 = require("./types/CreateMfaFactorSecret/CreateMfaFactorSecretError");
const CreatePolicyError_1 = require("./types/CreatePolicy/CreatePolicyError");
const CreatePolicyError_2 = require("./types/CreatePolicy/CreatePolicyError");
const CreatePolicyError_3 = require("./types/CreatePolicy/CreatePolicyError");
const CreatePolicyError_4 = require("./types/CreatePolicy/CreatePolicyError");
const CreatePolicyError_5 = require("./types/CreatePolicy/CreatePolicyError");
const CreatePolicyError_6 = require("./types/CreatePolicy/CreatePolicyError");
const CreatePolicyError_7 = require("./types/CreatePolicy/CreatePolicyError");
const CreatePolicyError_8 = require("./types/CreatePolicy/CreatePolicyError");
const CreateProviderError_1 = require("./types/CreateProvider/CreateProviderError");
const CreateProviderError_2 = require("./types/CreateProvider/CreateProviderError");
const CreateProviderError_3 = require("./types/CreateProvider/CreateProviderError");
const CreateProviderError_4 = require("./types/CreateProvider/CreateProviderError");
const CreateProviderError_5 = require("./types/CreateProvider/CreateProviderError");
const CreateProviderError_6 = require("./types/CreateProvider/CreateProviderError");
const CreateProviderError_7 = require("./types/CreateProvider/CreateProviderError");
const CreateProviderError_8 = require("./types/CreateProvider/CreateProviderError");
const CreateProviderError_9 = require("./types/CreateProvider/CreateProviderError");
const CreateRoleError_1 = require("./types/CreateRole/CreateRoleError");
const CreateRoleError_2 = require("./types/CreateRole/CreateRoleError");
const CreateRoleError_3 = require("./types/CreateRole/CreateRoleError");
const CreateRoleError_4 = require("./types/CreateRole/CreateRoleError");
const CreateRoleError_5 = require("./types/CreateRole/CreateRoleError");
const CreateRoleError_6 = require("./types/CreateRole/CreateRoleError");
const CreateRoleError_7 = require("./types/CreateRole/CreateRoleError");
const CreateRoleError_8 = require("./types/CreateRole/CreateRoleError");
const CreateTeamError_1 = require("./types/CreateTeam/CreateTeamError");
const CreateTeamError_2 = require("./types/CreateTeam/CreateTeamError");
const CreateTeamError_3 = require("./types/CreateTeam/CreateTeamError");
const CreateTeamError_4 = require("./types/CreateTeam/CreateTeamError");
const CreateTeamError_5 = require("./types/CreateTeam/CreateTeamError");
const CreateTeamError_6 = require("./types/CreateTeam/CreateTeamError");
const CreateTeamError_7 = require("./types/CreateTeam/CreateTeamError");
const CreateTeamError_8 = require("./types/CreateTeam/CreateTeamError");
const CreateTokenError_1 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_2 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_3 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_4 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_5 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_6 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_7 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_8 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_9 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_10 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_11 = require("./types/CreateToken/CreateTokenError");
const CreateTokenError_12 = require("./types/CreateToken/CreateTokenError");
const CreateUserError_1 = require("./types/CreateUser/CreateUserError");
const CreateUserError_2 = require("./types/CreateUser/CreateUserError");
const CreateUserError_3 = require("./types/CreateUser/CreateUserError");
const CreateUserError_4 = require("./types/CreateUser/CreateUserError");
const CreateUserError_5 = require("./types/CreateUser/CreateUserError");
const CreateUserError_6 = require("./types/CreateUser/CreateUserError");
const CreateUserError_7 = require("./types/CreateUser/CreateUserError");
const CreateUserError_8 = require("./types/CreateUser/CreateUserError");
const CreateUserError_9 = require("./types/CreateUser/CreateUserError");
const CreateUserMfaFactorSecretError_1 = require("./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError");
const CreateUserMfaFactorSecretError_2 = require("./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError");
const CreateUserMfaFactorSecretError_3 = require("./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError");
const CreateUserMfaFactorSecretError_4 = require("./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError");
const CreateUserMfaFactorSecretError_5 = require("./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError");
const CreateUserMfaFactorSecretError_6 = require("./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError");
const CreateUserMfaFactorSecretError_7 = require("./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError");
const CreateUserMfaFactorSecretError_8 = require("./types/CreateUserMfaFactorSecret/CreateUserMfaFactorSecretError");
const CreateUserSCIMError_1 = require("./types/CreateUserSCIM/CreateUserSCIMError");
const CreateUserSCIMError_2 = require("./types/CreateUserSCIM/CreateUserSCIMError");
const CreateUserSCIMError_3 = require("./types/CreateUserSCIM/CreateUserSCIMError");
const CreateUserSCIMError_4 = require("./types/CreateUserSCIM/CreateUserSCIMError");
const CreateUserSCIMError_5 = require("./types/CreateUserSCIM/CreateUserSCIMError");
const CreateUserSCIMError_6 = require("./types/CreateUserSCIM/CreateUserSCIMError");
const CreateUserSCIMError_7 = require("./types/CreateUserSCIM/CreateUserSCIMError");
const CreateUserSCIMError_8 = require("./types/CreateUserSCIM/CreateUserSCIMError");
const CreateUserSCIMError_9 = require("./types/CreateUserSCIM/CreateUserSCIMError");
const CreateUserTokenError_1 = require("./types/CreateUserToken/CreateUserTokenError");
const CreateUserTokenError_2 = require("./types/CreateUserToken/CreateUserTokenError");
const CreateUserTokenError_3 = require("./types/CreateUserToken/CreateUserTokenError");
const CreateUserTokenError_4 = require("./types/CreateUserToken/CreateUserTokenError");
const CreateUserTokenError_5 = require("./types/CreateUserToken/CreateUserTokenError");
const CreateUserTokenError_6 = require("./types/CreateUserToken/CreateUserTokenError");
const CreateUserTokenError_7 = require("./types/CreateUserToken/CreateUserTokenError");
const CreateUserTokenError_8 = require("./types/CreateUserToken/CreateUserTokenError");
const CreateUserTokenError_9 = require("./types/CreateUserToken/CreateUserTokenError");
const CreateUserTokenError_10 = require("./types/CreateUserToken/CreateUserTokenError");
const DeleteAccountError_1 = require("./types/DeleteAccount/DeleteAccountError");
const DeleteAccountError_2 = require("./types/DeleteAccount/DeleteAccountError");
const DeleteAccountError_3 = require("./types/DeleteAccount/DeleteAccountError");
const DeleteAccountError_4 = require("./types/DeleteAccount/DeleteAccountError");
const DeleteAccountError_5 = require("./types/DeleteAccount/DeleteAccountError");
const DeleteAccountError_6 = require("./types/DeleteAccount/DeleteAccountError");
const DeleteAccountError_7 = require("./types/DeleteAccount/DeleteAccountError");
const DeleteGroupError_1 = require("./types/DeleteGroup/DeleteGroupError");
const DeleteGroupError_2 = require("./types/DeleteGroup/DeleteGroupError");
const DeleteGroupError_3 = require("./types/DeleteGroup/DeleteGroupError");
const DeleteGroupError_4 = require("./types/DeleteGroup/DeleteGroupError");
const DeleteGroupError_5 = require("./types/DeleteGroup/DeleteGroupError");
const DeleteGroupError_6 = require("./types/DeleteGroup/DeleteGroupError");
const DeleteGroupError_7 = require("./types/DeleteGroup/DeleteGroupError");
const DeleteGroupError_8 = require("./types/DeleteGroup/DeleteGroupError");
const DeleteGroupSCIMError_1 = require("./types/DeleteGroupSCIM/DeleteGroupSCIMError");
const DeleteGroupSCIMError_2 = require("./types/DeleteGroupSCIM/DeleteGroupSCIMError");
const DeleteGroupSCIMError_3 = require("./types/DeleteGroupSCIM/DeleteGroupSCIMError");
const DeleteGroupSCIMError_4 = require("./types/DeleteGroupSCIM/DeleteGroupSCIMError");
const DeleteGroupSCIMError_5 = require("./types/DeleteGroupSCIM/DeleteGroupSCIMError");
const DeleteGroupSCIMError_6 = require("./types/DeleteGroupSCIM/DeleteGroupSCIMError");
const DeleteGroupSCIMError_7 = require("./types/DeleteGroupSCIM/DeleteGroupSCIMError");
const DeleteGroupSCIMError_8 = require("./types/DeleteGroupSCIM/DeleteGroupSCIMError");
const DeletePolicyError_1 = require("./types/DeletePolicy/DeletePolicyError");
const DeletePolicyError_2 = require("./types/DeletePolicy/DeletePolicyError");
const DeletePolicyError_3 = require("./types/DeletePolicy/DeletePolicyError");
const DeletePolicyError_4 = require("./types/DeletePolicy/DeletePolicyError");
const DeletePolicyError_5 = require("./types/DeletePolicy/DeletePolicyError");
const DeletePolicyError_6 = require("./types/DeletePolicy/DeletePolicyError");
const DeletePolicyError_7 = require("./types/DeletePolicy/DeletePolicyError");
const DeletePolicyError_8 = require("./types/DeletePolicy/DeletePolicyError");
const DeleteProviderError_1 = require("./types/DeleteProvider/DeleteProviderError");
const DeleteProviderError_2 = require("./types/DeleteProvider/DeleteProviderError");
const DeleteProviderError_3 = require("./types/DeleteProvider/DeleteProviderError");
const DeleteProviderError_4 = require("./types/DeleteProvider/DeleteProviderError");
const DeleteProviderError_5 = require("./types/DeleteProvider/DeleteProviderError");
const DeleteProviderError_6 = require("./types/DeleteProvider/DeleteProviderError");
const DeleteProviderError_7 = require("./types/DeleteProvider/DeleteProviderError");
const DeleteProviderError_8 = require("./types/DeleteProvider/DeleteProviderError");
const DeleteRoleError_1 = require("./types/DeleteRole/DeleteRoleError");
const DeleteRoleError_2 = require("./types/DeleteRole/DeleteRoleError");
const DeleteRoleError_3 = require("./types/DeleteRole/DeleteRoleError");
const DeleteRoleError_4 = require("./types/DeleteRole/DeleteRoleError");
const DeleteRoleError_5 = require("./types/DeleteRole/DeleteRoleError");
const DeleteRoleError_6 = require("./types/DeleteRole/DeleteRoleError");
const DeleteRoleError_7 = require("./types/DeleteRole/DeleteRoleError");
const DeleteRoleError_8 = require("./types/DeleteRole/DeleteRoleError");
const DeleteTeamError_1 = require("./types/DeleteTeam/DeleteTeamError");
const DeleteTeamError_2 = require("./types/DeleteTeam/DeleteTeamError");
const DeleteTeamError_3 = require("./types/DeleteTeam/DeleteTeamError");
const DeleteTeamError_4 = require("./types/DeleteTeam/DeleteTeamError");
const DeleteTeamError_5 = require("./types/DeleteTeam/DeleteTeamError");
const DeleteTeamError_6 = require("./types/DeleteTeam/DeleteTeamError");
const DeleteTeamError_7 = require("./types/DeleteTeam/DeleteTeamError");
const DeleteTeamError_8 = require("./types/DeleteTeam/DeleteTeamError");
const DeleteUserError_1 = require("./types/DeleteUser/DeleteUserError");
const DeleteUserError_2 = require("./types/DeleteUser/DeleteUserError");
const DeleteUserError_3 = require("./types/DeleteUser/DeleteUserError");
const DeleteUserError_4 = require("./types/DeleteUser/DeleteUserError");
const DeleteUserError_5 = require("./types/DeleteUser/DeleteUserError");
const DeleteUserError_6 = require("./types/DeleteUser/DeleteUserError");
const DeleteUserError_7 = require("./types/DeleteUser/DeleteUserError");
const DeleteUserError_8 = require("./types/DeleteUser/DeleteUserError");
const DeleteUserSCIMError_1 = require("./types/DeleteUserSCIM/DeleteUserSCIMError");
const DeleteUserSCIMError_2 = require("./types/DeleteUserSCIM/DeleteUserSCIMError");
const DeleteUserSCIMError_3 = require("./types/DeleteUserSCIM/DeleteUserSCIMError");
const DeleteUserSCIMError_4 = require("./types/DeleteUserSCIM/DeleteUserSCIMError");
const DeleteUserSCIMError_5 = require("./types/DeleteUserSCIM/DeleteUserSCIMError");
const DeleteUserSCIMError_6 = require("./types/DeleteUserSCIM/DeleteUserSCIMError");
const DeleteUserSCIMError_7 = require("./types/DeleteUserSCIM/DeleteUserSCIMError");
const DeleteUserSCIMError_8 = require("./types/DeleteUserSCIM/DeleteUserSCIMError");
const DetachGroupRoleError_1 = require("./types/DetachGroupRole/DetachGroupRoleError");
const DetachGroupRoleError_2 = require("./types/DetachGroupRole/DetachGroupRoleError");
const DetachGroupRoleError_3 = require("./types/DetachGroupRole/DetachGroupRoleError");
const DetachGroupRoleError_4 = require("./types/DetachGroupRole/DetachGroupRoleError");
const DetachGroupRoleError_5 = require("./types/DetachGroupRole/DetachGroupRoleError");
const DetachGroupRoleError_6 = require("./types/DetachGroupRole/DetachGroupRoleError");
const DetachGroupRoleError_7 = require("./types/DetachGroupRole/DetachGroupRoleError");
const DetachGroupRoleError_8 = require("./types/DetachGroupRole/DetachGroupRoleError");
const DetachGroupUserError_1 = require("./types/DetachGroupUser/DetachGroupUserError");
const DetachGroupUserError_2 = require("./types/DetachGroupUser/DetachGroupUserError");
const DetachGroupUserError_3 = require("./types/DetachGroupUser/DetachGroupUserError");
const DetachGroupUserError_4 = require("./types/DetachGroupUser/DetachGroupUserError");
const DetachGroupUserError_5 = require("./types/DetachGroupUser/DetachGroupUserError");
const DetachGroupUserError_6 = require("./types/DetachGroupUser/DetachGroupUserError");
const DetachGroupUserError_7 = require("./types/DetachGroupUser/DetachGroupUserError");
const DetachGroupUserError_8 = require("./types/DetachGroupUser/DetachGroupUserError");
const DetachRolePolicyError_1 = require("./types/DetachRolePolicy/DetachRolePolicyError");
const DetachRolePolicyError_2 = require("./types/DetachRolePolicy/DetachRolePolicyError");
const DetachRolePolicyError_3 = require("./types/DetachRolePolicy/DetachRolePolicyError");
const DetachRolePolicyError_4 = require("./types/DetachRolePolicy/DetachRolePolicyError");
const DetachRolePolicyError_5 = require("./types/DetachRolePolicy/DetachRolePolicyError");
const DetachRolePolicyError_6 = require("./types/DetachRolePolicy/DetachRolePolicyError");
const DetachRolePolicyError_7 = require("./types/DetachRolePolicy/DetachRolePolicyError");
const DetachRolePolicyError_8 = require("./types/DetachRolePolicy/DetachRolePolicyError");
const DetachTeamGroupError_1 = require("./types/DetachTeamGroup/DetachTeamGroupError");
const DetachTeamGroupError_2 = require("./types/DetachTeamGroup/DetachTeamGroupError");
const DetachTeamGroupError_3 = require("./types/DetachTeamGroup/DetachTeamGroupError");
const DetachTeamGroupError_4 = require("./types/DetachTeamGroup/DetachTeamGroupError");
const DetachTeamGroupError_5 = require("./types/DetachTeamGroup/DetachTeamGroupError");
const DetachTeamGroupError_6 = require("./types/DetachTeamGroup/DetachTeamGroupError");
const DetachTeamGroupError_7 = require("./types/DetachTeamGroup/DetachTeamGroupError");
const DetachTeamGroupError_8 = require("./types/DetachTeamGroup/DetachTeamGroupError");
const DetachTeamGroupRoleError_1 = require("./types/DetachTeamGroupRole/DetachTeamGroupRoleError");
const DetachTeamGroupRoleError_2 = require("./types/DetachTeamGroupRole/DetachTeamGroupRoleError");
const DetachTeamGroupRoleError_3 = require("./types/DetachTeamGroupRole/DetachTeamGroupRoleError");
const DetachTeamGroupRoleError_4 = require("./types/DetachTeamGroupRole/DetachTeamGroupRoleError");
const DetachTeamGroupRoleError_5 = require("./types/DetachTeamGroupRole/DetachTeamGroupRoleError");
const DetachTeamGroupRoleError_6 = require("./types/DetachTeamGroupRole/DetachTeamGroupRoleError");
const DetachTeamGroupRoleError_7 = require("./types/DetachTeamGroupRole/DetachTeamGroupRoleError");
const DetachTeamGroupRoleError_8 = require("./types/DetachTeamGroupRole/DetachTeamGroupRoleError");
const DetachTeamGroupUserError_1 = require("./types/DetachTeamGroupUser/DetachTeamGroupUserError");
const DetachTeamGroupUserError_2 = require("./types/DetachTeamGroupUser/DetachTeamGroupUserError");
const DetachTeamGroupUserError_3 = require("./types/DetachTeamGroupUser/DetachTeamGroupUserError");
const DetachTeamGroupUserError_4 = require("./types/DetachTeamGroupUser/DetachTeamGroupUserError");
const DetachTeamGroupUserError_5 = require("./types/DetachTeamGroupUser/DetachTeamGroupUserError");
const DetachTeamGroupUserError_6 = require("./types/DetachTeamGroupUser/DetachTeamGroupUserError");
const DetachTeamGroupUserError_7 = require("./types/DetachTeamGroupUser/DetachTeamGroupUserError");
const DetachTeamGroupUserError_8 = require("./types/DetachTeamGroupUser/DetachTeamGroupUserError");
exports.errors = {
    ListUserTeams: {
        InvalidParameterError: ListUserTeamsError_2.InvalidParameterError,
        UnauthorizedError: ListUserTeamsError_3.UnauthorizedError,
        ForbiddenError: ListUserTeamsError_4.ForbiddenError,
        NotFoundError: ListUserTeamsError_5.NotFoundError,
        InternalServerError: ListUserTeamsError_6.InternalServerError,
        BadGatewayError: ListUserTeamsError_7.BadGatewayError,
        GatewayTimeoutError: ListUserTeamsError_8.GatewayTimeoutError,
        GenericError: ListUserTeamsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUsers: {
        UnauthorizedError: ListUsersError_2.UnauthorizedError,
        ForbiddenError: ListUsersError_3.ForbiddenError,
        InternalServerError: ListUsersError_4.InternalServerError,
        BadGatewayError: ListUsersError_5.BadGatewayError,
        GatewayTimeoutError: ListUsersError_6.GatewayTimeoutError,
        GenericError: ListUsersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUsersSCIM: {
        InvalidParameterError: ListUsersSCIMError_2.InvalidParameterError,
        UnauthorizedError: ListUsersSCIMError_3.UnauthorizedError,
        ForbiddenError: ListUsersSCIMError_4.ForbiddenError,
        InternalServerError: ListUsersSCIMError_5.InternalServerError,
        BadGatewayError: ListUsersSCIMError_6.BadGatewayError,
        GatewayTimeoutError: ListUsersSCIMError_7.GatewayTimeoutError,
        GenericError: ListUsersSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    PatchGroupSCIM: {
        InvalidParameterError: PatchGroupSCIMError_2.InvalidParameterError,
        UnauthorizedError: PatchGroupSCIMError_3.UnauthorizedError,
        ForbiddenError: PatchGroupSCIMError_4.ForbiddenError,
        NotFoundError: PatchGroupSCIMError_5.NotFoundError,
        InternalServerError: PatchGroupSCIMError_6.InternalServerError,
        BadGatewayError: PatchGroupSCIMError_7.BadGatewayError,
        GatewayTimeoutError: PatchGroupSCIMError_8.GatewayTimeoutError,
        GenericError: PatchGroupSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    PatchUserSCIM: {
        InvalidParameterError: PatchUserSCIMError_2.InvalidParameterError,
        UnauthorizedError: PatchUserSCIMError_3.UnauthorizedError,
        ForbiddenError: PatchUserSCIMError_4.ForbiddenError,
        NotFoundError: PatchUserSCIMError_5.NotFoundError,
        ConflictError: PatchUserSCIMError_6.ConflictError,
        InternalServerError: PatchUserSCIMError_7.InternalServerError,
        BadGatewayError: PatchUserSCIMError_8.BadGatewayError,
        GatewayTimeoutError: PatchUserSCIMError_9.GatewayTimeoutError,
        GenericError: PatchUserSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    RenewToken: {
        InvalidParameterError: RenewTokenError_2.InvalidParameterError,
        PasswordRevokedError: RenewTokenError_3.PasswordRevokedError,
        IdentityDisabledError: RenewTokenError_4.IdentityDisabledError,
        NotAllowedError: RenewTokenError_5.NotAllowedError,
        InvalidRefreshTokenError: RenewTokenError_6.InvalidRefreshTokenError,
        NotFoundError: RenewTokenError_7.NotFoundError,
        InternalServerError: RenewTokenError_8.InternalServerError,
        BadGatewayError: RenewTokenError_9.BadGatewayError,
        GatewayTimeoutError: RenewTokenError_10.GatewayTimeoutError,
        GenericError: RenewTokenError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ResetMfaFactor: {
        InvalidParameterError: ResetMfaFactorError_2.InvalidParameterError,
        UnauthorizedError: ResetMfaFactorError_3.UnauthorizedError,
        ForbiddenError: ResetMfaFactorError_4.ForbiddenError,
        NotFoundError: ResetMfaFactorError_5.NotFoundError,
        InternalServerError: ResetMfaFactorError_6.InternalServerError,
        BadGatewayError: ResetMfaFactorError_7.BadGatewayError,
        GatewayTimeoutError: ResetMfaFactorError_8.GatewayTimeoutError,
        GenericError: ResetMfaFactorError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ResetPassword: {
        InvalidParameterError: ResetPasswordError_2.InvalidParameterError,
        InvalidSecretError: ResetPasswordError_3.InvalidSecretError,
        ExpiredSecretError: ResetPasswordError_4.ExpiredSecretError,
        NotFoundError: ResetPasswordError_5.NotFoundError,
        InternalServerError: ResetPasswordError_6.InternalServerError,
        BadGatewayError: ResetPasswordError_7.BadGatewayError,
        GatewayTimeoutError: ResetPasswordError_8.GatewayTimeoutError,
        GenericError: ResetPasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ResetUserMfaFactor: {
        InvalidParameterError: ResetUserMfaFactorError_2.InvalidParameterError,
        UnauthorizedError: ResetUserMfaFactorError_3.UnauthorizedError,
        ForbiddenError: ResetUserMfaFactorError_4.ForbiddenError,
        NotFoundError: ResetUserMfaFactorError_5.NotFoundError,
        InternalServerError: ResetUserMfaFactorError_6.InternalServerError,
        BadGatewayError: ResetUserMfaFactorError_7.BadGatewayError,
        GatewayTimeoutError: ResetUserMfaFactorError_8.GatewayTimeoutError,
        GenericError: ResetUserMfaFactorError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    RotateKey: {
        UnauthorizedError: RotateKeyError_2.UnauthorizedError,
        ForbiddenError: RotateKeyError_3.ForbiddenError,
        NotFoundError: RotateKeyError_4.NotFoundError,
        InternalServerError: RotateKeyError_5.InternalServerError,
        BadGatewayError: RotateKeyError_6.BadGatewayError,
        GatewayTimeoutError: RotateKeyError_7.GatewayTimeoutError,
        GenericError: RotateKeyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    RotateUserKey: {
        InvalidParameterError: RotateUserKeyError_2.InvalidParameterError,
        UnauthorizedError: RotateUserKeyError_3.UnauthorizedError,
        ForbiddenError: RotateUserKeyError_4.ForbiddenError,
        NotFoundError: RotateUserKeyError_5.NotFoundError,
        InternalServerError: RotateUserKeyError_6.InternalServerError,
        BadGatewayError: RotateUserKeyError_7.BadGatewayError,
        GatewayTimeoutError: RotateUserKeyError_8.GatewayTimeoutError,
        GenericError: RotateUserKeyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    SamlSignon: {
        InvalidParameterError: SamlSignonError_2.InvalidParameterError,
        UserNotAllowedToSignonError: SamlSignonError_3.UserNotAllowedToSignonError,
        InvalidAudienceUriError: SamlSignonError_4.InvalidAudienceUriError,
        NotFoundError: SamlSignonError_5.NotFoundError,
        ConflictError: SamlSignonError_6.ConflictError,
        InternalServerError: SamlSignonError_7.InternalServerError,
        BadGatewayError: SamlSignonError_8.BadGatewayError,
        GatewayTimeoutError: SamlSignonError_9.GatewayTimeoutError,
        GenericError: SamlSignonError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    SendOtp: {
        InvalidParameterError: SendOtpError_2.InvalidParameterError,
        InvalidTokenError: SendOtpError_3.InvalidTokenError,
        MfaFactorNotAllowedError: SendOtpError_4.MfaFactorNotAllowedError,
        ConflictError: SendOtpError_5.ConflictError,
        InternalServerError: SendOtpError_6.InternalServerError,
        BadGatewayError: SendOtpError_7.BadGatewayError,
        GatewayTimeoutError: SendOtpError_8.GatewayTimeoutError,
        GenericError: SendOtpError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    SsoSignin: {
        InvalidParameterError: SsoSigninError_2.InvalidParameterError,
        NotFoundError: SsoSigninError_3.NotFoundError,
        ConflictError: SsoSigninError_4.ConflictError,
        InternalServerError: SsoSigninError_5.InternalServerError,
        BadGatewayError: SsoSigninError_6.BadGatewayError,
        GatewayTimeoutError: SsoSigninError_7.GatewayTimeoutError,
        GenericError: SsoSigninError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateAccount: {
        InvalidParameterError: UpdateAccountError_2.InvalidParameterError,
        UnauthorizedError: UpdateAccountError_3.UnauthorizedError,
        ForbiddenError: UpdateAccountError_4.ForbiddenError,
        NotFoundError: UpdateAccountError_5.NotFoundError,
        ConflictError: UpdateAccountError_6.ConflictError,
        InternalServerError: UpdateAccountError_7.InternalServerError,
        BadGatewayError: UpdateAccountError_8.BadGatewayError,
        GatewayTimeoutError: UpdateAccountError_9.GatewayTimeoutError,
        GenericError: UpdateAccountError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateGroup: {
        InvalidParameterError: UpdateGroupError_2.InvalidParameterError,
        UnauthorizedError: UpdateGroupError_3.UnauthorizedError,
        ForbiddenError: UpdateGroupError_4.ForbiddenError,
        NotFoundError: UpdateGroupError_5.NotFoundError,
        InternalServerError: UpdateGroupError_6.InternalServerError,
        BadGatewayError: UpdateGroupError_7.BadGatewayError,
        GatewayTimeoutError: UpdateGroupError_8.GatewayTimeoutError,
        GenericError: UpdateGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateGroupSCIM: {
        InvalidParameterError: UpdateGroupSCIMError_2.InvalidParameterError,
        UnauthorizedError: UpdateGroupSCIMError_3.UnauthorizedError,
        ForbiddenError: UpdateGroupSCIMError_4.ForbiddenError,
        NotFoundError: UpdateGroupSCIMError_5.NotFoundError,
        InternalServerError: UpdateGroupSCIMError_6.InternalServerError,
        BadGatewayError: UpdateGroupSCIMError_7.BadGatewayError,
        GatewayTimeoutError: UpdateGroupSCIMError_8.GatewayTimeoutError,
        GenericError: UpdateGroupSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateManagedPolicy: {
        InvalidParameterError: UpdateManagedPolicyError_2.InvalidParameterError,
        UnauthorizedError: UpdateManagedPolicyError_3.UnauthorizedError,
        ForbiddenError: UpdateManagedPolicyError_4.ForbiddenError,
        NotFoundError: UpdateManagedPolicyError_5.NotFoundError,
        InternalServerError: UpdateManagedPolicyError_6.InternalServerError,
        BadGatewayError: UpdateManagedPolicyError_7.BadGatewayError,
        GatewayTimeoutError: UpdateManagedPolicyError_8.GatewayTimeoutError,
        GenericError: UpdateManagedPolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateMfa: {
        InvalidParameterError: UpdateMfaError_2.InvalidParameterError,
        UnauthorizedError: UpdateMfaError_3.UnauthorizedError,
        MfaFactorNotVerifiedError: UpdateMfaError_4.MfaFactorNotVerifiedError,
        ForbiddenError: UpdateMfaError_5.ForbiddenError,
        NotFoundError: UpdateMfaError_6.NotFoundError,
        InternalServerError: UpdateMfaError_7.InternalServerError,
        BadGatewayError: UpdateMfaError_8.BadGatewayError,
        GatewayTimeoutError: UpdateMfaError_9.GatewayTimeoutError,
        GenericError: UpdateMfaError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdatePassword: {
        InvalidParameterError: UpdatePasswordError_2.InvalidParameterError,
        UnauthorizedError: UpdatePasswordError_3.UnauthorizedError,
        InvalidAuthenticationModeError: UpdatePasswordError_4.InvalidAuthenticationModeError,
        PasswordDoesNotMatchError: UpdatePasswordError_5.PasswordDoesNotMatchError,
        ForbiddenError: UpdatePasswordError_6.ForbiddenError,
        NotFoundError: UpdatePasswordError_7.NotFoundError,
        InternalServerError: UpdatePasswordError_8.InternalServerError,
        BadGatewayError: UpdatePasswordError_9.BadGatewayError,
        GatewayTimeoutError: UpdatePasswordError_10.GatewayTimeoutError,
        GenericError: UpdatePasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdatePolicy: {
        InvalidParameterError: UpdatePolicyError_2.InvalidParameterError,
        UnauthorizedError: UpdatePolicyError_3.UnauthorizedError,
        ForbiddenError: UpdatePolicyError_4.ForbiddenError,
        NotFoundError: UpdatePolicyError_5.NotFoundError,
        InternalServerError: UpdatePolicyError_6.InternalServerError,
        BadGatewayError: UpdatePolicyError_7.BadGatewayError,
        GatewayTimeoutError: UpdatePolicyError_8.GatewayTimeoutError,
        GenericError: UpdatePolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateProvider: {
        InvalidParameterError: UpdateProviderError_2.InvalidParameterError,
        UnauthorizedError: UpdateProviderError_3.UnauthorizedError,
        InvalidCertificateError: UpdateProviderError_4.InvalidCertificateError,
        ForbiddenError: UpdateProviderError_5.ForbiddenError,
        NotFoundError: UpdateProviderError_6.NotFoundError,
        InternalServerError: UpdateProviderError_7.InternalServerError,
        BadGatewayError: UpdateProviderError_8.BadGatewayError,
        GatewayTimeoutError: UpdateProviderError_9.GatewayTimeoutError,
        GenericError: UpdateProviderError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateRole: {
        InvalidParameterError: UpdateRoleError_2.InvalidParameterError,
        UnauthorizedError: UpdateRoleError_3.UnauthorizedError,
        ForbiddenError: UpdateRoleError_4.ForbiddenError,
        NotFoundError: UpdateRoleError_5.NotFoundError,
        InternalServerError: UpdateRoleError_6.InternalServerError,
        BadGatewayError: UpdateRoleError_7.BadGatewayError,
        GatewayTimeoutError: UpdateRoleError_8.GatewayTimeoutError,
        GenericError: UpdateRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateSecurity: {
        InvalidParameterError: UpdateSecurityError_2.InvalidParameterError,
        UnauthorizedError: UpdateSecurityError_3.UnauthorizedError,
        ForbiddenError: UpdateSecurityError_4.ForbiddenError,
        NotFoundError: UpdateSecurityError_5.NotFoundError,
        InternalServerError: UpdateSecurityError_6.InternalServerError,
        BadGatewayError: UpdateSecurityError_7.BadGatewayError,
        GatewayTimeoutError: UpdateSecurityError_8.GatewayTimeoutError,
        GenericError: UpdateSecurityError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateTeam: {
        InvalidParameterError: UpdateTeamError_2.InvalidParameterError,
        UnauthorizedError: UpdateTeamError_3.UnauthorizedError,
        ForbiddenError: UpdateTeamError_4.ForbiddenError,
        NotFoundError: UpdateTeamError_5.NotFoundError,
        InternalServerError: UpdateTeamError_6.InternalServerError,
        BadGatewayError: UpdateTeamError_7.BadGatewayError,
        GatewayTimeoutError: UpdateTeamError_8.GatewayTimeoutError,
        GenericError: UpdateTeamError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateTeamGroup: {
        InvalidParameterError: UpdateTeamGroupError_2.InvalidParameterError,
        UnauthorizedError: UpdateTeamGroupError_3.UnauthorizedError,
        ForbiddenError: UpdateTeamGroupError_4.ForbiddenError,
        NotFoundError: UpdateTeamGroupError_5.NotFoundError,
        InternalServerError: UpdateTeamGroupError_6.InternalServerError,
        BadGatewayError: UpdateTeamGroupError_7.BadGatewayError,
        GatewayTimeoutError: UpdateTeamGroupError_8.GatewayTimeoutError,
        GenericError: UpdateTeamGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateTeamUser: {
        InvalidParameterError: UpdateTeamUserError_2.InvalidParameterError,
        UnauthorizedError: UpdateTeamUserError_3.UnauthorizedError,
        InvalidSubscriptionError: UpdateTeamUserError_4.InvalidSubscriptionError,
        ForbiddenToUpdateProvisionedUserError: UpdateTeamUserError_5.ForbiddenToUpdateProvisionedUserError,
        ForbiddenError: UpdateTeamUserError_6.ForbiddenError,
        NotFoundError: UpdateTeamUserError_7.NotFoundError,
        ConflictError: UpdateTeamUserError_8.ConflictError,
        InternalServerError: UpdateTeamUserError_9.InternalServerError,
        BadGatewayError: UpdateTeamUserError_10.BadGatewayError,
        GatewayTimeoutError: UpdateTeamUserError_11.GatewayTimeoutError,
        GenericError: UpdateTeamUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateUser: {
        InvalidParameterError: UpdateUserError_2.InvalidParameterError,
        UnauthorizedError: UpdateUserError_3.UnauthorizedError,
        ForbiddenToUpdateProvisionedUserError: UpdateUserError_4.ForbiddenToUpdateProvisionedUserError,
        InvalidSubscriptionError: UpdateUserError_5.InvalidSubscriptionError,
        ForbiddenError: UpdateUserError_6.ForbiddenError,
        NotFoundError: UpdateUserError_7.NotFoundError,
        InternalServerError: UpdateUserError_8.InternalServerError,
        BadGatewayError: UpdateUserError_9.BadGatewayError,
        GatewayTimeoutError: UpdateUserError_10.GatewayTimeoutError,
        GenericError: UpdateUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateUserMfa: {
        InvalidParameterError: UpdateUserMfaError_2.InvalidParameterError,
        UnauthorizedError: UpdateUserMfaError_3.UnauthorizedError,
        MfaFactorNotVerifiedError: UpdateUserMfaError_4.MfaFactorNotVerifiedError,
        ForbiddenError: UpdateUserMfaError_5.ForbiddenError,
        NotFoundError: UpdateUserMfaError_6.NotFoundError,
        InternalServerError: UpdateUserMfaError_7.InternalServerError,
        BadGatewayError: UpdateUserMfaError_8.BadGatewayError,
        GatewayTimeoutError: UpdateUserMfaError_9.GatewayTimeoutError,
        GenericError: UpdateUserMfaError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateUserSCIM: {
        InvalidParameterError: UpdateUserSCIMError_2.InvalidParameterError,
        UnauthorizedError: UpdateUserSCIMError_3.UnauthorizedError,
        ForbiddenError: UpdateUserSCIMError_4.ForbiddenError,
        NotFoundError: UpdateUserSCIMError_5.NotFoundError,
        ConflictError: UpdateUserSCIMError_6.ConflictError,
        InternalServerError: UpdateUserSCIMError_7.InternalServerError,
        BadGatewayError: UpdateUserSCIMError_8.BadGatewayError,
        GatewayTimeoutError: UpdateUserSCIMError_9.GatewayTimeoutError,
        GenericError: UpdateUserSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    VerifyMfaFactor: {
        InvalidParameterError: VerifyMfaFactorError_2.InvalidParameterError,
        InvalidTokenError: VerifyMfaFactorError_3.InvalidTokenError,
        InvalidOtpError: VerifyMfaFactorError_4.InvalidOtpError,
        MfaFactorNotAllowedError: VerifyMfaFactorError_5.MfaFactorNotAllowedError,
        NotFoundError: VerifyMfaFactorError_6.NotFoundError,
        InternalServerError: VerifyMfaFactorError_7.InternalServerError,
        BadGatewayError: VerifyMfaFactorError_8.BadGatewayError,
        GatewayTimeoutError: VerifyMfaFactorError_9.GatewayTimeoutError,
        GenericError: VerifyMfaFactorError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    VerifyOtp: {
        InvalidParameterError: VerifyOtpError_2.InvalidParameterError,
        InvalidOtpError: VerifyOtpError_3.InvalidOtpError,
        InvalidTokenError: VerifyOtpError_4.InvalidTokenError,
        TokenExpiredError: VerifyOtpError_5.TokenExpiredError,
        NotFoundError: VerifyOtpError_6.NotFoundError,
        InternalServerError: VerifyOtpError_7.InternalServerError,
        BadGatewayError: VerifyOtpError_8.BadGatewayError,
        GatewayTimeoutError: VerifyOtpError_9.GatewayTimeoutError,
        GenericError: VerifyOtpError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    VerifyUserMfaFactor: {
        InvalidParameterError: VerifyUserMfaFactorError_2.InvalidParameterError,
        InvalidTokenError: VerifyUserMfaFactorError_3.InvalidTokenError,
        InvalidOtpError: VerifyUserMfaFactorError_4.InvalidOtpError,
        MfaFactorNotAllowedError: VerifyUserMfaFactorError_5.MfaFactorNotAllowedError,
        NotFoundError: VerifyUserMfaFactorError_6.NotFoundError,
        InternalServerError: VerifyUserMfaFactorError_7.InternalServerError,
        BadGatewayError: VerifyUserMfaFactorError_8.BadGatewayError,
        GatewayTimeoutError: VerifyUserMfaFactorError_9.GatewayTimeoutError,
        GenericError: VerifyUserMfaFactorError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamRole: {
        InvalidParameterError: DetachTeamRoleError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamRoleError_3.UnauthorizedError,
        ForbiddenError: DetachTeamRoleError_4.ForbiddenError,
        NotFoundError: DetachTeamRoleError_5.NotFoundError,
        InternalServerError: DetachTeamRoleError_6.InternalServerError,
        BadGatewayError: DetachTeamRoleError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamRoleError_8.GatewayTimeoutError,
        GenericError: DetachTeamRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamUser: {
        InvalidParameterError: DetachTeamUserError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamUserError_3.UnauthorizedError,
        ForbiddenError: DetachTeamUserError_4.ForbiddenError,
        NotFoundError: DetachTeamUserError_5.NotFoundError,
        InternalServerError: DetachTeamUserError_6.InternalServerError,
        BadGatewayError: DetachTeamUserError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamUserError_8.GatewayTimeoutError,
        GenericError: DetachTeamUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamUserRole: {
        InvalidParameterError: DetachTeamUserRoleError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamUserRoleError_3.UnauthorizedError,
        ForbiddenError: DetachTeamUserRoleError_4.ForbiddenError,
        NotFoundError: DetachTeamUserRoleError_5.NotFoundError,
        InternalServerError: DetachTeamUserRoleError_6.InternalServerError,
        BadGatewayError: DetachTeamUserRoleError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamUserRoleError_8.GatewayTimeoutError,
        GenericError: DetachTeamUserRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachUserRole: {
        InvalidParameterError: DetachUserRoleError_2.InvalidParameterError,
        UnauthorizedError: DetachUserRoleError_3.UnauthorizedError,
        ForbiddenError: DetachUserRoleError_4.ForbiddenError,
        NotFoundError: DetachUserRoleError_5.NotFoundError,
        InternalServerError: DetachUserRoleError_6.InternalServerError,
        BadGatewayError: DetachUserRoleError_7.BadGatewayError,
        GatewayTimeoutError: DetachUserRoleError_8.GatewayTimeoutError,
        GenericError: DetachUserRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ForgotPassword: {
        InvalidParameterError: ForgotPasswordError_2.InvalidParameterError,
        InvalidIdentityUsernameError: ForgotPasswordError_3.InvalidIdentityUsernameError,
        NotFoundError: ForgotPasswordError_4.NotFoundError,
        InternalServerError: ForgotPasswordError_5.InternalServerError,
        BadGatewayError: ForgotPasswordError_6.BadGatewayError,
        GatewayTimeoutError: ForgotPasswordError_7.GatewayTimeoutError,
        GenericError: ForgotPasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetAccount: {
        UnauthorizedError: GetAccountError_2.UnauthorizedError,
        ForbiddenError: GetAccountError_3.ForbiddenError,
        NotFoundError: GetAccountError_4.NotFoundError,
        InternalServerError: GetAccountError_5.InternalServerError,
        BadGatewayError: GetAccountError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountError_7.GatewayTimeoutError,
        GenericError: GetAccountError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetGroup: {
        InvalidParameterError: GetGroupError_2.InvalidParameterError,
        UnauthorizedError: GetGroupError_3.UnauthorizedError,
        ForbiddenError: GetGroupError_4.ForbiddenError,
        NotFoundError: GetGroupError_5.NotFoundError,
        InternalServerError: GetGroupError_6.InternalServerError,
        BadGatewayError: GetGroupError_7.BadGatewayError,
        GatewayTimeoutError: GetGroupError_8.GatewayTimeoutError,
        GenericError: GetGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetGroupSCIM: {
        InvalidParameterError: GetGroupSCIMError_2.InvalidParameterError,
        UnauthorizedError: GetGroupSCIMError_3.UnauthorizedError,
        ForbiddenError: GetGroupSCIMError_4.ForbiddenError,
        NotFoundError: GetGroupSCIMError_5.NotFoundError,
        InternalServerError: GetGroupSCIMError_6.InternalServerError,
        BadGatewayError: GetGroupSCIMError_7.BadGatewayError,
        GatewayTimeoutError: GetGroupSCIMError_8.GatewayTimeoutError,
        GenericError: GetGroupSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetMfa: {
        UnauthorizedError: GetMfaError_2.UnauthorizedError,
        ForbiddenError: GetMfaError_3.ForbiddenError,
        NotFoundError: GetMfaError_4.NotFoundError,
        InternalServerError: GetMfaError_5.InternalServerError,
        BadGatewayError: GetMfaError_6.BadGatewayError,
        GatewayTimeoutError: GetMfaError_7.GatewayTimeoutError,
        GenericError: GetMfaError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetPolicy: {
        InvalidParameterError: GetPolicyError_2.InvalidParameterError,
        UnauthorizedError: GetPolicyError_3.UnauthorizedError,
        ForbiddenError: GetPolicyError_4.ForbiddenError,
        NotFoundError: GetPolicyError_5.NotFoundError,
        InternalServerError: GetPolicyError_6.InternalServerError,
        BadGatewayError: GetPolicyError_7.BadGatewayError,
        GatewayTimeoutError: GetPolicyError_8.GatewayTimeoutError,
        GenericError: GetPolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetProvider: {
        InvalidParameterError: GetProviderError_2.InvalidParameterError,
        UnauthorizedError: GetProviderError_3.UnauthorizedError,
        ForbiddenError: GetProviderError_4.ForbiddenError,
        NotFoundError: GetProviderError_5.NotFoundError,
        InternalServerError: GetProviderError_6.InternalServerError,
        BadGatewayError: GetProviderError_7.BadGatewayError,
        GatewayTimeoutError: GetProviderError_8.GatewayTimeoutError,
        GenericError: GetProviderError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetResourceTypes: {
        UnauthorizedError: GetResourceTypesError_2.UnauthorizedError,
        ForbiddenError: GetResourceTypesError_3.ForbiddenError,
        InternalServerError: GetResourceTypesError_4.InternalServerError,
        BadGatewayError: GetResourceTypesError_5.BadGatewayError,
        GatewayTimeoutError: GetResourceTypesError_6.GatewayTimeoutError,
        GenericError: GetResourceTypesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetRole: {
        InvalidParameterError: GetRoleError_2.InvalidParameterError,
        UnauthorizedError: GetRoleError_3.UnauthorizedError,
        ForbiddenError: GetRoleError_4.ForbiddenError,
        NotFoundError: GetRoleError_5.NotFoundError,
        InternalServerError: GetRoleError_6.InternalServerError,
        BadGatewayError: GetRoleError_7.BadGatewayError,
        GatewayTimeoutError: GetRoleError_8.GatewayTimeoutError,
        GenericError: GetRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetSchemas: {
        UnauthorizedError: GetSchemasError_2.UnauthorizedError,
        ForbiddenError: GetSchemasError_3.ForbiddenError,
        InternalServerError: GetSchemasError_4.InternalServerError,
        BadGatewayError: GetSchemasError_5.BadGatewayError,
        GatewayTimeoutError: GetSchemasError_6.GatewayTimeoutError,
        GenericError: GetSchemasError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetSecurity: {
        UnauthorizedError: GetSecurityError_2.UnauthorizedError,
        ForbiddenError: GetSecurityError_3.ForbiddenError,
        NotFoundError: GetSecurityError_4.NotFoundError,
        InternalServerError: GetSecurityError_5.InternalServerError,
        BadGatewayError: GetSecurityError_6.BadGatewayError,
        GatewayTimeoutError: GetSecurityError_7.GatewayTimeoutError,
        GenericError: GetSecurityError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetServiceProviderConfig: {
        UnauthorizedError: GetServiceProviderConfigError_2.UnauthorizedError,
        ForbiddenError: GetServiceProviderConfigError_3.ForbiddenError,
        InternalServerError: GetServiceProviderConfigError_4.InternalServerError,
        BadGatewayError: GetServiceProviderConfigError_5.BadGatewayError,
        GatewayTimeoutError: GetServiceProviderConfigError_6.GatewayTimeoutError,
        GenericError: GetServiceProviderConfigError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetSigninConfiguration: {
        InvalidParameterError: GetSigninConfigurationError_2.InvalidParameterError,
        NotFoundError: GetSigninConfigurationError_3.NotFoundError,
        InternalServerError: GetSigninConfigurationError_4.InternalServerError,
        BadGatewayError: GetSigninConfigurationError_5.BadGatewayError,
        GatewayTimeoutError: GetSigninConfigurationError_6.GatewayTimeoutError,
        GenericError: GetSigninConfigurationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetTeam: {
        InvalidParameterError: GetTeamError_2.InvalidParameterError,
        UnauthorizedError: GetTeamError_3.UnauthorizedError,
        ForbiddenError: GetTeamError_4.ForbiddenError,
        NotFoundError: GetTeamError_5.NotFoundError,
        InternalServerError: GetTeamError_6.InternalServerError,
        BadGatewayError: GetTeamError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamError_8.GatewayTimeoutError,
        GenericError: GetTeamError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetTeamGroup: {
        InvalidParameterError: GetTeamGroupError_2.InvalidParameterError,
        UnauthorizedError: GetTeamGroupError_3.UnauthorizedError,
        ForbiddenError: GetTeamGroupError_4.ForbiddenError,
        NotFoundError: GetTeamGroupError_5.NotFoundError,
        InternalServerError: GetTeamGroupError_6.InternalServerError,
        BadGatewayError: GetTeamGroupError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamGroupError_8.GatewayTimeoutError,
        GenericError: GetTeamGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetTeamUser: {
        InvalidParameterError: GetTeamUserError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserError_3.UnauthorizedError,
        ForbiddenError: GetTeamUserError_4.ForbiddenError,
        NotFoundError: GetTeamUserError_5.NotFoundError,
        InternalServerError: GetTeamUserError_6.InternalServerError,
        BadGatewayError: GetTeamUserError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamUserError_8.GatewayTimeoutError,
        GenericError: GetTeamUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetUser: {
        InvalidParameterError: GetUserError_2.InvalidParameterError,
        UnauthorizedError: GetUserError_3.UnauthorizedError,
        ForbiddenError: GetUserError_4.ForbiddenError,
        NotFoundError: GetUserError_5.NotFoundError,
        InternalServerError: GetUserError_6.InternalServerError,
        BadGatewayError: GetUserError_7.BadGatewayError,
        GatewayTimeoutError: GetUserError_8.GatewayTimeoutError,
        GenericError: GetUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetUserMfa: {
        InvalidParameterError: GetUserMfaError_2.InvalidParameterError,
        UnauthorizedError: GetUserMfaError_3.UnauthorizedError,
        ForbiddenError: GetUserMfaError_4.ForbiddenError,
        NotFoundError: GetUserMfaError_5.NotFoundError,
        InternalServerError: GetUserMfaError_6.InternalServerError,
        BadGatewayError: GetUserMfaError_7.BadGatewayError,
        GatewayTimeoutError: GetUserMfaError_8.GatewayTimeoutError,
        GenericError: GetUserMfaError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetUserSCIM: {
        InvalidParameterError: GetUserSCIMError_2.InvalidParameterError,
        UnauthorizedError: GetUserSCIMError_3.UnauthorizedError,
        ForbiddenError: GetUserSCIMError_4.ForbiddenError,
        NotFoundError: GetUserSCIMError_5.NotFoundError,
        InternalServerError: GetUserSCIMError_6.InternalServerError,
        BadGatewayError: GetUserSCIMError_7.BadGatewayError,
        GatewayTimeoutError: GetUserSCIMError_8.GatewayTimeoutError,
        GenericError: GetUserSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    InviteTeamUser: {
        InvalidParameterError: InviteTeamUserError_2.InvalidParameterError,
        UnauthorizedError: InviteTeamUserError_3.UnauthorizedError,
        ForbiddenError: InviteTeamUserError_4.ForbiddenError,
        NotFoundError: InviteTeamUserError_5.NotFoundError,
        InternalServerError: InviteTeamUserError_6.InternalServerError,
        BadGatewayError: InviteTeamUserError_7.BadGatewayError,
        GatewayTimeoutError: InviteTeamUserError_8.GatewayTimeoutError,
        GenericError: InviteTeamUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    InviteUser: {
        InvalidParameterError: InviteUserError_2.InvalidParameterError,
        UnauthorizedError: InviteUserError_3.UnauthorizedError,
        InvalidEmailError: InviteUserError_4.InvalidEmailError,
        ForbiddenError: InviteUserError_5.ForbiddenError,
        NotFoundError: InviteUserError_6.NotFoundError,
        InternalServerError: InviteUserError_7.InternalServerError,
        BadGatewayError: InviteUserError_8.BadGatewayError,
        GatewayTimeoutError: InviteUserError_9.GatewayTimeoutError,
        GenericError: InviteUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListGroupRoles: {
        InvalidParameterError: ListGroupRolesError_2.InvalidParameterError,
        UnauthorizedError: ListGroupRolesError_3.UnauthorizedError,
        ForbiddenError: ListGroupRolesError_4.ForbiddenError,
        NotFoundError: ListGroupRolesError_5.NotFoundError,
        InternalServerError: ListGroupRolesError_6.InternalServerError,
        BadGatewayError: ListGroupRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListGroupRolesError_8.GatewayTimeoutError,
        GenericError: ListGroupRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListGroupTeams: {
        InvalidParameterError: ListGroupTeamsError_2.InvalidParameterError,
        UnauthorizedError: ListGroupTeamsError_3.UnauthorizedError,
        ForbiddenError: ListGroupTeamsError_4.ForbiddenError,
        NotFoundError: ListGroupTeamsError_5.NotFoundError,
        InternalServerError: ListGroupTeamsError_6.InternalServerError,
        BadGatewayError: ListGroupTeamsError_7.BadGatewayError,
        GatewayTimeoutError: ListGroupTeamsError_8.GatewayTimeoutError,
        GenericError: ListGroupTeamsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListGroupUsers: {
        InvalidParameterError: ListGroupUsersError_2.InvalidParameterError,
        UnauthorizedError: ListGroupUsersError_3.UnauthorizedError,
        ForbiddenError: ListGroupUsersError_4.ForbiddenError,
        NotFoundError: ListGroupUsersError_5.NotFoundError,
        InternalServerError: ListGroupUsersError_6.InternalServerError,
        BadGatewayError: ListGroupUsersError_7.BadGatewayError,
        GatewayTimeoutError: ListGroupUsersError_8.GatewayTimeoutError,
        GenericError: ListGroupUsersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListGroups: {
        UnauthorizedError: ListGroupsError_2.UnauthorizedError,
        ForbiddenError: ListGroupsError_3.ForbiddenError,
        NotFoundError: ListGroupsError_4.NotFoundError,
        InternalServerError: ListGroupsError_5.InternalServerError,
        BadGatewayError: ListGroupsError_6.BadGatewayError,
        GatewayTimeoutError: ListGroupsError_7.GatewayTimeoutError,
        GenericError: ListGroupsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListGroupsSCIM: {
        InvalidParameterError: ListGroupsSCIMError_2.InvalidParameterError,
        UnauthorizedError: ListGroupsSCIMError_3.UnauthorizedError,
        ForbiddenError: ListGroupsSCIMError_4.ForbiddenError,
        InternalServerError: ListGroupsSCIMError_5.InternalServerError,
        BadGatewayError: ListGroupsSCIMError_6.BadGatewayError,
        GatewayTimeoutError: ListGroupsSCIMError_7.GatewayTimeoutError,
        GenericError: ListGroupsSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListPolicies: {
        UnauthorizedError: ListPoliciesError_2.UnauthorizedError,
        ForbiddenError: ListPoliciesError_3.ForbiddenError,
        InternalServerError: ListPoliciesError_4.InternalServerError,
        BadGatewayError: ListPoliciesError_5.BadGatewayError,
        GatewayTimeoutError: ListPoliciesError_6.GatewayTimeoutError,
        GenericError: ListPoliciesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListProviders: {
        UnauthorizedError: ListProvidersError_2.UnauthorizedError,
        ForbiddenError: ListProvidersError_3.ForbiddenError,
        InternalServerError: ListProvidersError_4.InternalServerError,
        BadGatewayError: ListProvidersError_5.BadGatewayError,
        GatewayTimeoutError: ListProvidersError_6.GatewayTimeoutError,
        GenericError: ListProvidersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListRoles: {
        UnauthorizedError: ListRolesError_2.UnauthorizedError,
        ForbiddenError: ListRolesError_3.ForbiddenError,
        InternalServerError: ListRolesError_4.InternalServerError,
        BadGatewayError: ListRolesError_5.BadGatewayError,
        GatewayTimeoutError: ListRolesError_6.GatewayTimeoutError,
        GenericError: ListRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamGroupRoles: {
        InvalidParameterError: ListTeamGroupRolesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamGroupRolesError_3.UnauthorizedError,
        ForbiddenError: ListTeamGroupRolesError_4.ForbiddenError,
        NotFoundError: ListTeamGroupRolesError_5.NotFoundError,
        InternalServerError: ListTeamGroupRolesError_6.InternalServerError,
        BadGatewayError: ListTeamGroupRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamGroupRolesError_8.GatewayTimeoutError,
        GenericError: ListTeamGroupRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamGroupUsers: {
        InvalidParameterError: ListTeamGroupUsersError_2.InvalidParameterError,
        UnauthorizedError: ListTeamGroupUsersError_3.UnauthorizedError,
        ForbiddenError: ListTeamGroupUsersError_4.ForbiddenError,
        NotFoundError: ListTeamGroupUsersError_5.NotFoundError,
        InternalServerError: ListTeamGroupUsersError_6.InternalServerError,
        BadGatewayError: ListTeamGroupUsersError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamGroupUsersError_8.GatewayTimeoutError,
        GenericError: ListTeamGroupUsersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamGroups: {
        InvalidParameterError: ListTeamGroupsError_2.InvalidParameterError,
        UnauthorizedError: ListTeamGroupsError_3.UnauthorizedError,
        ForbiddenError: ListTeamGroupsError_4.ForbiddenError,
        NotFoundError: ListTeamGroupsError_5.NotFoundError,
        InternalServerError: ListTeamGroupsError_6.InternalServerError,
        BadGatewayError: ListTeamGroupsError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamGroupsError_8.GatewayTimeoutError,
        GenericError: ListTeamGroupsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamRoles: {
        InvalidParameterError: ListTeamRolesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamRolesError_3.UnauthorizedError,
        ForbiddenError: ListTeamRolesError_4.ForbiddenError,
        NotFoundError: ListTeamRolesError_5.NotFoundError,
        InternalServerError: ListTeamRolesError_6.InternalServerError,
        BadGatewayError: ListTeamRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamRolesError_8.GatewayTimeoutError,
        GenericError: ListTeamRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamUserGroups: {
        InvalidParameterError: ListTeamUserGroupsError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserGroupsError_3.UnauthorizedError,
        ForbiddenError: ListTeamUserGroupsError_4.ForbiddenError,
        NotFoundError: ListTeamUserGroupsError_5.NotFoundError,
        InternalServerError: ListTeamUserGroupsError_6.InternalServerError,
        BadGatewayError: ListTeamUserGroupsError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamUserGroupsError_8.GatewayTimeoutError,
        GenericError: ListTeamUserGroupsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamUserRoles: {
        InvalidParameterError: ListTeamUserRolesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserRolesError_3.UnauthorizedError,
        ForbiddenError: ListTeamUserRolesError_4.ForbiddenError,
        NotFoundError: ListTeamUserRolesError_5.NotFoundError,
        InternalServerError: ListTeamUserRolesError_6.InternalServerError,
        BadGatewayError: ListTeamUserRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamUserRolesError_8.GatewayTimeoutError,
        GenericError: ListTeamUserRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamUsers: {
        InvalidParameterError: ListTeamUsersError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUsersError_3.UnauthorizedError,
        ForbiddenError: ListTeamUsersError_4.ForbiddenError,
        NotFoundError: ListTeamUsersError_5.NotFoundError,
        InternalServerError: ListTeamUsersError_6.InternalServerError,
        BadGatewayError: ListTeamUsersError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamUsersError_8.GatewayTimeoutError,
        GenericError: ListTeamUsersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeams: {
        UnauthorizedError: ListTeamsError_2.UnauthorizedError,
        ForbiddenError: ListTeamsError_3.ForbiddenError,
        InternalServerError: ListTeamsError_4.InternalServerError,
        BadGatewayError: ListTeamsError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamsError_6.GatewayTimeoutError,
        GenericError: ListTeamsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUserGroups: {
        InvalidParameterError: ListUserGroupsError_2.InvalidParameterError,
        UnauthorizedError: ListUserGroupsError_3.UnauthorizedError,
        ForbiddenError: ListUserGroupsError_4.ForbiddenError,
        NotFoundError: ListUserGroupsError_5.NotFoundError,
        InternalServerError: ListUserGroupsError_6.InternalServerError,
        BadGatewayError: ListUserGroupsError_7.BadGatewayError,
        GatewayTimeoutError: ListUserGroupsError_8.GatewayTimeoutError,
        GenericError: ListUserGroupsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUserGroupsRoles: {
        InvalidParameterError: ListUserGroupsRolesError_2.InvalidParameterError,
        UnauthorizedError: ListUserGroupsRolesError_3.UnauthorizedError,
        ForbiddenError: ListUserGroupsRolesError_4.ForbiddenError,
        NotFoundError: ListUserGroupsRolesError_5.NotFoundError,
        InternalServerError: ListUserGroupsRolesError_6.InternalServerError,
        BadGatewayError: ListUserGroupsRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListUserGroupsRolesError_8.GatewayTimeoutError,
        GenericError: ListUserGroupsRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUserGroupsTeams: {
        InvalidParameterError: ListUserGroupsTeamsError_2.InvalidParameterError,
        UnauthorizedError: ListUserGroupsTeamsError_3.UnauthorizedError,
        ForbiddenError: ListUserGroupsTeamsError_4.ForbiddenError,
        NotFoundError: ListUserGroupsTeamsError_5.NotFoundError,
        InternalServerError: ListUserGroupsTeamsError_6.InternalServerError,
        BadGatewayError: ListUserGroupsTeamsError_7.BadGatewayError,
        GatewayTimeoutError: ListUserGroupsTeamsError_8.GatewayTimeoutError,
        GenericError: ListUserGroupsTeamsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUserRoles: {
        InvalidParameterError: ListUserRolesError_2.InvalidParameterError,
        UnauthorizedError: ListUserRolesError_3.UnauthorizedError,
        ForbiddenError: ListUserRolesError_4.ForbiddenError,
        NotFoundError: ListUserRolesError_5.NotFoundError,
        InternalServerError: ListUserRolesError_6.InternalServerError,
        BadGatewayError: ListUserRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListUserRolesError_8.GatewayTimeoutError,
        GenericError: ListUserRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AcceptInvitation: {
        InvalidParameterError: AcceptInvitationError_2.InvalidParameterError,
        InvalidInvitationError: AcceptInvitationError_3.InvalidInvitationError,
        InvalidInvitationSecretError: AcceptInvitationError_4.InvalidInvitationSecretError,
        ExpiredInvitationError: AcceptInvitationError_5.ExpiredInvitationError,
        NotFoundError: AcceptInvitationError_6.NotFoundError,
        InternalServerError: AcceptInvitationError_7.InternalServerError,
        BadGatewayError: AcceptInvitationError_8.BadGatewayError,
        GatewayTimeoutError: AcceptInvitationError_9.GatewayTimeoutError,
        GenericError: AcceptInvitationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AcceptUserInvitation: {
        InvalidParameterError: AcceptUserInvitationError_2.InvalidParameterError,
        InvalidInvitationError: AcceptUserInvitationError_3.InvalidInvitationError,
        ExpiredInvitationError: AcceptUserInvitationError_4.ExpiredInvitationError,
        NotFoundError: AcceptUserInvitationError_5.NotFoundError,
        InternalServerError: AcceptUserInvitationError_6.InternalServerError,
        BadGatewayError: AcceptUserInvitationError_7.BadGatewayError,
        GatewayTimeoutError: AcceptUserInvitationError_8.GatewayTimeoutError,
        GenericError: AcceptUserInvitationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachGroupRole: {
        InvalidParameterError: AttachGroupRoleError_2.InvalidParameterError,
        UnauthorizedError: AttachGroupRoleError_3.UnauthorizedError,
        ForbiddenError: AttachGroupRoleError_4.ForbiddenError,
        NotFoundError: AttachGroupRoleError_5.NotFoundError,
        ConflictError: AttachGroupRoleError_6.ConflictError,
        InternalServerError: AttachGroupRoleError_7.InternalServerError,
        BadGatewayError: AttachGroupRoleError_8.BadGatewayError,
        GatewayTimeoutError: AttachGroupRoleError_9.GatewayTimeoutError,
        GenericError: AttachGroupRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachGroupUser: {
        InvalidParameterError: AttachGroupUserError_2.InvalidParameterError,
        UnauthorizedError: AttachGroupUserError_3.UnauthorizedError,
        ForbiddenError: AttachGroupUserError_4.ForbiddenError,
        NotFoundError: AttachGroupUserError_5.NotFoundError,
        ConflictError: AttachGroupUserError_6.ConflictError,
        InternalServerError: AttachGroupUserError_7.InternalServerError,
        BadGatewayError: AttachGroupUserError_8.BadGatewayError,
        GatewayTimeoutError: AttachGroupUserError_9.GatewayTimeoutError,
        GenericError: AttachGroupUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachRolePolicy: {
        InvalidParameterError: AttachRolePolicyError_2.InvalidParameterError,
        UnauthorizedError: AttachRolePolicyError_3.UnauthorizedError,
        ForbiddenError: AttachRolePolicyError_4.ForbiddenError,
        NotFoundError: AttachRolePolicyError_5.NotFoundError,
        ConflictError: AttachRolePolicyError_6.ConflictError,
        InternalServerError: AttachRolePolicyError_7.InternalServerError,
        BadGatewayError: AttachRolePolicyError_8.BadGatewayError,
        GatewayTimeoutError: AttachRolePolicyError_9.GatewayTimeoutError,
        GenericError: AttachRolePolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamGroup: {
        InvalidParameterError: AttachTeamGroupError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamGroupError_3.UnauthorizedError,
        ForbiddenError: AttachTeamGroupError_4.ForbiddenError,
        NotFoundError: AttachTeamGroupError_5.NotFoundError,
        ConflictError: AttachTeamGroupError_6.ConflictError,
        InternalServerError: AttachTeamGroupError_7.InternalServerError,
        BadGatewayError: AttachTeamGroupError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamGroupError_9.GatewayTimeoutError,
        GenericError: AttachTeamGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamGroupRole: {
        InvalidParameterError: AttachTeamGroupRoleError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamGroupRoleError_3.UnauthorizedError,
        ForbiddenError: AttachTeamGroupRoleError_4.ForbiddenError,
        NotFoundError: AttachTeamGroupRoleError_5.NotFoundError,
        ConflictError: AttachTeamGroupRoleError_6.ConflictError,
        InternalServerError: AttachTeamGroupRoleError_7.InternalServerError,
        BadGatewayError: AttachTeamGroupRoleError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamGroupRoleError_9.GatewayTimeoutError,
        GenericError: AttachTeamGroupRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamGroupUser: {
        InvalidParameterError: AttachTeamGroupUserError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamGroupUserError_3.UnauthorizedError,
        ForbiddenError: AttachTeamGroupUserError_4.ForbiddenError,
        NotFoundError: AttachTeamGroupUserError_5.NotFoundError,
        ConflictError: AttachTeamGroupUserError_6.ConflictError,
        InternalServerError: AttachTeamGroupUserError_7.InternalServerError,
        BadGatewayError: AttachTeamGroupUserError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamGroupUserError_9.GatewayTimeoutError,
        GenericError: AttachTeamGroupUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamRole: {
        InvalidParameterError: AttachTeamRoleError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamRoleError_3.UnauthorizedError,
        ForbiddenError: AttachTeamRoleError_4.ForbiddenError,
        NotFoundError: AttachTeamRoleError_5.NotFoundError,
        ConflictError: AttachTeamRoleError_6.ConflictError,
        InternalServerError: AttachTeamRoleError_7.InternalServerError,
        BadGatewayError: AttachTeamRoleError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamRoleError_9.GatewayTimeoutError,
        GenericError: AttachTeamRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamUser: {
        InvalidParameterError: AttachTeamUserError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamUserError_3.UnauthorizedError,
        ForbiddenError: AttachTeamUserError_4.ForbiddenError,
        NotFoundError: AttachTeamUserError_5.NotFoundError,
        ConflictError: AttachTeamUserError_6.ConflictError,
        InternalServerError: AttachTeamUserError_7.InternalServerError,
        BadGatewayError: AttachTeamUserError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamUserError_9.GatewayTimeoutError,
        GenericError: AttachTeamUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamUserRole: {
        InvalidParameterError: AttachTeamUserRoleError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamUserRoleError_3.UnauthorizedError,
        ForbiddenError: AttachTeamUserRoleError_4.ForbiddenError,
        NotFoundError: AttachTeamUserRoleError_5.NotFoundError,
        ConflictError: AttachTeamUserRoleError_6.ConflictError,
        InternalServerError: AttachTeamUserRoleError_7.InternalServerError,
        BadGatewayError: AttachTeamUserRoleError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamUserRoleError_9.GatewayTimeoutError,
        GenericError: AttachTeamUserRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachUserRole: {
        InvalidParameterError: AttachUserRoleError_2.InvalidParameterError,
        UnauthorizedError: AttachUserRoleError_3.UnauthorizedError,
        ForbiddenError: AttachUserRoleError_4.ForbiddenError,
        NotFoundError: AttachUserRoleError_5.NotFoundError,
        ConflictError: AttachUserRoleError_6.ConflictError,
        InternalServerError: AttachUserRoleError_7.InternalServerError,
        BadGatewayError: AttachUserRoleError_8.BadGatewayError,
        GatewayTimeoutError: AttachUserRoleError_9.GatewayTimeoutError,
        GenericError: AttachUserRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ChangePassword: {
        InvalidParameterError: ChangePasswordError_2.InvalidParameterError,
        InvalidSecretError: ChangePasswordError_3.InvalidSecretError,
        ExpiredSecretError: ChangePasswordError_4.ExpiredSecretError,
        NotFoundError: ChangePasswordError_5.NotFoundError,
        InternalServerError: ChangePasswordError_6.InternalServerError,
        BadGatewayError: ChangePasswordError_7.BadGatewayError,
        GatewayTimeoutError: ChangePasswordError_8.GatewayTimeoutError,
        GenericError: ChangePasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateAccount: {
        InvalidParameterError: CreateAccountError_2.InvalidParameterError,
        NotFoundError: CreateAccountError_3.NotFoundError,
        ConflictError: CreateAccountError_4.ConflictError,
        InternalServerError: CreateAccountError_5.InternalServerError,
        BadGatewayError: CreateAccountError_6.BadGatewayError,
        GatewayTimeoutError: CreateAccountError_7.GatewayTimeoutError,
        GenericError: CreateAccountError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateGroup: {
        InvalidParameterError: CreateGroupError_2.InvalidParameterError,
        UnauthorizedError: CreateGroupError_3.UnauthorizedError,
        ForbiddenError: CreateGroupError_4.ForbiddenError,
        ConflictError: CreateGroupError_5.ConflictError,
        InternalServerError: CreateGroupError_6.InternalServerError,
        BadGatewayError: CreateGroupError_7.BadGatewayError,
        GatewayTimeoutError: CreateGroupError_8.GatewayTimeoutError,
        GenericError: CreateGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateGroupSCIM: {
        InvalidParameterError: CreateGroupSCIMError_2.InvalidParameterError,
        UnauthorizedError: CreateGroupSCIMError_3.UnauthorizedError,
        ForbiddenError: CreateGroupSCIMError_4.ForbiddenError,
        NotFoundError: CreateGroupSCIMError_5.NotFoundError,
        ConflictError: CreateGroupSCIMError_6.ConflictError,
        InternalServerError: CreateGroupSCIMError_7.InternalServerError,
        BadGatewayError: CreateGroupSCIMError_8.BadGatewayError,
        GatewayTimeoutError: CreateGroupSCIMError_9.GatewayTimeoutError,
        GenericError: CreateGroupSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateMfaFactorSecret: {
        InvalidParameterError: CreateMfaFactorSecretError_2.InvalidParameterError,
        InvalidTokenError: CreateMfaFactorSecretError_3.InvalidTokenError,
        MfaFactorNotAllowedError: CreateMfaFactorSecretError_4.MfaFactorNotAllowedError,
        NotFoundError: CreateMfaFactorSecretError_5.NotFoundError,
        InternalServerError: CreateMfaFactorSecretError_6.InternalServerError,
        BadGatewayError: CreateMfaFactorSecretError_7.BadGatewayError,
        GatewayTimeoutError: CreateMfaFactorSecretError_8.GatewayTimeoutError,
        GenericError: CreateMfaFactorSecretError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreatePolicy: {
        InvalidParameterError: CreatePolicyError_2.InvalidParameterError,
        UnauthorizedError: CreatePolicyError_3.UnauthorizedError,
        ForbiddenError: CreatePolicyError_4.ForbiddenError,
        ConflictError: CreatePolicyError_5.ConflictError,
        InternalServerError: CreatePolicyError_6.InternalServerError,
        BadGatewayError: CreatePolicyError_7.BadGatewayError,
        GatewayTimeoutError: CreatePolicyError_8.GatewayTimeoutError,
        GenericError: CreatePolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateProvider: {
        InvalidParameterError: CreateProviderError_2.InvalidParameterError,
        UnauthorizedError: CreateProviderError_3.UnauthorizedError,
        InvalidCertificateError: CreateProviderError_4.InvalidCertificateError,
        ForbiddenError: CreateProviderError_5.ForbiddenError,
        ConflictError: CreateProviderError_6.ConflictError,
        InternalServerError: CreateProviderError_7.InternalServerError,
        BadGatewayError: CreateProviderError_8.BadGatewayError,
        GatewayTimeoutError: CreateProviderError_9.GatewayTimeoutError,
        GenericError: CreateProviderError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateRole: {
        InvalidParameterError: CreateRoleError_2.InvalidParameterError,
        UnauthorizedError: CreateRoleError_3.UnauthorizedError,
        ForbiddenError: CreateRoleError_4.ForbiddenError,
        ConflictError: CreateRoleError_5.ConflictError,
        InternalServerError: CreateRoleError_6.InternalServerError,
        BadGatewayError: CreateRoleError_7.BadGatewayError,
        GatewayTimeoutError: CreateRoleError_8.GatewayTimeoutError,
        GenericError: CreateRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateTeam: {
        InvalidParameterError: CreateTeamError_2.InvalidParameterError,
        UnauthorizedError: CreateTeamError_3.UnauthorizedError,
        ForbiddenError: CreateTeamError_4.ForbiddenError,
        ConflictError: CreateTeamError_5.ConflictError,
        InternalServerError: CreateTeamError_6.InternalServerError,
        BadGatewayError: CreateTeamError_7.BadGatewayError,
        GatewayTimeoutError: CreateTeamError_8.GatewayTimeoutError,
        GenericError: CreateTeamError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateToken: {
        InvalidParameterError: CreateTokenError_2.InvalidParameterError,
        InvalidCredentialsError: CreateTokenError_3.InvalidCredentialsError,
        PasswordRevokedError: CreateTokenError_4.PasswordRevokedError,
        IdentityDisabledError: CreateTokenError_5.IdentityDisabledError,
        InvalidAuthenticationModeError: CreateTokenError_6.InvalidAuthenticationModeError,
        MfaRequiredError: CreateTokenError_7.MfaRequiredError,
        NotFoundError: CreateTokenError_8.NotFoundError,
        ConflictError: CreateTokenError_9.ConflictError,
        InternalServerError: CreateTokenError_10.InternalServerError,
        BadGatewayError: CreateTokenError_11.BadGatewayError,
        GatewayTimeoutError: CreateTokenError_12.GatewayTimeoutError,
        GenericError: CreateTokenError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateUser: {
        InvalidParameterError: CreateUserError_2.InvalidParameterError,
        UnauthorizedError: CreateUserError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateUserError_4.InvalidSubscriptionError,
        ForbiddenError: CreateUserError_5.ForbiddenError,
        ConflictError: CreateUserError_6.ConflictError,
        InternalServerError: CreateUserError_7.InternalServerError,
        BadGatewayError: CreateUserError_8.BadGatewayError,
        GatewayTimeoutError: CreateUserError_9.GatewayTimeoutError,
        GenericError: CreateUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateUserMfaFactorSecret: {
        InvalidParameterError: CreateUserMfaFactorSecretError_2.InvalidParameterError,
        InvalidTokenError: CreateUserMfaFactorSecretError_3.InvalidTokenError,
        MfaFactorNotAllowedError: CreateUserMfaFactorSecretError_4.MfaFactorNotAllowedError,
        NotFoundError: CreateUserMfaFactorSecretError_5.NotFoundError,
        InternalServerError: CreateUserMfaFactorSecretError_6.InternalServerError,
        BadGatewayError: CreateUserMfaFactorSecretError_7.BadGatewayError,
        GatewayTimeoutError: CreateUserMfaFactorSecretError_8.GatewayTimeoutError,
        GenericError: CreateUserMfaFactorSecretError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateUserSCIM: {
        InvalidParameterError: CreateUserSCIMError_2.InvalidParameterError,
        UnauthorizedError: CreateUserSCIMError_3.UnauthorizedError,
        ForbiddenError: CreateUserSCIMError_4.ForbiddenError,
        NotFoundError: CreateUserSCIMError_5.NotFoundError,
        ConflictError: CreateUserSCIMError_6.ConflictError,
        InternalServerError: CreateUserSCIMError_7.InternalServerError,
        BadGatewayError: CreateUserSCIMError_8.BadGatewayError,
        GatewayTimeoutError: CreateUserSCIMError_9.GatewayTimeoutError,
        GenericError: CreateUserSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateUserToken: {
        InvalidParameterError: CreateUserTokenError_2.InvalidParameterError,
        UnauthorizedError: CreateUserTokenError_3.UnauthorizedError,
        IdentityDisabledError: CreateUserTokenError_4.IdentityDisabledError,
        ForbiddenError: CreateUserTokenError_5.ForbiddenError,
        NotFoundError: CreateUserTokenError_6.NotFoundError,
        ConflictError: CreateUserTokenError_7.ConflictError,
        InternalServerError: CreateUserTokenError_8.InternalServerError,
        BadGatewayError: CreateUserTokenError_9.BadGatewayError,
        GatewayTimeoutError: CreateUserTokenError_10.GatewayTimeoutError,
        GenericError: CreateUserTokenError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteAccount: {
        UnauthorizedError: DeleteAccountError_2.UnauthorizedError,
        ForbiddenError: DeleteAccountError_3.ForbiddenError,
        NotFoundError: DeleteAccountError_4.NotFoundError,
        InternalServerError: DeleteAccountError_5.InternalServerError,
        BadGatewayError: DeleteAccountError_6.BadGatewayError,
        GatewayTimeoutError: DeleteAccountError_7.GatewayTimeoutError,
        GenericError: DeleteAccountError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteGroup: {
        InvalidParameterError: DeleteGroupError_2.InvalidParameterError,
        UnauthorizedError: DeleteGroupError_3.UnauthorizedError,
        ForbiddenError: DeleteGroupError_4.ForbiddenError,
        NotFoundError: DeleteGroupError_5.NotFoundError,
        InternalServerError: DeleteGroupError_6.InternalServerError,
        BadGatewayError: DeleteGroupError_7.BadGatewayError,
        GatewayTimeoutError: DeleteGroupError_8.GatewayTimeoutError,
        GenericError: DeleteGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteGroupSCIM: {
        InvalidParameterError: DeleteGroupSCIMError_2.InvalidParameterError,
        UnauthorizedError: DeleteGroupSCIMError_3.UnauthorizedError,
        ForbiddenError: DeleteGroupSCIMError_4.ForbiddenError,
        NotFoundError: DeleteGroupSCIMError_5.NotFoundError,
        InternalServerError: DeleteGroupSCIMError_6.InternalServerError,
        BadGatewayError: DeleteGroupSCIMError_7.BadGatewayError,
        GatewayTimeoutError: DeleteGroupSCIMError_8.GatewayTimeoutError,
        GenericError: DeleteGroupSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeletePolicy: {
        InvalidParameterError: DeletePolicyError_2.InvalidParameterError,
        UnauthorizedError: DeletePolicyError_3.UnauthorizedError,
        ForbiddenError: DeletePolicyError_4.ForbiddenError,
        NotFoundError: DeletePolicyError_5.NotFoundError,
        InternalServerError: DeletePolicyError_6.InternalServerError,
        BadGatewayError: DeletePolicyError_7.BadGatewayError,
        GatewayTimeoutError: DeletePolicyError_8.GatewayTimeoutError,
        GenericError: DeletePolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteProvider: {
        InvalidParameterError: DeleteProviderError_2.InvalidParameterError,
        UnauthorizedError: DeleteProviderError_3.UnauthorizedError,
        ForbiddenError: DeleteProviderError_4.ForbiddenError,
        NotFoundError: DeleteProviderError_5.NotFoundError,
        InternalServerError: DeleteProviderError_6.InternalServerError,
        BadGatewayError: DeleteProviderError_7.BadGatewayError,
        GatewayTimeoutError: DeleteProviderError_8.GatewayTimeoutError,
        GenericError: DeleteProviderError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteRole: {
        InvalidParameterError: DeleteRoleError_2.InvalidParameterError,
        UnauthorizedError: DeleteRoleError_3.UnauthorizedError,
        ForbiddenError: DeleteRoleError_4.ForbiddenError,
        NotFoundError: DeleteRoleError_5.NotFoundError,
        InternalServerError: DeleteRoleError_6.InternalServerError,
        BadGatewayError: DeleteRoleError_7.BadGatewayError,
        GatewayTimeoutError: DeleteRoleError_8.GatewayTimeoutError,
        GenericError: DeleteRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteTeam: {
        InvalidParameterError: DeleteTeamError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamError_3.UnauthorizedError,
        ForbiddenError: DeleteTeamError_4.ForbiddenError,
        NotFoundError: DeleteTeamError_5.NotFoundError,
        InternalServerError: DeleteTeamError_6.InternalServerError,
        BadGatewayError: DeleteTeamError_7.BadGatewayError,
        GatewayTimeoutError: DeleteTeamError_8.GatewayTimeoutError,
        GenericError: DeleteTeamError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteUser: {
        InvalidParameterError: DeleteUserError_2.InvalidParameterError,
        UnauthorizedError: DeleteUserError_3.UnauthorizedError,
        ForbiddenError: DeleteUserError_4.ForbiddenError,
        NotFoundError: DeleteUserError_5.NotFoundError,
        InternalServerError: DeleteUserError_6.InternalServerError,
        BadGatewayError: DeleteUserError_7.BadGatewayError,
        GatewayTimeoutError: DeleteUserError_8.GatewayTimeoutError,
        GenericError: DeleteUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteUserSCIM: {
        InvalidParameterError: DeleteUserSCIMError_2.InvalidParameterError,
        UnauthorizedError: DeleteUserSCIMError_3.UnauthorizedError,
        ForbiddenError: DeleteUserSCIMError_4.ForbiddenError,
        NotFoundError: DeleteUserSCIMError_5.NotFoundError,
        InternalServerError: DeleteUserSCIMError_6.InternalServerError,
        BadGatewayError: DeleteUserSCIMError_7.BadGatewayError,
        GatewayTimeoutError: DeleteUserSCIMError_8.GatewayTimeoutError,
        GenericError: DeleteUserSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachGroupRole: {
        InvalidParameterError: DetachGroupRoleError_2.InvalidParameterError,
        UnauthorizedError: DetachGroupRoleError_3.UnauthorizedError,
        ForbiddenError: DetachGroupRoleError_4.ForbiddenError,
        NotFoundError: DetachGroupRoleError_5.NotFoundError,
        InternalServerError: DetachGroupRoleError_6.InternalServerError,
        BadGatewayError: DetachGroupRoleError_7.BadGatewayError,
        GatewayTimeoutError: DetachGroupRoleError_8.GatewayTimeoutError,
        GenericError: DetachGroupRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachGroupUser: {
        InvalidParameterError: DetachGroupUserError_2.InvalidParameterError,
        UnauthorizedError: DetachGroupUserError_3.UnauthorizedError,
        ForbiddenError: DetachGroupUserError_4.ForbiddenError,
        NotFoundError: DetachGroupUserError_5.NotFoundError,
        InternalServerError: DetachGroupUserError_6.InternalServerError,
        BadGatewayError: DetachGroupUserError_7.BadGatewayError,
        GatewayTimeoutError: DetachGroupUserError_8.GatewayTimeoutError,
        GenericError: DetachGroupUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachRolePolicy: {
        InvalidParameterError: DetachRolePolicyError_2.InvalidParameterError,
        UnauthorizedError: DetachRolePolicyError_3.UnauthorizedError,
        ForbiddenError: DetachRolePolicyError_4.ForbiddenError,
        NotFoundError: DetachRolePolicyError_5.NotFoundError,
        InternalServerError: DetachRolePolicyError_6.InternalServerError,
        BadGatewayError: DetachRolePolicyError_7.BadGatewayError,
        GatewayTimeoutError: DetachRolePolicyError_8.GatewayTimeoutError,
        GenericError: DetachRolePolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamGroup: {
        InvalidParameterError: DetachTeamGroupError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamGroupError_3.UnauthorizedError,
        ForbiddenError: DetachTeamGroupError_4.ForbiddenError,
        NotFoundError: DetachTeamGroupError_5.NotFoundError,
        InternalServerError: DetachTeamGroupError_6.InternalServerError,
        BadGatewayError: DetachTeamGroupError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamGroupError_8.GatewayTimeoutError,
        GenericError: DetachTeamGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamGroupRole: {
        InvalidParameterError: DetachTeamGroupRoleError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamGroupRoleError_3.UnauthorizedError,
        ForbiddenError: DetachTeamGroupRoleError_4.ForbiddenError,
        NotFoundError: DetachTeamGroupRoleError_5.NotFoundError,
        InternalServerError: DetachTeamGroupRoleError_6.InternalServerError,
        BadGatewayError: DetachTeamGroupRoleError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamGroupRoleError_8.GatewayTimeoutError,
        GenericError: DetachTeamGroupRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamGroupUser: {
        InvalidParameterError: DetachTeamGroupUserError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamGroupUserError_3.UnauthorizedError,
        ForbiddenError: DetachTeamGroupUserError_4.ForbiddenError,
        NotFoundError: DetachTeamGroupUserError_5.NotFoundError,
        InternalServerError: DetachTeamGroupUserError_6.InternalServerError,
        BadGatewayError: DetachTeamGroupUserError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamGroupUserError_8.GatewayTimeoutError,
        GenericError: DetachTeamGroupUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUserTeamsError: {
        InvalidParameterError: ListUserTeamsError_2.InvalidParameterError,
        UnauthorizedError: ListUserTeamsError_3.UnauthorizedError,
        ForbiddenError: ListUserTeamsError_4.ForbiddenError,
        NotFoundError: ListUserTeamsError_5.NotFoundError,
        InternalServerError: ListUserTeamsError_6.InternalServerError,
        BadGatewayError: ListUserTeamsError_7.BadGatewayError,
        GatewayTimeoutError: ListUserTeamsError_8.GatewayTimeoutError,
        GenericError: ListUserTeamsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUsersError: {
        UnauthorizedError: ListUsersError_2.UnauthorizedError,
        ForbiddenError: ListUsersError_3.ForbiddenError,
        InternalServerError: ListUsersError_4.InternalServerError,
        BadGatewayError: ListUsersError_5.BadGatewayError,
        GatewayTimeoutError: ListUsersError_6.GatewayTimeoutError,
        GenericError: ListUsersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUsersSCIMError: {
        InvalidParameterError: ListUsersSCIMError_2.InvalidParameterError,
        UnauthorizedError: ListUsersSCIMError_3.UnauthorizedError,
        ForbiddenError: ListUsersSCIMError_4.ForbiddenError,
        InternalServerError: ListUsersSCIMError_5.InternalServerError,
        BadGatewayError: ListUsersSCIMError_6.BadGatewayError,
        GatewayTimeoutError: ListUsersSCIMError_7.GatewayTimeoutError,
        GenericError: ListUsersSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    PatchGroupSCIMError: {
        InvalidParameterError: PatchGroupSCIMError_2.InvalidParameterError,
        UnauthorizedError: PatchGroupSCIMError_3.UnauthorizedError,
        ForbiddenError: PatchGroupSCIMError_4.ForbiddenError,
        NotFoundError: PatchGroupSCIMError_5.NotFoundError,
        InternalServerError: PatchGroupSCIMError_6.InternalServerError,
        BadGatewayError: PatchGroupSCIMError_7.BadGatewayError,
        GatewayTimeoutError: PatchGroupSCIMError_8.GatewayTimeoutError,
        GenericError: PatchGroupSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    PatchUserSCIMError: {
        InvalidParameterError: PatchUserSCIMError_2.InvalidParameterError,
        UnauthorizedError: PatchUserSCIMError_3.UnauthorizedError,
        ForbiddenError: PatchUserSCIMError_4.ForbiddenError,
        NotFoundError: PatchUserSCIMError_5.NotFoundError,
        ConflictError: PatchUserSCIMError_6.ConflictError,
        InternalServerError: PatchUserSCIMError_7.InternalServerError,
        BadGatewayError: PatchUserSCIMError_8.BadGatewayError,
        GatewayTimeoutError: PatchUserSCIMError_9.GatewayTimeoutError,
        GenericError: PatchUserSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    RenewTokenError: {
        InvalidParameterError: RenewTokenError_2.InvalidParameterError,
        PasswordRevokedError: RenewTokenError_3.PasswordRevokedError,
        IdentityDisabledError: RenewTokenError_4.IdentityDisabledError,
        NotAllowedError: RenewTokenError_5.NotAllowedError,
        InvalidRefreshTokenError: RenewTokenError_6.InvalidRefreshTokenError,
        NotFoundError: RenewTokenError_7.NotFoundError,
        InternalServerError: RenewTokenError_8.InternalServerError,
        BadGatewayError: RenewTokenError_9.BadGatewayError,
        GatewayTimeoutError: RenewTokenError_10.GatewayTimeoutError,
        GenericError: RenewTokenError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ResetMfaFactorError: {
        InvalidParameterError: ResetMfaFactorError_2.InvalidParameterError,
        UnauthorizedError: ResetMfaFactorError_3.UnauthorizedError,
        ForbiddenError: ResetMfaFactorError_4.ForbiddenError,
        NotFoundError: ResetMfaFactorError_5.NotFoundError,
        InternalServerError: ResetMfaFactorError_6.InternalServerError,
        BadGatewayError: ResetMfaFactorError_7.BadGatewayError,
        GatewayTimeoutError: ResetMfaFactorError_8.GatewayTimeoutError,
        GenericError: ResetMfaFactorError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ResetPasswordError: {
        InvalidParameterError: ResetPasswordError_2.InvalidParameterError,
        InvalidSecretError: ResetPasswordError_3.InvalidSecretError,
        ExpiredSecretError: ResetPasswordError_4.ExpiredSecretError,
        NotFoundError: ResetPasswordError_5.NotFoundError,
        InternalServerError: ResetPasswordError_6.InternalServerError,
        BadGatewayError: ResetPasswordError_7.BadGatewayError,
        GatewayTimeoutError: ResetPasswordError_8.GatewayTimeoutError,
        GenericError: ResetPasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ResetUserMfaFactorError: {
        InvalidParameterError: ResetUserMfaFactorError_2.InvalidParameterError,
        UnauthorizedError: ResetUserMfaFactorError_3.UnauthorizedError,
        ForbiddenError: ResetUserMfaFactorError_4.ForbiddenError,
        NotFoundError: ResetUserMfaFactorError_5.NotFoundError,
        InternalServerError: ResetUserMfaFactorError_6.InternalServerError,
        BadGatewayError: ResetUserMfaFactorError_7.BadGatewayError,
        GatewayTimeoutError: ResetUserMfaFactorError_8.GatewayTimeoutError,
        GenericError: ResetUserMfaFactorError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    RotateKeyError: {
        UnauthorizedError: RotateKeyError_2.UnauthorizedError,
        ForbiddenError: RotateKeyError_3.ForbiddenError,
        NotFoundError: RotateKeyError_4.NotFoundError,
        InternalServerError: RotateKeyError_5.InternalServerError,
        BadGatewayError: RotateKeyError_6.BadGatewayError,
        GatewayTimeoutError: RotateKeyError_7.GatewayTimeoutError,
        GenericError: RotateKeyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    RotateUserKeyError: {
        InvalidParameterError: RotateUserKeyError_2.InvalidParameterError,
        UnauthorizedError: RotateUserKeyError_3.UnauthorizedError,
        ForbiddenError: RotateUserKeyError_4.ForbiddenError,
        NotFoundError: RotateUserKeyError_5.NotFoundError,
        InternalServerError: RotateUserKeyError_6.InternalServerError,
        BadGatewayError: RotateUserKeyError_7.BadGatewayError,
        GatewayTimeoutError: RotateUserKeyError_8.GatewayTimeoutError,
        GenericError: RotateUserKeyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    SamlSignonError: {
        InvalidParameterError: SamlSignonError_2.InvalidParameterError,
        UserNotAllowedToSignonError: SamlSignonError_3.UserNotAllowedToSignonError,
        InvalidAudienceUriError: SamlSignonError_4.InvalidAudienceUriError,
        NotFoundError: SamlSignonError_5.NotFoundError,
        ConflictError: SamlSignonError_6.ConflictError,
        InternalServerError: SamlSignonError_7.InternalServerError,
        BadGatewayError: SamlSignonError_8.BadGatewayError,
        GatewayTimeoutError: SamlSignonError_9.GatewayTimeoutError,
        GenericError: SamlSignonError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    SendOtpError: {
        InvalidParameterError: SendOtpError_2.InvalidParameterError,
        InvalidTokenError: SendOtpError_3.InvalidTokenError,
        MfaFactorNotAllowedError: SendOtpError_4.MfaFactorNotAllowedError,
        ConflictError: SendOtpError_5.ConflictError,
        InternalServerError: SendOtpError_6.InternalServerError,
        BadGatewayError: SendOtpError_7.BadGatewayError,
        GatewayTimeoutError: SendOtpError_8.GatewayTimeoutError,
        GenericError: SendOtpError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    SsoSigninError: {
        InvalidParameterError: SsoSigninError_2.InvalidParameterError,
        NotFoundError: SsoSigninError_3.NotFoundError,
        ConflictError: SsoSigninError_4.ConflictError,
        InternalServerError: SsoSigninError_5.InternalServerError,
        BadGatewayError: SsoSigninError_6.BadGatewayError,
        GatewayTimeoutError: SsoSigninError_7.GatewayTimeoutError,
        GenericError: SsoSigninError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateAccountError: {
        InvalidParameterError: UpdateAccountError_2.InvalidParameterError,
        UnauthorizedError: UpdateAccountError_3.UnauthorizedError,
        ForbiddenError: UpdateAccountError_4.ForbiddenError,
        NotFoundError: UpdateAccountError_5.NotFoundError,
        ConflictError: UpdateAccountError_6.ConflictError,
        InternalServerError: UpdateAccountError_7.InternalServerError,
        BadGatewayError: UpdateAccountError_8.BadGatewayError,
        GatewayTimeoutError: UpdateAccountError_9.GatewayTimeoutError,
        GenericError: UpdateAccountError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateGroupError: {
        InvalidParameterError: UpdateGroupError_2.InvalidParameterError,
        UnauthorizedError: UpdateGroupError_3.UnauthorizedError,
        ForbiddenError: UpdateGroupError_4.ForbiddenError,
        NotFoundError: UpdateGroupError_5.NotFoundError,
        InternalServerError: UpdateGroupError_6.InternalServerError,
        BadGatewayError: UpdateGroupError_7.BadGatewayError,
        GatewayTimeoutError: UpdateGroupError_8.GatewayTimeoutError,
        GenericError: UpdateGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateGroupSCIMError: {
        InvalidParameterError: UpdateGroupSCIMError_2.InvalidParameterError,
        UnauthorizedError: UpdateGroupSCIMError_3.UnauthorizedError,
        ForbiddenError: UpdateGroupSCIMError_4.ForbiddenError,
        NotFoundError: UpdateGroupSCIMError_5.NotFoundError,
        InternalServerError: UpdateGroupSCIMError_6.InternalServerError,
        BadGatewayError: UpdateGroupSCIMError_7.BadGatewayError,
        GatewayTimeoutError: UpdateGroupSCIMError_8.GatewayTimeoutError,
        GenericError: UpdateGroupSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateManagedPolicyError: {
        InvalidParameterError: UpdateManagedPolicyError_2.InvalidParameterError,
        UnauthorizedError: UpdateManagedPolicyError_3.UnauthorizedError,
        ForbiddenError: UpdateManagedPolicyError_4.ForbiddenError,
        NotFoundError: UpdateManagedPolicyError_5.NotFoundError,
        InternalServerError: UpdateManagedPolicyError_6.InternalServerError,
        BadGatewayError: UpdateManagedPolicyError_7.BadGatewayError,
        GatewayTimeoutError: UpdateManagedPolicyError_8.GatewayTimeoutError,
        GenericError: UpdateManagedPolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateMfaError: {
        InvalidParameterError: UpdateMfaError_2.InvalidParameterError,
        UnauthorizedError: UpdateMfaError_3.UnauthorizedError,
        MfaFactorNotVerifiedError: UpdateMfaError_4.MfaFactorNotVerifiedError,
        ForbiddenError: UpdateMfaError_5.ForbiddenError,
        NotFoundError: UpdateMfaError_6.NotFoundError,
        InternalServerError: UpdateMfaError_7.InternalServerError,
        BadGatewayError: UpdateMfaError_8.BadGatewayError,
        GatewayTimeoutError: UpdateMfaError_9.GatewayTimeoutError,
        GenericError: UpdateMfaError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdatePasswordError: {
        InvalidParameterError: UpdatePasswordError_2.InvalidParameterError,
        UnauthorizedError: UpdatePasswordError_3.UnauthorizedError,
        InvalidAuthenticationModeError: UpdatePasswordError_4.InvalidAuthenticationModeError,
        PasswordDoesNotMatchError: UpdatePasswordError_5.PasswordDoesNotMatchError,
        ForbiddenError: UpdatePasswordError_6.ForbiddenError,
        NotFoundError: UpdatePasswordError_7.NotFoundError,
        InternalServerError: UpdatePasswordError_8.InternalServerError,
        BadGatewayError: UpdatePasswordError_9.BadGatewayError,
        GatewayTimeoutError: UpdatePasswordError_10.GatewayTimeoutError,
        GenericError: UpdatePasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdatePolicyError: {
        InvalidParameterError: UpdatePolicyError_2.InvalidParameterError,
        UnauthorizedError: UpdatePolicyError_3.UnauthorizedError,
        ForbiddenError: UpdatePolicyError_4.ForbiddenError,
        NotFoundError: UpdatePolicyError_5.NotFoundError,
        InternalServerError: UpdatePolicyError_6.InternalServerError,
        BadGatewayError: UpdatePolicyError_7.BadGatewayError,
        GatewayTimeoutError: UpdatePolicyError_8.GatewayTimeoutError,
        GenericError: UpdatePolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateProviderError: {
        InvalidParameterError: UpdateProviderError_2.InvalidParameterError,
        UnauthorizedError: UpdateProviderError_3.UnauthorizedError,
        InvalidCertificateError: UpdateProviderError_4.InvalidCertificateError,
        ForbiddenError: UpdateProviderError_5.ForbiddenError,
        NotFoundError: UpdateProviderError_6.NotFoundError,
        InternalServerError: UpdateProviderError_7.InternalServerError,
        BadGatewayError: UpdateProviderError_8.BadGatewayError,
        GatewayTimeoutError: UpdateProviderError_9.GatewayTimeoutError,
        GenericError: UpdateProviderError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateRoleError: {
        InvalidParameterError: UpdateRoleError_2.InvalidParameterError,
        UnauthorizedError: UpdateRoleError_3.UnauthorizedError,
        ForbiddenError: UpdateRoleError_4.ForbiddenError,
        NotFoundError: UpdateRoleError_5.NotFoundError,
        InternalServerError: UpdateRoleError_6.InternalServerError,
        BadGatewayError: UpdateRoleError_7.BadGatewayError,
        GatewayTimeoutError: UpdateRoleError_8.GatewayTimeoutError,
        GenericError: UpdateRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateSecurityError: {
        InvalidParameterError: UpdateSecurityError_2.InvalidParameterError,
        UnauthorizedError: UpdateSecurityError_3.UnauthorizedError,
        ForbiddenError: UpdateSecurityError_4.ForbiddenError,
        NotFoundError: UpdateSecurityError_5.NotFoundError,
        InternalServerError: UpdateSecurityError_6.InternalServerError,
        BadGatewayError: UpdateSecurityError_7.BadGatewayError,
        GatewayTimeoutError: UpdateSecurityError_8.GatewayTimeoutError,
        GenericError: UpdateSecurityError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateTeamError: {
        InvalidParameterError: UpdateTeamError_2.InvalidParameterError,
        UnauthorizedError: UpdateTeamError_3.UnauthorizedError,
        ForbiddenError: UpdateTeamError_4.ForbiddenError,
        NotFoundError: UpdateTeamError_5.NotFoundError,
        InternalServerError: UpdateTeamError_6.InternalServerError,
        BadGatewayError: UpdateTeamError_7.BadGatewayError,
        GatewayTimeoutError: UpdateTeamError_8.GatewayTimeoutError,
        GenericError: UpdateTeamError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateTeamGroupError: {
        InvalidParameterError: UpdateTeamGroupError_2.InvalidParameterError,
        UnauthorizedError: UpdateTeamGroupError_3.UnauthorizedError,
        ForbiddenError: UpdateTeamGroupError_4.ForbiddenError,
        NotFoundError: UpdateTeamGroupError_5.NotFoundError,
        InternalServerError: UpdateTeamGroupError_6.InternalServerError,
        BadGatewayError: UpdateTeamGroupError_7.BadGatewayError,
        GatewayTimeoutError: UpdateTeamGroupError_8.GatewayTimeoutError,
        GenericError: UpdateTeamGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateTeamUserError: {
        InvalidParameterError: UpdateTeamUserError_2.InvalidParameterError,
        UnauthorizedError: UpdateTeamUserError_3.UnauthorizedError,
        InvalidSubscriptionError: UpdateTeamUserError_4.InvalidSubscriptionError,
        ForbiddenToUpdateProvisionedUserError: UpdateTeamUserError_5.ForbiddenToUpdateProvisionedUserError,
        ForbiddenError: UpdateTeamUserError_6.ForbiddenError,
        NotFoundError: UpdateTeamUserError_7.NotFoundError,
        ConflictError: UpdateTeamUserError_8.ConflictError,
        InternalServerError: UpdateTeamUserError_9.InternalServerError,
        BadGatewayError: UpdateTeamUserError_10.BadGatewayError,
        GatewayTimeoutError: UpdateTeamUserError_11.GatewayTimeoutError,
        GenericError: UpdateTeamUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateUserError: {
        InvalidParameterError: UpdateUserError_2.InvalidParameterError,
        UnauthorizedError: UpdateUserError_3.UnauthorizedError,
        ForbiddenToUpdateProvisionedUserError: UpdateUserError_4.ForbiddenToUpdateProvisionedUserError,
        InvalidSubscriptionError: UpdateUserError_5.InvalidSubscriptionError,
        ForbiddenError: UpdateUserError_6.ForbiddenError,
        NotFoundError: UpdateUserError_7.NotFoundError,
        InternalServerError: UpdateUserError_8.InternalServerError,
        BadGatewayError: UpdateUserError_9.BadGatewayError,
        GatewayTimeoutError: UpdateUserError_10.GatewayTimeoutError,
        GenericError: UpdateUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateUserMfaError: {
        InvalidParameterError: UpdateUserMfaError_2.InvalidParameterError,
        UnauthorizedError: UpdateUserMfaError_3.UnauthorizedError,
        MfaFactorNotVerifiedError: UpdateUserMfaError_4.MfaFactorNotVerifiedError,
        ForbiddenError: UpdateUserMfaError_5.ForbiddenError,
        NotFoundError: UpdateUserMfaError_6.NotFoundError,
        InternalServerError: UpdateUserMfaError_7.InternalServerError,
        BadGatewayError: UpdateUserMfaError_8.BadGatewayError,
        GatewayTimeoutError: UpdateUserMfaError_9.GatewayTimeoutError,
        GenericError: UpdateUserMfaError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    UpdateUserSCIMError: {
        InvalidParameterError: UpdateUserSCIMError_2.InvalidParameterError,
        UnauthorizedError: UpdateUserSCIMError_3.UnauthorizedError,
        ForbiddenError: UpdateUserSCIMError_4.ForbiddenError,
        NotFoundError: UpdateUserSCIMError_5.NotFoundError,
        ConflictError: UpdateUserSCIMError_6.ConflictError,
        InternalServerError: UpdateUserSCIMError_7.InternalServerError,
        BadGatewayError: UpdateUserSCIMError_8.BadGatewayError,
        GatewayTimeoutError: UpdateUserSCIMError_9.GatewayTimeoutError,
        GenericError: UpdateUserSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    VerifyMfaFactorError: {
        InvalidParameterError: VerifyMfaFactorError_2.InvalidParameterError,
        InvalidTokenError: VerifyMfaFactorError_3.InvalidTokenError,
        InvalidOtpError: VerifyMfaFactorError_4.InvalidOtpError,
        MfaFactorNotAllowedError: VerifyMfaFactorError_5.MfaFactorNotAllowedError,
        NotFoundError: VerifyMfaFactorError_6.NotFoundError,
        InternalServerError: VerifyMfaFactorError_7.InternalServerError,
        BadGatewayError: VerifyMfaFactorError_8.BadGatewayError,
        GatewayTimeoutError: VerifyMfaFactorError_9.GatewayTimeoutError,
        GenericError: VerifyMfaFactorError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    VerifyOtpError: {
        InvalidParameterError: VerifyOtpError_2.InvalidParameterError,
        InvalidOtpError: VerifyOtpError_3.InvalidOtpError,
        InvalidTokenError: VerifyOtpError_4.InvalidTokenError,
        TokenExpiredError: VerifyOtpError_5.TokenExpiredError,
        NotFoundError: VerifyOtpError_6.NotFoundError,
        InternalServerError: VerifyOtpError_7.InternalServerError,
        BadGatewayError: VerifyOtpError_8.BadGatewayError,
        GatewayTimeoutError: VerifyOtpError_9.GatewayTimeoutError,
        GenericError: VerifyOtpError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    VerifyUserMfaFactorError: {
        InvalidParameterError: VerifyUserMfaFactorError_2.InvalidParameterError,
        InvalidTokenError: VerifyUserMfaFactorError_3.InvalidTokenError,
        InvalidOtpError: VerifyUserMfaFactorError_4.InvalidOtpError,
        MfaFactorNotAllowedError: VerifyUserMfaFactorError_5.MfaFactorNotAllowedError,
        NotFoundError: VerifyUserMfaFactorError_6.NotFoundError,
        InternalServerError: VerifyUserMfaFactorError_7.InternalServerError,
        BadGatewayError: VerifyUserMfaFactorError_8.BadGatewayError,
        GatewayTimeoutError: VerifyUserMfaFactorError_9.GatewayTimeoutError,
        GenericError: VerifyUserMfaFactorError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamRoleError: {
        InvalidParameterError: DetachTeamRoleError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamRoleError_3.UnauthorizedError,
        ForbiddenError: DetachTeamRoleError_4.ForbiddenError,
        NotFoundError: DetachTeamRoleError_5.NotFoundError,
        InternalServerError: DetachTeamRoleError_6.InternalServerError,
        BadGatewayError: DetachTeamRoleError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamRoleError_8.GatewayTimeoutError,
        GenericError: DetachTeamRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamUserError: {
        InvalidParameterError: DetachTeamUserError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamUserError_3.UnauthorizedError,
        ForbiddenError: DetachTeamUserError_4.ForbiddenError,
        NotFoundError: DetachTeamUserError_5.NotFoundError,
        InternalServerError: DetachTeamUserError_6.InternalServerError,
        BadGatewayError: DetachTeamUserError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamUserError_8.GatewayTimeoutError,
        GenericError: DetachTeamUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamUserRoleError: {
        InvalidParameterError: DetachTeamUserRoleError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamUserRoleError_3.UnauthorizedError,
        ForbiddenError: DetachTeamUserRoleError_4.ForbiddenError,
        NotFoundError: DetachTeamUserRoleError_5.NotFoundError,
        InternalServerError: DetachTeamUserRoleError_6.InternalServerError,
        BadGatewayError: DetachTeamUserRoleError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamUserRoleError_8.GatewayTimeoutError,
        GenericError: DetachTeamUserRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachUserRoleError: {
        InvalidParameterError: DetachUserRoleError_2.InvalidParameterError,
        UnauthorizedError: DetachUserRoleError_3.UnauthorizedError,
        ForbiddenError: DetachUserRoleError_4.ForbiddenError,
        NotFoundError: DetachUserRoleError_5.NotFoundError,
        InternalServerError: DetachUserRoleError_6.InternalServerError,
        BadGatewayError: DetachUserRoleError_7.BadGatewayError,
        GatewayTimeoutError: DetachUserRoleError_8.GatewayTimeoutError,
        GenericError: DetachUserRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ForgotPasswordError: {
        InvalidParameterError: ForgotPasswordError_2.InvalidParameterError,
        InvalidIdentityUsernameError: ForgotPasswordError_3.InvalidIdentityUsernameError,
        NotFoundError: ForgotPasswordError_4.NotFoundError,
        InternalServerError: ForgotPasswordError_5.InternalServerError,
        BadGatewayError: ForgotPasswordError_6.BadGatewayError,
        GatewayTimeoutError: ForgotPasswordError_7.GatewayTimeoutError,
        GenericError: ForgotPasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetAccountError: {
        UnauthorizedError: GetAccountError_2.UnauthorizedError,
        ForbiddenError: GetAccountError_3.ForbiddenError,
        NotFoundError: GetAccountError_4.NotFoundError,
        InternalServerError: GetAccountError_5.InternalServerError,
        BadGatewayError: GetAccountError_6.BadGatewayError,
        GatewayTimeoutError: GetAccountError_7.GatewayTimeoutError,
        GenericError: GetAccountError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetGroupError: {
        InvalidParameterError: GetGroupError_2.InvalidParameterError,
        UnauthorizedError: GetGroupError_3.UnauthorizedError,
        ForbiddenError: GetGroupError_4.ForbiddenError,
        NotFoundError: GetGroupError_5.NotFoundError,
        InternalServerError: GetGroupError_6.InternalServerError,
        BadGatewayError: GetGroupError_7.BadGatewayError,
        GatewayTimeoutError: GetGroupError_8.GatewayTimeoutError,
        GenericError: GetGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetGroupSCIMError: {
        InvalidParameterError: GetGroupSCIMError_2.InvalidParameterError,
        UnauthorizedError: GetGroupSCIMError_3.UnauthorizedError,
        ForbiddenError: GetGroupSCIMError_4.ForbiddenError,
        NotFoundError: GetGroupSCIMError_5.NotFoundError,
        InternalServerError: GetGroupSCIMError_6.InternalServerError,
        BadGatewayError: GetGroupSCIMError_7.BadGatewayError,
        GatewayTimeoutError: GetGroupSCIMError_8.GatewayTimeoutError,
        GenericError: GetGroupSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetMfaError: {
        UnauthorizedError: GetMfaError_2.UnauthorizedError,
        ForbiddenError: GetMfaError_3.ForbiddenError,
        NotFoundError: GetMfaError_4.NotFoundError,
        InternalServerError: GetMfaError_5.InternalServerError,
        BadGatewayError: GetMfaError_6.BadGatewayError,
        GatewayTimeoutError: GetMfaError_7.GatewayTimeoutError,
        GenericError: GetMfaError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetPolicyError: {
        InvalidParameterError: GetPolicyError_2.InvalidParameterError,
        UnauthorizedError: GetPolicyError_3.UnauthorizedError,
        ForbiddenError: GetPolicyError_4.ForbiddenError,
        NotFoundError: GetPolicyError_5.NotFoundError,
        InternalServerError: GetPolicyError_6.InternalServerError,
        BadGatewayError: GetPolicyError_7.BadGatewayError,
        GatewayTimeoutError: GetPolicyError_8.GatewayTimeoutError,
        GenericError: GetPolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetProviderError: {
        InvalidParameterError: GetProviderError_2.InvalidParameterError,
        UnauthorizedError: GetProviderError_3.UnauthorizedError,
        ForbiddenError: GetProviderError_4.ForbiddenError,
        NotFoundError: GetProviderError_5.NotFoundError,
        InternalServerError: GetProviderError_6.InternalServerError,
        BadGatewayError: GetProviderError_7.BadGatewayError,
        GatewayTimeoutError: GetProviderError_8.GatewayTimeoutError,
        GenericError: GetProviderError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetResourceTypesError: {
        UnauthorizedError: GetResourceTypesError_2.UnauthorizedError,
        ForbiddenError: GetResourceTypesError_3.ForbiddenError,
        InternalServerError: GetResourceTypesError_4.InternalServerError,
        BadGatewayError: GetResourceTypesError_5.BadGatewayError,
        GatewayTimeoutError: GetResourceTypesError_6.GatewayTimeoutError,
        GenericError: GetResourceTypesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetRoleError: {
        InvalidParameterError: GetRoleError_2.InvalidParameterError,
        UnauthorizedError: GetRoleError_3.UnauthorizedError,
        ForbiddenError: GetRoleError_4.ForbiddenError,
        NotFoundError: GetRoleError_5.NotFoundError,
        InternalServerError: GetRoleError_6.InternalServerError,
        BadGatewayError: GetRoleError_7.BadGatewayError,
        GatewayTimeoutError: GetRoleError_8.GatewayTimeoutError,
        GenericError: GetRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetSchemasError: {
        UnauthorizedError: GetSchemasError_2.UnauthorizedError,
        ForbiddenError: GetSchemasError_3.ForbiddenError,
        InternalServerError: GetSchemasError_4.InternalServerError,
        BadGatewayError: GetSchemasError_5.BadGatewayError,
        GatewayTimeoutError: GetSchemasError_6.GatewayTimeoutError,
        GenericError: GetSchemasError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetSecurityError: {
        UnauthorizedError: GetSecurityError_2.UnauthorizedError,
        ForbiddenError: GetSecurityError_3.ForbiddenError,
        NotFoundError: GetSecurityError_4.NotFoundError,
        InternalServerError: GetSecurityError_5.InternalServerError,
        BadGatewayError: GetSecurityError_6.BadGatewayError,
        GatewayTimeoutError: GetSecurityError_7.GatewayTimeoutError,
        GenericError: GetSecurityError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetServiceProviderConfigError: {
        UnauthorizedError: GetServiceProviderConfigError_2.UnauthorizedError,
        ForbiddenError: GetServiceProviderConfigError_3.ForbiddenError,
        InternalServerError: GetServiceProviderConfigError_4.InternalServerError,
        BadGatewayError: GetServiceProviderConfigError_5.BadGatewayError,
        GatewayTimeoutError: GetServiceProviderConfigError_6.GatewayTimeoutError,
        GenericError: GetServiceProviderConfigError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetSigninConfigurationError: {
        InvalidParameterError: GetSigninConfigurationError_2.InvalidParameterError,
        NotFoundError: GetSigninConfigurationError_3.NotFoundError,
        InternalServerError: GetSigninConfigurationError_4.InternalServerError,
        BadGatewayError: GetSigninConfigurationError_5.BadGatewayError,
        GatewayTimeoutError: GetSigninConfigurationError_6.GatewayTimeoutError,
        GenericError: GetSigninConfigurationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetTeamError: {
        InvalidParameterError: GetTeamError_2.InvalidParameterError,
        UnauthorizedError: GetTeamError_3.UnauthorizedError,
        ForbiddenError: GetTeamError_4.ForbiddenError,
        NotFoundError: GetTeamError_5.NotFoundError,
        InternalServerError: GetTeamError_6.InternalServerError,
        BadGatewayError: GetTeamError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamError_8.GatewayTimeoutError,
        GenericError: GetTeamError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetTeamGroupError: {
        InvalidParameterError: GetTeamGroupError_2.InvalidParameterError,
        UnauthorizedError: GetTeamGroupError_3.UnauthorizedError,
        ForbiddenError: GetTeamGroupError_4.ForbiddenError,
        NotFoundError: GetTeamGroupError_5.NotFoundError,
        InternalServerError: GetTeamGroupError_6.InternalServerError,
        BadGatewayError: GetTeamGroupError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamGroupError_8.GatewayTimeoutError,
        GenericError: GetTeamGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetTeamUserError: {
        InvalidParameterError: GetTeamUserError_2.InvalidParameterError,
        UnauthorizedError: GetTeamUserError_3.UnauthorizedError,
        ForbiddenError: GetTeamUserError_4.ForbiddenError,
        NotFoundError: GetTeamUserError_5.NotFoundError,
        InternalServerError: GetTeamUserError_6.InternalServerError,
        BadGatewayError: GetTeamUserError_7.BadGatewayError,
        GatewayTimeoutError: GetTeamUserError_8.GatewayTimeoutError,
        GenericError: GetTeamUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetUserError: {
        InvalidParameterError: GetUserError_2.InvalidParameterError,
        UnauthorizedError: GetUserError_3.UnauthorizedError,
        ForbiddenError: GetUserError_4.ForbiddenError,
        NotFoundError: GetUserError_5.NotFoundError,
        InternalServerError: GetUserError_6.InternalServerError,
        BadGatewayError: GetUserError_7.BadGatewayError,
        GatewayTimeoutError: GetUserError_8.GatewayTimeoutError,
        GenericError: GetUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetUserMfaError: {
        InvalidParameterError: GetUserMfaError_2.InvalidParameterError,
        UnauthorizedError: GetUserMfaError_3.UnauthorizedError,
        ForbiddenError: GetUserMfaError_4.ForbiddenError,
        NotFoundError: GetUserMfaError_5.NotFoundError,
        InternalServerError: GetUserMfaError_6.InternalServerError,
        BadGatewayError: GetUserMfaError_7.BadGatewayError,
        GatewayTimeoutError: GetUserMfaError_8.GatewayTimeoutError,
        GenericError: GetUserMfaError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    GetUserSCIMError: {
        InvalidParameterError: GetUserSCIMError_2.InvalidParameterError,
        UnauthorizedError: GetUserSCIMError_3.UnauthorizedError,
        ForbiddenError: GetUserSCIMError_4.ForbiddenError,
        NotFoundError: GetUserSCIMError_5.NotFoundError,
        InternalServerError: GetUserSCIMError_6.InternalServerError,
        BadGatewayError: GetUserSCIMError_7.BadGatewayError,
        GatewayTimeoutError: GetUserSCIMError_8.GatewayTimeoutError,
        GenericError: GetUserSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    InviteTeamUserError: {
        InvalidParameterError: InviteTeamUserError_2.InvalidParameterError,
        UnauthorizedError: InviteTeamUserError_3.UnauthorizedError,
        ForbiddenError: InviteTeamUserError_4.ForbiddenError,
        NotFoundError: InviteTeamUserError_5.NotFoundError,
        InternalServerError: InviteTeamUserError_6.InternalServerError,
        BadGatewayError: InviteTeamUserError_7.BadGatewayError,
        GatewayTimeoutError: InviteTeamUserError_8.GatewayTimeoutError,
        GenericError: InviteTeamUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    InviteUserError: {
        InvalidParameterError: InviteUserError_2.InvalidParameterError,
        UnauthorizedError: InviteUserError_3.UnauthorizedError,
        InvalidEmailError: InviteUserError_4.InvalidEmailError,
        ForbiddenError: InviteUserError_5.ForbiddenError,
        NotFoundError: InviteUserError_6.NotFoundError,
        InternalServerError: InviteUserError_7.InternalServerError,
        BadGatewayError: InviteUserError_8.BadGatewayError,
        GatewayTimeoutError: InviteUserError_9.GatewayTimeoutError,
        GenericError: InviteUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListGroupRolesError: {
        InvalidParameterError: ListGroupRolesError_2.InvalidParameterError,
        UnauthorizedError: ListGroupRolesError_3.UnauthorizedError,
        ForbiddenError: ListGroupRolesError_4.ForbiddenError,
        NotFoundError: ListGroupRolesError_5.NotFoundError,
        InternalServerError: ListGroupRolesError_6.InternalServerError,
        BadGatewayError: ListGroupRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListGroupRolesError_8.GatewayTimeoutError,
        GenericError: ListGroupRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListGroupTeamsError: {
        InvalidParameterError: ListGroupTeamsError_2.InvalidParameterError,
        UnauthorizedError: ListGroupTeamsError_3.UnauthorizedError,
        ForbiddenError: ListGroupTeamsError_4.ForbiddenError,
        NotFoundError: ListGroupTeamsError_5.NotFoundError,
        InternalServerError: ListGroupTeamsError_6.InternalServerError,
        BadGatewayError: ListGroupTeamsError_7.BadGatewayError,
        GatewayTimeoutError: ListGroupTeamsError_8.GatewayTimeoutError,
        GenericError: ListGroupTeamsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListGroupUsersError: {
        InvalidParameterError: ListGroupUsersError_2.InvalidParameterError,
        UnauthorizedError: ListGroupUsersError_3.UnauthorizedError,
        ForbiddenError: ListGroupUsersError_4.ForbiddenError,
        NotFoundError: ListGroupUsersError_5.NotFoundError,
        InternalServerError: ListGroupUsersError_6.InternalServerError,
        BadGatewayError: ListGroupUsersError_7.BadGatewayError,
        GatewayTimeoutError: ListGroupUsersError_8.GatewayTimeoutError,
        GenericError: ListGroupUsersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListGroupsError: {
        UnauthorizedError: ListGroupsError_2.UnauthorizedError,
        ForbiddenError: ListGroupsError_3.ForbiddenError,
        NotFoundError: ListGroupsError_4.NotFoundError,
        InternalServerError: ListGroupsError_5.InternalServerError,
        BadGatewayError: ListGroupsError_6.BadGatewayError,
        GatewayTimeoutError: ListGroupsError_7.GatewayTimeoutError,
        GenericError: ListGroupsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListGroupsSCIMError: {
        InvalidParameterError: ListGroupsSCIMError_2.InvalidParameterError,
        UnauthorizedError: ListGroupsSCIMError_3.UnauthorizedError,
        ForbiddenError: ListGroupsSCIMError_4.ForbiddenError,
        InternalServerError: ListGroupsSCIMError_5.InternalServerError,
        BadGatewayError: ListGroupsSCIMError_6.BadGatewayError,
        GatewayTimeoutError: ListGroupsSCIMError_7.GatewayTimeoutError,
        GenericError: ListGroupsSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListPoliciesError: {
        UnauthorizedError: ListPoliciesError_2.UnauthorizedError,
        ForbiddenError: ListPoliciesError_3.ForbiddenError,
        InternalServerError: ListPoliciesError_4.InternalServerError,
        BadGatewayError: ListPoliciesError_5.BadGatewayError,
        GatewayTimeoutError: ListPoliciesError_6.GatewayTimeoutError,
        GenericError: ListPoliciesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListProvidersError: {
        UnauthorizedError: ListProvidersError_2.UnauthorizedError,
        ForbiddenError: ListProvidersError_3.ForbiddenError,
        InternalServerError: ListProvidersError_4.InternalServerError,
        BadGatewayError: ListProvidersError_5.BadGatewayError,
        GatewayTimeoutError: ListProvidersError_6.GatewayTimeoutError,
        GenericError: ListProvidersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListRolesError: {
        UnauthorizedError: ListRolesError_2.UnauthorizedError,
        ForbiddenError: ListRolesError_3.ForbiddenError,
        InternalServerError: ListRolesError_4.InternalServerError,
        BadGatewayError: ListRolesError_5.BadGatewayError,
        GatewayTimeoutError: ListRolesError_6.GatewayTimeoutError,
        GenericError: ListRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamGroupRolesError: {
        InvalidParameterError: ListTeamGroupRolesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamGroupRolesError_3.UnauthorizedError,
        ForbiddenError: ListTeamGroupRolesError_4.ForbiddenError,
        NotFoundError: ListTeamGroupRolesError_5.NotFoundError,
        InternalServerError: ListTeamGroupRolesError_6.InternalServerError,
        BadGatewayError: ListTeamGroupRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamGroupRolesError_8.GatewayTimeoutError,
        GenericError: ListTeamGroupRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamGroupUsersError: {
        InvalidParameterError: ListTeamGroupUsersError_2.InvalidParameterError,
        UnauthorizedError: ListTeamGroupUsersError_3.UnauthorizedError,
        ForbiddenError: ListTeamGroupUsersError_4.ForbiddenError,
        NotFoundError: ListTeamGroupUsersError_5.NotFoundError,
        InternalServerError: ListTeamGroupUsersError_6.InternalServerError,
        BadGatewayError: ListTeamGroupUsersError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamGroupUsersError_8.GatewayTimeoutError,
        GenericError: ListTeamGroupUsersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamGroupsError: {
        InvalidParameterError: ListTeamGroupsError_2.InvalidParameterError,
        UnauthorizedError: ListTeamGroupsError_3.UnauthorizedError,
        ForbiddenError: ListTeamGroupsError_4.ForbiddenError,
        NotFoundError: ListTeamGroupsError_5.NotFoundError,
        InternalServerError: ListTeamGroupsError_6.InternalServerError,
        BadGatewayError: ListTeamGroupsError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamGroupsError_8.GatewayTimeoutError,
        GenericError: ListTeamGroupsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamRolesError: {
        InvalidParameterError: ListTeamRolesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamRolesError_3.UnauthorizedError,
        ForbiddenError: ListTeamRolesError_4.ForbiddenError,
        NotFoundError: ListTeamRolesError_5.NotFoundError,
        InternalServerError: ListTeamRolesError_6.InternalServerError,
        BadGatewayError: ListTeamRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamRolesError_8.GatewayTimeoutError,
        GenericError: ListTeamRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamUserGroupsError: {
        InvalidParameterError: ListTeamUserGroupsError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserGroupsError_3.UnauthorizedError,
        ForbiddenError: ListTeamUserGroupsError_4.ForbiddenError,
        NotFoundError: ListTeamUserGroupsError_5.NotFoundError,
        InternalServerError: ListTeamUserGroupsError_6.InternalServerError,
        BadGatewayError: ListTeamUserGroupsError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamUserGroupsError_8.GatewayTimeoutError,
        GenericError: ListTeamUserGroupsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamUserRolesError: {
        InvalidParameterError: ListTeamUserRolesError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUserRolesError_3.UnauthorizedError,
        ForbiddenError: ListTeamUserRolesError_4.ForbiddenError,
        NotFoundError: ListTeamUserRolesError_5.NotFoundError,
        InternalServerError: ListTeamUserRolesError_6.InternalServerError,
        BadGatewayError: ListTeamUserRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamUserRolesError_8.GatewayTimeoutError,
        GenericError: ListTeamUserRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamUsersError: {
        InvalidParameterError: ListTeamUsersError_2.InvalidParameterError,
        UnauthorizedError: ListTeamUsersError_3.UnauthorizedError,
        ForbiddenError: ListTeamUsersError_4.ForbiddenError,
        NotFoundError: ListTeamUsersError_5.NotFoundError,
        InternalServerError: ListTeamUsersError_6.InternalServerError,
        BadGatewayError: ListTeamUsersError_7.BadGatewayError,
        GatewayTimeoutError: ListTeamUsersError_8.GatewayTimeoutError,
        GenericError: ListTeamUsersError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListTeamsError: {
        UnauthorizedError: ListTeamsError_2.UnauthorizedError,
        ForbiddenError: ListTeamsError_3.ForbiddenError,
        InternalServerError: ListTeamsError_4.InternalServerError,
        BadGatewayError: ListTeamsError_5.BadGatewayError,
        GatewayTimeoutError: ListTeamsError_6.GatewayTimeoutError,
        GenericError: ListTeamsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUserGroupsError: {
        InvalidParameterError: ListUserGroupsError_2.InvalidParameterError,
        UnauthorizedError: ListUserGroupsError_3.UnauthorizedError,
        ForbiddenError: ListUserGroupsError_4.ForbiddenError,
        NotFoundError: ListUserGroupsError_5.NotFoundError,
        InternalServerError: ListUserGroupsError_6.InternalServerError,
        BadGatewayError: ListUserGroupsError_7.BadGatewayError,
        GatewayTimeoutError: ListUserGroupsError_8.GatewayTimeoutError,
        GenericError: ListUserGroupsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUserGroupsRolesError: {
        InvalidParameterError: ListUserGroupsRolesError_2.InvalidParameterError,
        UnauthorizedError: ListUserGroupsRolesError_3.UnauthorizedError,
        ForbiddenError: ListUserGroupsRolesError_4.ForbiddenError,
        NotFoundError: ListUserGroupsRolesError_5.NotFoundError,
        InternalServerError: ListUserGroupsRolesError_6.InternalServerError,
        BadGatewayError: ListUserGroupsRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListUserGroupsRolesError_8.GatewayTimeoutError,
        GenericError: ListUserGroupsRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUserGroupsTeamsError: {
        InvalidParameterError: ListUserGroupsTeamsError_2.InvalidParameterError,
        UnauthorizedError: ListUserGroupsTeamsError_3.UnauthorizedError,
        ForbiddenError: ListUserGroupsTeamsError_4.ForbiddenError,
        NotFoundError: ListUserGroupsTeamsError_5.NotFoundError,
        InternalServerError: ListUserGroupsTeamsError_6.InternalServerError,
        BadGatewayError: ListUserGroupsTeamsError_7.BadGatewayError,
        GatewayTimeoutError: ListUserGroupsTeamsError_8.GatewayTimeoutError,
        GenericError: ListUserGroupsTeamsError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ListUserRolesError: {
        InvalidParameterError: ListUserRolesError_2.InvalidParameterError,
        UnauthorizedError: ListUserRolesError_3.UnauthorizedError,
        ForbiddenError: ListUserRolesError_4.ForbiddenError,
        NotFoundError: ListUserRolesError_5.NotFoundError,
        InternalServerError: ListUserRolesError_6.InternalServerError,
        BadGatewayError: ListUserRolesError_7.BadGatewayError,
        GatewayTimeoutError: ListUserRolesError_8.GatewayTimeoutError,
        GenericError: ListUserRolesError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AcceptInvitationError: {
        InvalidParameterError: AcceptInvitationError_2.InvalidParameterError,
        InvalidInvitationError: AcceptInvitationError_3.InvalidInvitationError,
        InvalidInvitationSecretError: AcceptInvitationError_4.InvalidInvitationSecretError,
        ExpiredInvitationError: AcceptInvitationError_5.ExpiredInvitationError,
        NotFoundError: AcceptInvitationError_6.NotFoundError,
        InternalServerError: AcceptInvitationError_7.InternalServerError,
        BadGatewayError: AcceptInvitationError_8.BadGatewayError,
        GatewayTimeoutError: AcceptInvitationError_9.GatewayTimeoutError,
        GenericError: AcceptInvitationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AcceptUserInvitationError: {
        InvalidParameterError: AcceptUserInvitationError_2.InvalidParameterError,
        InvalidInvitationError: AcceptUserInvitationError_3.InvalidInvitationError,
        ExpiredInvitationError: AcceptUserInvitationError_4.ExpiredInvitationError,
        NotFoundError: AcceptUserInvitationError_5.NotFoundError,
        InternalServerError: AcceptUserInvitationError_6.InternalServerError,
        BadGatewayError: AcceptUserInvitationError_7.BadGatewayError,
        GatewayTimeoutError: AcceptUserInvitationError_8.GatewayTimeoutError,
        GenericError: AcceptUserInvitationError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachGroupRoleError: {
        InvalidParameterError: AttachGroupRoleError_2.InvalidParameterError,
        UnauthorizedError: AttachGroupRoleError_3.UnauthorizedError,
        ForbiddenError: AttachGroupRoleError_4.ForbiddenError,
        NotFoundError: AttachGroupRoleError_5.NotFoundError,
        ConflictError: AttachGroupRoleError_6.ConflictError,
        InternalServerError: AttachGroupRoleError_7.InternalServerError,
        BadGatewayError: AttachGroupRoleError_8.BadGatewayError,
        GatewayTimeoutError: AttachGroupRoleError_9.GatewayTimeoutError,
        GenericError: AttachGroupRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachGroupUserError: {
        InvalidParameterError: AttachGroupUserError_2.InvalidParameterError,
        UnauthorizedError: AttachGroupUserError_3.UnauthorizedError,
        ForbiddenError: AttachGroupUserError_4.ForbiddenError,
        NotFoundError: AttachGroupUserError_5.NotFoundError,
        ConflictError: AttachGroupUserError_6.ConflictError,
        InternalServerError: AttachGroupUserError_7.InternalServerError,
        BadGatewayError: AttachGroupUserError_8.BadGatewayError,
        GatewayTimeoutError: AttachGroupUserError_9.GatewayTimeoutError,
        GenericError: AttachGroupUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachRolePolicyError: {
        InvalidParameterError: AttachRolePolicyError_2.InvalidParameterError,
        UnauthorizedError: AttachRolePolicyError_3.UnauthorizedError,
        ForbiddenError: AttachRolePolicyError_4.ForbiddenError,
        NotFoundError: AttachRolePolicyError_5.NotFoundError,
        ConflictError: AttachRolePolicyError_6.ConflictError,
        InternalServerError: AttachRolePolicyError_7.InternalServerError,
        BadGatewayError: AttachRolePolicyError_8.BadGatewayError,
        GatewayTimeoutError: AttachRolePolicyError_9.GatewayTimeoutError,
        GenericError: AttachRolePolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamGroupError: {
        InvalidParameterError: AttachTeamGroupError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamGroupError_3.UnauthorizedError,
        ForbiddenError: AttachTeamGroupError_4.ForbiddenError,
        NotFoundError: AttachTeamGroupError_5.NotFoundError,
        ConflictError: AttachTeamGroupError_6.ConflictError,
        InternalServerError: AttachTeamGroupError_7.InternalServerError,
        BadGatewayError: AttachTeamGroupError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamGroupError_9.GatewayTimeoutError,
        GenericError: AttachTeamGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamGroupRoleError: {
        InvalidParameterError: AttachTeamGroupRoleError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamGroupRoleError_3.UnauthorizedError,
        ForbiddenError: AttachTeamGroupRoleError_4.ForbiddenError,
        NotFoundError: AttachTeamGroupRoleError_5.NotFoundError,
        ConflictError: AttachTeamGroupRoleError_6.ConflictError,
        InternalServerError: AttachTeamGroupRoleError_7.InternalServerError,
        BadGatewayError: AttachTeamGroupRoleError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamGroupRoleError_9.GatewayTimeoutError,
        GenericError: AttachTeamGroupRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamGroupUserError: {
        InvalidParameterError: AttachTeamGroupUserError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamGroupUserError_3.UnauthorizedError,
        ForbiddenError: AttachTeamGroupUserError_4.ForbiddenError,
        NotFoundError: AttachTeamGroupUserError_5.NotFoundError,
        ConflictError: AttachTeamGroupUserError_6.ConflictError,
        InternalServerError: AttachTeamGroupUserError_7.InternalServerError,
        BadGatewayError: AttachTeamGroupUserError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamGroupUserError_9.GatewayTimeoutError,
        GenericError: AttachTeamGroupUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamRoleError: {
        InvalidParameterError: AttachTeamRoleError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamRoleError_3.UnauthorizedError,
        ForbiddenError: AttachTeamRoleError_4.ForbiddenError,
        NotFoundError: AttachTeamRoleError_5.NotFoundError,
        ConflictError: AttachTeamRoleError_6.ConflictError,
        InternalServerError: AttachTeamRoleError_7.InternalServerError,
        BadGatewayError: AttachTeamRoleError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamRoleError_9.GatewayTimeoutError,
        GenericError: AttachTeamRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamUserError: {
        InvalidParameterError: AttachTeamUserError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamUserError_3.UnauthorizedError,
        ForbiddenError: AttachTeamUserError_4.ForbiddenError,
        NotFoundError: AttachTeamUserError_5.NotFoundError,
        ConflictError: AttachTeamUserError_6.ConflictError,
        InternalServerError: AttachTeamUserError_7.InternalServerError,
        BadGatewayError: AttachTeamUserError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamUserError_9.GatewayTimeoutError,
        GenericError: AttachTeamUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachTeamUserRoleError: {
        InvalidParameterError: AttachTeamUserRoleError_2.InvalidParameterError,
        UnauthorizedError: AttachTeamUserRoleError_3.UnauthorizedError,
        ForbiddenError: AttachTeamUserRoleError_4.ForbiddenError,
        NotFoundError: AttachTeamUserRoleError_5.NotFoundError,
        ConflictError: AttachTeamUserRoleError_6.ConflictError,
        InternalServerError: AttachTeamUserRoleError_7.InternalServerError,
        BadGatewayError: AttachTeamUserRoleError_8.BadGatewayError,
        GatewayTimeoutError: AttachTeamUserRoleError_9.GatewayTimeoutError,
        GenericError: AttachTeamUserRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    AttachUserRoleError: {
        InvalidParameterError: AttachUserRoleError_2.InvalidParameterError,
        UnauthorizedError: AttachUserRoleError_3.UnauthorizedError,
        ForbiddenError: AttachUserRoleError_4.ForbiddenError,
        NotFoundError: AttachUserRoleError_5.NotFoundError,
        ConflictError: AttachUserRoleError_6.ConflictError,
        InternalServerError: AttachUserRoleError_7.InternalServerError,
        BadGatewayError: AttachUserRoleError_8.BadGatewayError,
        GatewayTimeoutError: AttachUserRoleError_9.GatewayTimeoutError,
        GenericError: AttachUserRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    ChangePasswordError: {
        InvalidParameterError: ChangePasswordError_2.InvalidParameterError,
        InvalidSecretError: ChangePasswordError_3.InvalidSecretError,
        ExpiredSecretError: ChangePasswordError_4.ExpiredSecretError,
        NotFoundError: ChangePasswordError_5.NotFoundError,
        InternalServerError: ChangePasswordError_6.InternalServerError,
        BadGatewayError: ChangePasswordError_7.BadGatewayError,
        GatewayTimeoutError: ChangePasswordError_8.GatewayTimeoutError,
        GenericError: ChangePasswordError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateAccountError: {
        InvalidParameterError: CreateAccountError_2.InvalidParameterError,
        NotFoundError: CreateAccountError_3.NotFoundError,
        ConflictError: CreateAccountError_4.ConflictError,
        InternalServerError: CreateAccountError_5.InternalServerError,
        BadGatewayError: CreateAccountError_6.BadGatewayError,
        GatewayTimeoutError: CreateAccountError_7.GatewayTimeoutError,
        GenericError: CreateAccountError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateGroupError: {
        InvalidParameterError: CreateGroupError_2.InvalidParameterError,
        UnauthorizedError: CreateGroupError_3.UnauthorizedError,
        ForbiddenError: CreateGroupError_4.ForbiddenError,
        ConflictError: CreateGroupError_5.ConflictError,
        InternalServerError: CreateGroupError_6.InternalServerError,
        BadGatewayError: CreateGroupError_7.BadGatewayError,
        GatewayTimeoutError: CreateGroupError_8.GatewayTimeoutError,
        GenericError: CreateGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateGroupSCIMError: {
        InvalidParameterError: CreateGroupSCIMError_2.InvalidParameterError,
        UnauthorizedError: CreateGroupSCIMError_3.UnauthorizedError,
        ForbiddenError: CreateGroupSCIMError_4.ForbiddenError,
        NotFoundError: CreateGroupSCIMError_5.NotFoundError,
        ConflictError: CreateGroupSCIMError_6.ConflictError,
        InternalServerError: CreateGroupSCIMError_7.InternalServerError,
        BadGatewayError: CreateGroupSCIMError_8.BadGatewayError,
        GatewayTimeoutError: CreateGroupSCIMError_9.GatewayTimeoutError,
        GenericError: CreateGroupSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateMfaFactorSecretError: {
        InvalidParameterError: CreateMfaFactorSecretError_2.InvalidParameterError,
        InvalidTokenError: CreateMfaFactorSecretError_3.InvalidTokenError,
        MfaFactorNotAllowedError: CreateMfaFactorSecretError_4.MfaFactorNotAllowedError,
        NotFoundError: CreateMfaFactorSecretError_5.NotFoundError,
        InternalServerError: CreateMfaFactorSecretError_6.InternalServerError,
        BadGatewayError: CreateMfaFactorSecretError_7.BadGatewayError,
        GatewayTimeoutError: CreateMfaFactorSecretError_8.GatewayTimeoutError,
        GenericError: CreateMfaFactorSecretError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreatePolicyError: {
        InvalidParameterError: CreatePolicyError_2.InvalidParameterError,
        UnauthorizedError: CreatePolicyError_3.UnauthorizedError,
        ForbiddenError: CreatePolicyError_4.ForbiddenError,
        ConflictError: CreatePolicyError_5.ConflictError,
        InternalServerError: CreatePolicyError_6.InternalServerError,
        BadGatewayError: CreatePolicyError_7.BadGatewayError,
        GatewayTimeoutError: CreatePolicyError_8.GatewayTimeoutError,
        GenericError: CreatePolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateProviderError: {
        InvalidParameterError: CreateProviderError_2.InvalidParameterError,
        UnauthorizedError: CreateProviderError_3.UnauthorizedError,
        InvalidCertificateError: CreateProviderError_4.InvalidCertificateError,
        ForbiddenError: CreateProviderError_5.ForbiddenError,
        ConflictError: CreateProviderError_6.ConflictError,
        InternalServerError: CreateProviderError_7.InternalServerError,
        BadGatewayError: CreateProviderError_8.BadGatewayError,
        GatewayTimeoutError: CreateProviderError_9.GatewayTimeoutError,
        GenericError: CreateProviderError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateRoleError: {
        InvalidParameterError: CreateRoleError_2.InvalidParameterError,
        UnauthorizedError: CreateRoleError_3.UnauthorizedError,
        ForbiddenError: CreateRoleError_4.ForbiddenError,
        ConflictError: CreateRoleError_5.ConflictError,
        InternalServerError: CreateRoleError_6.InternalServerError,
        BadGatewayError: CreateRoleError_7.BadGatewayError,
        GatewayTimeoutError: CreateRoleError_8.GatewayTimeoutError,
        GenericError: CreateRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateTeamError: {
        InvalidParameterError: CreateTeamError_2.InvalidParameterError,
        UnauthorizedError: CreateTeamError_3.UnauthorizedError,
        ForbiddenError: CreateTeamError_4.ForbiddenError,
        ConflictError: CreateTeamError_5.ConflictError,
        InternalServerError: CreateTeamError_6.InternalServerError,
        BadGatewayError: CreateTeamError_7.BadGatewayError,
        GatewayTimeoutError: CreateTeamError_8.GatewayTimeoutError,
        GenericError: CreateTeamError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateTokenError: {
        InvalidParameterError: CreateTokenError_2.InvalidParameterError,
        InvalidCredentialsError: CreateTokenError_3.InvalidCredentialsError,
        PasswordRevokedError: CreateTokenError_4.PasswordRevokedError,
        IdentityDisabledError: CreateTokenError_5.IdentityDisabledError,
        InvalidAuthenticationModeError: CreateTokenError_6.InvalidAuthenticationModeError,
        MfaRequiredError: CreateTokenError_7.MfaRequiredError,
        NotFoundError: CreateTokenError_8.NotFoundError,
        ConflictError: CreateTokenError_9.ConflictError,
        InternalServerError: CreateTokenError_10.InternalServerError,
        BadGatewayError: CreateTokenError_11.BadGatewayError,
        GatewayTimeoutError: CreateTokenError_12.GatewayTimeoutError,
        GenericError: CreateTokenError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateUserError: {
        InvalidParameterError: CreateUserError_2.InvalidParameterError,
        UnauthorizedError: CreateUserError_3.UnauthorizedError,
        InvalidSubscriptionError: CreateUserError_4.InvalidSubscriptionError,
        ForbiddenError: CreateUserError_5.ForbiddenError,
        ConflictError: CreateUserError_6.ConflictError,
        InternalServerError: CreateUserError_7.InternalServerError,
        BadGatewayError: CreateUserError_8.BadGatewayError,
        GatewayTimeoutError: CreateUserError_9.GatewayTimeoutError,
        GenericError: CreateUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateUserMfaFactorSecretError: {
        InvalidParameterError: CreateUserMfaFactorSecretError_2.InvalidParameterError,
        InvalidTokenError: CreateUserMfaFactorSecretError_3.InvalidTokenError,
        MfaFactorNotAllowedError: CreateUserMfaFactorSecretError_4.MfaFactorNotAllowedError,
        NotFoundError: CreateUserMfaFactorSecretError_5.NotFoundError,
        InternalServerError: CreateUserMfaFactorSecretError_6.InternalServerError,
        BadGatewayError: CreateUserMfaFactorSecretError_7.BadGatewayError,
        GatewayTimeoutError: CreateUserMfaFactorSecretError_8.GatewayTimeoutError,
        GenericError: CreateUserMfaFactorSecretError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateUserSCIMError: {
        InvalidParameterError: CreateUserSCIMError_2.InvalidParameterError,
        UnauthorizedError: CreateUserSCIMError_3.UnauthorizedError,
        ForbiddenError: CreateUserSCIMError_4.ForbiddenError,
        NotFoundError: CreateUserSCIMError_5.NotFoundError,
        ConflictError: CreateUserSCIMError_6.ConflictError,
        InternalServerError: CreateUserSCIMError_7.InternalServerError,
        BadGatewayError: CreateUserSCIMError_8.BadGatewayError,
        GatewayTimeoutError: CreateUserSCIMError_9.GatewayTimeoutError,
        GenericError: CreateUserSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    CreateUserTokenError: {
        InvalidParameterError: CreateUserTokenError_2.InvalidParameterError,
        UnauthorizedError: CreateUserTokenError_3.UnauthorizedError,
        IdentityDisabledError: CreateUserTokenError_4.IdentityDisabledError,
        ForbiddenError: CreateUserTokenError_5.ForbiddenError,
        NotFoundError: CreateUserTokenError_6.NotFoundError,
        ConflictError: CreateUserTokenError_7.ConflictError,
        InternalServerError: CreateUserTokenError_8.InternalServerError,
        BadGatewayError: CreateUserTokenError_9.BadGatewayError,
        GatewayTimeoutError: CreateUserTokenError_10.GatewayTimeoutError,
        GenericError: CreateUserTokenError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteAccountError: {
        UnauthorizedError: DeleteAccountError_2.UnauthorizedError,
        ForbiddenError: DeleteAccountError_3.ForbiddenError,
        NotFoundError: DeleteAccountError_4.NotFoundError,
        InternalServerError: DeleteAccountError_5.InternalServerError,
        BadGatewayError: DeleteAccountError_6.BadGatewayError,
        GatewayTimeoutError: DeleteAccountError_7.GatewayTimeoutError,
        GenericError: DeleteAccountError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteGroupError: {
        InvalidParameterError: DeleteGroupError_2.InvalidParameterError,
        UnauthorizedError: DeleteGroupError_3.UnauthorizedError,
        ForbiddenError: DeleteGroupError_4.ForbiddenError,
        NotFoundError: DeleteGroupError_5.NotFoundError,
        InternalServerError: DeleteGroupError_6.InternalServerError,
        BadGatewayError: DeleteGroupError_7.BadGatewayError,
        GatewayTimeoutError: DeleteGroupError_8.GatewayTimeoutError,
        GenericError: DeleteGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteGroupSCIMError: {
        InvalidParameterError: DeleteGroupSCIMError_2.InvalidParameterError,
        UnauthorizedError: DeleteGroupSCIMError_3.UnauthorizedError,
        ForbiddenError: DeleteGroupSCIMError_4.ForbiddenError,
        NotFoundError: DeleteGroupSCIMError_5.NotFoundError,
        InternalServerError: DeleteGroupSCIMError_6.InternalServerError,
        BadGatewayError: DeleteGroupSCIMError_7.BadGatewayError,
        GatewayTimeoutError: DeleteGroupSCIMError_8.GatewayTimeoutError,
        GenericError: DeleteGroupSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeletePolicyError: {
        InvalidParameterError: DeletePolicyError_2.InvalidParameterError,
        UnauthorizedError: DeletePolicyError_3.UnauthorizedError,
        ForbiddenError: DeletePolicyError_4.ForbiddenError,
        NotFoundError: DeletePolicyError_5.NotFoundError,
        InternalServerError: DeletePolicyError_6.InternalServerError,
        BadGatewayError: DeletePolicyError_7.BadGatewayError,
        GatewayTimeoutError: DeletePolicyError_8.GatewayTimeoutError,
        GenericError: DeletePolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteProviderError: {
        InvalidParameterError: DeleteProviderError_2.InvalidParameterError,
        UnauthorizedError: DeleteProviderError_3.UnauthorizedError,
        ForbiddenError: DeleteProviderError_4.ForbiddenError,
        NotFoundError: DeleteProviderError_5.NotFoundError,
        InternalServerError: DeleteProviderError_6.InternalServerError,
        BadGatewayError: DeleteProviderError_7.BadGatewayError,
        GatewayTimeoutError: DeleteProviderError_8.GatewayTimeoutError,
        GenericError: DeleteProviderError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteRoleError: {
        InvalidParameterError: DeleteRoleError_2.InvalidParameterError,
        UnauthorizedError: DeleteRoleError_3.UnauthorizedError,
        ForbiddenError: DeleteRoleError_4.ForbiddenError,
        NotFoundError: DeleteRoleError_5.NotFoundError,
        InternalServerError: DeleteRoleError_6.InternalServerError,
        BadGatewayError: DeleteRoleError_7.BadGatewayError,
        GatewayTimeoutError: DeleteRoleError_8.GatewayTimeoutError,
        GenericError: DeleteRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteTeamError: {
        InvalidParameterError: DeleteTeamError_2.InvalidParameterError,
        UnauthorizedError: DeleteTeamError_3.UnauthorizedError,
        ForbiddenError: DeleteTeamError_4.ForbiddenError,
        NotFoundError: DeleteTeamError_5.NotFoundError,
        InternalServerError: DeleteTeamError_6.InternalServerError,
        BadGatewayError: DeleteTeamError_7.BadGatewayError,
        GatewayTimeoutError: DeleteTeamError_8.GatewayTimeoutError,
        GenericError: DeleteTeamError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteUserError: {
        InvalidParameterError: DeleteUserError_2.InvalidParameterError,
        UnauthorizedError: DeleteUserError_3.UnauthorizedError,
        ForbiddenError: DeleteUserError_4.ForbiddenError,
        NotFoundError: DeleteUserError_5.NotFoundError,
        InternalServerError: DeleteUserError_6.InternalServerError,
        BadGatewayError: DeleteUserError_7.BadGatewayError,
        GatewayTimeoutError: DeleteUserError_8.GatewayTimeoutError,
        GenericError: DeleteUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DeleteUserSCIMError: {
        InvalidParameterError: DeleteUserSCIMError_2.InvalidParameterError,
        UnauthorizedError: DeleteUserSCIMError_3.UnauthorizedError,
        ForbiddenError: DeleteUserSCIMError_4.ForbiddenError,
        NotFoundError: DeleteUserSCIMError_5.NotFoundError,
        InternalServerError: DeleteUserSCIMError_6.InternalServerError,
        BadGatewayError: DeleteUserSCIMError_7.BadGatewayError,
        GatewayTimeoutError: DeleteUserSCIMError_8.GatewayTimeoutError,
        GenericError: DeleteUserSCIMError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachGroupRoleError: {
        InvalidParameterError: DetachGroupRoleError_2.InvalidParameterError,
        UnauthorizedError: DetachGroupRoleError_3.UnauthorizedError,
        ForbiddenError: DetachGroupRoleError_4.ForbiddenError,
        NotFoundError: DetachGroupRoleError_5.NotFoundError,
        InternalServerError: DetachGroupRoleError_6.InternalServerError,
        BadGatewayError: DetachGroupRoleError_7.BadGatewayError,
        GatewayTimeoutError: DetachGroupRoleError_8.GatewayTimeoutError,
        GenericError: DetachGroupRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachGroupUserError: {
        InvalidParameterError: DetachGroupUserError_2.InvalidParameterError,
        UnauthorizedError: DetachGroupUserError_3.UnauthorizedError,
        ForbiddenError: DetachGroupUserError_4.ForbiddenError,
        NotFoundError: DetachGroupUserError_5.NotFoundError,
        InternalServerError: DetachGroupUserError_6.InternalServerError,
        BadGatewayError: DetachGroupUserError_7.BadGatewayError,
        GatewayTimeoutError: DetachGroupUserError_8.GatewayTimeoutError,
        GenericError: DetachGroupUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachRolePolicyError: {
        InvalidParameterError: DetachRolePolicyError_2.InvalidParameterError,
        UnauthorizedError: DetachRolePolicyError_3.UnauthorizedError,
        ForbiddenError: DetachRolePolicyError_4.ForbiddenError,
        NotFoundError: DetachRolePolicyError_5.NotFoundError,
        InternalServerError: DetachRolePolicyError_6.InternalServerError,
        BadGatewayError: DetachRolePolicyError_7.BadGatewayError,
        GatewayTimeoutError: DetachRolePolicyError_8.GatewayTimeoutError,
        GenericError: DetachRolePolicyError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamGroupError: {
        InvalidParameterError: DetachTeamGroupError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamGroupError_3.UnauthorizedError,
        ForbiddenError: DetachTeamGroupError_4.ForbiddenError,
        NotFoundError: DetachTeamGroupError_5.NotFoundError,
        InternalServerError: DetachTeamGroupError_6.InternalServerError,
        BadGatewayError: DetachTeamGroupError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamGroupError_8.GatewayTimeoutError,
        GenericError: DetachTeamGroupError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamGroupRoleError: {
        InvalidParameterError: DetachTeamGroupRoleError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamGroupRoleError_3.UnauthorizedError,
        ForbiddenError: DetachTeamGroupRoleError_4.ForbiddenError,
        NotFoundError: DetachTeamGroupRoleError_5.NotFoundError,
        InternalServerError: DetachTeamGroupRoleError_6.InternalServerError,
        BadGatewayError: DetachTeamGroupRoleError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamGroupRoleError_8.GatewayTimeoutError,
        GenericError: DetachTeamGroupRoleError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    DetachTeamGroupUserError: {
        InvalidParameterError: DetachTeamGroupUserError_2.InvalidParameterError,
        UnauthorizedError: DetachTeamGroupUserError_3.UnauthorizedError,
        ForbiddenError: DetachTeamGroupUserError_4.ForbiddenError,
        NotFoundError: DetachTeamGroupUserError_5.NotFoundError,
        InternalServerError: DetachTeamGroupUserError_6.InternalServerError,
        BadGatewayError: DetachTeamGroupUserError_7.BadGatewayError,
        GatewayTimeoutError: DetachTeamGroupUserError_8.GatewayTimeoutError,
        GenericError: DetachTeamGroupUserError_1.GenericError,
        UnknownError: core_1.UnknownError,
        NetworkError: core_1.NetworkError,
        ConnectionAbortedError: core_1.ConnectionAbortedError,
        TimeoutError: core_1.TimeoutError,
    },
    InvalidSdkConfigurationError: core_1.InvalidSdkConfigurationError,
    InvalidRegionOrHostError: core_1.InvalidRegionOrHostError,
    InvalidRegionError: core_1.InvalidRegionError,
    InvalidHostError: core_1.InvalidHostError,
};
